import { Add, CalendarToday, Delete, Edit, InfoOutlined, KeyboardArrowDown, Save } from '@mui/icons-material';
import LinkedDocumentLink, {
    firstLinked,
    getEstimateDetailUrl,
    getInvoiceDetailUrl,
    getInvoiceSyncFromWorkOrderUrl,
    getWorkOrderDetailUrl,
} from '../../../common/LinkedDocumentLink';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    Popper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from '@mui/material';
import axios from 'axios';
import debounce from 'lodash/debounce';
import React, { lazy, Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../App.css';

import { useTheme } from '@emotion/react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';

import { Controller, useForm, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Context, REQUIRED_RED } from '../../../App';
import { MuiMultiFieldWithFocus } from '../../../config/MaterialUIConstants';
import AdditionalDetailsAccrodian from '../../../common/Accordians/AdditionalDetailsAccrodian';
import OpenDraftExistsDialog from '../../../common/OpenDraftExistsDialog';
import useOpenDraftAlert from '../../../hook/useOpenDraftAlert';
import PaymentDetailsAccrodian from '../../../common/Accordians/PaymentDetailsAccrodian';
import CommonDialog from '../../../common/CommonDialog';
import { getReapprovalDiff } from '../../../utility/helpers/workOrderReapproval';
import TermsAndWarrantyModal from '../../../common/TermsAndWarranty/TermsAndWarrantyModal';
import { normalizeTermId, resolveTermsOptionId, termIsInvoiceDefault, toTermsFormValue } from '../../../common/TermsAndWarranty/TermsAndWarrantySelect';
import useScreenWidth from '../../../common/useScreenWidth';
import { FormatNumberForKm } from '../../../components/FormatNumber/FormatNumber';
import { SHOP_CREATED, SHOP_IMPORTED, USER_TYPES } from '../../../config/dataService/constants';
import { discountProgramApi } from '../../../redux/Account/Pricing/action';
import { getDefaultShopPrice } from '../../../redux/Account/ShopDetails/action';
import { updateUserMembershipDetail } from '../../../redux/Account/action';
import { clearCustomerDetail, customerDetail as customerDetailApi, importedCustomerDetail } from '../../../redux/Customer/action';
import { estimateData } from '../../../redux/Estimate/action';
// Removed Redux inventory imports - now using TanStack Query hooks
import { addAdvisorApi, CustomersListBasedOnType, getAdvisorListApi, getInvoiceFeesListApi } from '../../../redux/Invoice/action';
import { checkServiceExistance } from '../../../redux/SavedServices/action';
import { vehicleDetails } from '../../../redux/Vehicles/action';
import { appointmentDetails } from '../../../redux/appointment/action';
// Updated imports using new domain-based structure
import { useQueryClient } from '@tanstack/react-query';
import AddNotesSection from '../../../common/AddNotesSection.jsx';
import LineTaxCell from '../../../common/Tax/LineTaxCell';
import { showTaxSettingsNotice } from '../../../common/TaxSettingsNotice';
import { updateInventoryApi } from '../../../redux/Inventory/action';
import { appointmentKeys } from '../../../services/business/appointment';
import { businessInventoryKeys, getInventoryBatchDetailApi, useInfiniteInventoryList, useRefetchInventoryList } from '../../../services/business/inventory';
import { useGetAppointmentForInvoice } from '../../../services/business/invoices/invoices.hooks';
import {
    businessWorkOrdersKeys,
    useCreateWorkOrder,
    useGenerateWorkOrderNumber,
    useUpdateWorkOrder,
    waitForWorkOrderStatus,
} from '../../../services/business/workOrders';
import { reviewRequestKeys } from '../../../services/business/reviewRequest/reviewRequest.hooks.js';
import { useCreateSavedService, useRefetchSavedServiceList } from '../../../services/business/savedService';
import { businessServicesKeys, useCreateServiceSubcategory, useGetShopServices } from '../../../services/business/services';
import { useGetVehicleMakeList } from '../../../services/core/master/master.hooks';
import { useGetShopConfig, useGetShopTaxes, useGetTermsAndWarranty, useUpdateShopConfig } from '../../../services/core/settings';
import useGlobalStore from '../../../store/useGlobalStore';
import {
    CHIP_COLOR,
    INVENTORY_MANAGE_TYPE,
    INVENTORY_TYPES,
    INVOICE_PAYMENT_STATUS,
    MILEAGE_UNIT,
    PART_TYPES,
    PAYEMNT_METHODS,
    PRICING_METHOD,
    PRICING_TYPES,
    SHOP_SERVICE_PRICE_TYPES,
    USER_TIMEZONE,
    WORK_ORDER_AUTHORIZATION_TEXT,
    WORK_ORDER_STATUS,
    WORK_ORDER_STATUS_LABEL,
    normalizeWorkOrderStatus,
} from '../../../utility/Constant';
import CustomerFleet from '../../../utility/Svg/CustomerFleet';
import CustomerTrim from '../../../utility/Svg/CustomerTrim';
import CustomerVin from '../../../utility/Svg/CustomerVin';
import FleetIconSvg from '../../../utility/Svg/FleetIconSvg';
import InvoiceDetailSvg from '../../../utility/Svg/InvoiceDetailSvg';
import PartBrandSvg from '../../../utility/Svg/PartBrandSvg';
import PartCategorySvg from '../../../utility/Svg/PartCategorySvg';
import AuthorizationSectionSvg from '../../../utility/Svg/AuthorizationSectionSvg';
import SaveAsDraftSvg from '../../../utility/Svg/SaveAsDraftSvg';
import SaveAndSendSvg from '../../../utility/Svg/SaveAndSendSvg';
import ServiceBlueSvg from '../../../utility/Svg/ServiceBlueSvg';
import ServiceWhiteSvg from '../../../utility/Svg/ServiceWhiteSvg';
import TermsAndWarrantySvg from '../../../utility/Svg/TermsAndWarrantySvg';
import {
    filterUndefined,
    formatDecimalNumber,
    formatNumberAsWhole,
    formatNumberWithCommas,
    handlePreventKeyDownDecimal,
    isNumberInRange,
    PhoneTypeIcon,
    truncateToFixed,
} from '../../../utility/helpers/commonFunction';
import { DISCOUNT_SOURCE, hydrateDiscountFromResponse } from '../../../utility/helpers/discountCalculation';
import { NumericEngine } from '../../../utility/helpers/numericEngine';
import { focusServiceSearch } from '../../../utility/helpers/focusServiceSearch';
import { shouldShowPerServiceSubtotalRow } from '../../../utility/helpers/shouldShowPerServiceSubtotalRow';
import {
    applyFloridaLabourSuppression,
    applyGlobalTaxToggle,
    buildInvoiceBreakdownFromEstimate,
    buildLineDefaultTaxes,
    buildLineTaxesBreakdownPayload,
    buildTaxableLines,
    buildTaxesBreakdownFromShopTaxes,
    buildTaxesBreakdownPayload,
    calculateDocumentTotals,
    DOCUMENT_TAX_TYPE,
    editorHasPartsOrPackages,
    getShopTaxRules,
    getTaxRowRate,
    isFloridaLabourOnlySuppressed,
    LINE_TAX_KIND,
    mergeShopTaxRulesIntoBreakdown,
    normalizeTaxesBreakdownFromResponse,
    partGrossAmount,
    recordHasPartsOrPackages,
    rehydrateLabourLineTaxes,
    resolveBreakdownForCalc,
    resolveTaxPreservation,
    shouldSyncCalculatedBreakdown,
    shouldWarnZeroMultiTax,
    summarizeTaxAcrossLines,
} from '../../../utility/helpers/taxCalculation';
import { useProvinceTaxGroup } from '../../../utility/hooks/useProvinceTaxGroup';
import { resolveSelectedVehicleId } from '../../../utility/vehicleSelection';
import { inputFormatPhoneNumber } from '../../Common/FormatPhoneNumber';
import InputWithIcon from '../../Common/InputWithIcon';
import GenralInventoryAutocomplete from '../../Common/Inventory/GenralInventoryAutocomplete';
import SuccessMessageModal from '../../Common/SuccessMessage';
import AddInventoryModal from '../../Inventory/AddInventory';
import BatchSelectionModal from '../../Inventory/BatchSelectionModal';
import PartDetailsModal from '../../Inventory/PartDetailTable';
import AddSavedServicesModal from '../../Shop/SavedServices/AddSavedServicesModal/AddSavedServicesModal';
import CreateSavedServiceFromInvoice from '../../Shop/SavedServices/CreateSavedServiceFromInvoice/CreateSavedServiceFromInvoice';
import AddCustomerProgramModal from '../../modal/AddCustomerProgramModal';
import '../../Invoice/Invoice.css';
import FeesSection from '../../Invoice/GenrateInvoice/FeesSection';

// Lazy load components that use country/province master APIs

const AddCustomerModalV4 = lazy(() => import('../../../common/AddCustomerModalV4'));
const VehicleModalV4 = lazy(() => import('../../../common/VehicleModalV4'));
const UpdateCustomerModal = lazy(() => import('../../Customers/Profile/UpdateCustomerModal'));

const createPartRowId = () =>
    typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `part-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

const NewWorkOrderV4 = ({ showLoader, setShowLoader, invoiceData = {}, fetchInvoceDetailData }) => {
    console.log('🚀 ~ NewWorkOrderV4 ~ invoiceData:', invoiceData);
    const refreshSavedServices = useRefetchSavedServiceList({});
    const { id, appointmentId, customerId, type } = useParams();
    const { isDirty, invoiceDataInStore, markSaved, resetGlobalState, setInvoiceDataInStore } = useGlobalStore();

    const queryClient = useQueryClient();

    const location = useLocation();
    const pathname = location.pathname ? location.pathname?.split('/') : '';
    const duplicateInvoiceData = location.state?.duplicateInvoice;
    const isNewInvoice = !id && !duplicateInvoiceData?._id && !location.state?.estimateData?._id;
    const isPlainNewInvoice = isNewInvoice && !appointmentId && !customerId && !type;

    const { isOpenSideBar } = useContext(Context);
    const [isAddPartAgain, setIsAddPartAgain] = useState(false);
    const requestIdRef = useRef(0);
    const cancelTokenSourceRef = useRef(null); // Track cancel token for customer list API

    const isDropOffManuallyChanged = useRef(false);
    const isCompletionManuallyChanged = useRef(false);
    const isTermsInitializedRef = useRef(false);

    const screenWidth = useScreenWidth();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // TanStack Query hooks
    const { data: termsAndWarrantyData, isLoading: termsLoading } = useGetTermsAndWarranty();
    const termsOptions = useMemo(() => (Array.isArray(termsAndWarrantyData) ? termsAndWarrantyData : []), [termsAndWarrantyData]);
    const { data: vehicleMakeData } = useGetVehicleMakeList({
        page: 1,
        limit: 2000,
    });

    // Extract vehicle make data
    const vehicleMakeList = Array.isArray(vehicleMakeData?.data) ? vehicleMakeData.data : Array.isArray(vehicleMakeData) ? vehicleMakeData : [];

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [isFinalizedEmail, setIsFinalizedEmail] = useState(false);
    const [isUsedInvoiceQty, setIsUsedInvoiceQty] = useState(null);
    const [linkedEstimateId, setLinkedEstimateId] = useState(null);

    const [vehicleDropdownOpen, setVehicleDropdownOpen] = useState(false);

    const [outOfStockStatus, setOutOfStockStatus] = useState(null);
    const [openEditCustomer, setOpenEditCustomer] = useState(false);
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
    });
    const newMethod = { transactionType: 'payment', paymentMethod: 'credit', amount: '', paymentReference: '', paymentDate: null };
    const [paymentMethods, setPaymentMethods] = useState([]);

    const [isOpenPartDeleteModal, setIsOpenPartDeleteModal] = useState({ open: false, outerIndex: 0, innerIndex: 0 });
    const [isOpenServiceDeleteModal, setIsOpenServiceDeleteModal] = useState({ open: false, outerIndex: 0, innerIndex: 0 });
    const [openPriceChangeModal, setOpenPriceChangeModal] = useState({ open: false, outerIndex: 0, innerIndex: 0 });
    const [priceUpdateLoader, setPriceUpdateLoader] = useState(false);
    const debouncePriceTimerRef = useRef(null);
    const previousPriceRef = useRef(null);

    const [isRecordModal, setIsRecordModal] = useState(false);
    const [issBatchNumberLoading, setIsBatchNumberLoading] = useState(false);
    const [paymentsMethod, setPaymentsMethods] = useState({});
    const isSubmittingRef = useRef(false);
    // Guards the one-time estimate→work order conversion so a shop-taxes refetch can't re-run it.
    const conversionInitRef = useRef(false);
    /*
     * Update Work Order (spec §6.5): the work order is loaded first, then only the fields the estimate
     * owns are overlaid — so what the work order owns (its authorization text, dates, advisor notes)
     * survives the refresh. The overlay waits for the load to finish.
     */
    const [targetHydrated, setTargetHydrated] = useState(false);
    const submitCompletedRef = useRef(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitCompleted, setSubmitCompleted] = useState(false);

    const [searchInventory, setSearchInventory] = useState('');

    //google review flow hooks (single source for Carfax + Google Review + custom message)
    const [googleReviewDetails, setIsGoogleReviewDetails] = useState({
        shouldSendInvoiceToCarfax: false,
        sendGoogleReviewRequest: true,
        customMessage: '',
        shouldSendReviewSMSToCustomer: false,
        shouldSendReviewEmailToCustomer: false,
        shouldSendReviewNotificationToCustomer: false,
    });
    console.log('🚀 ~ NewWorkOrderV4 ~ googleReviewDetails:', googleReviewDetails);
    // TanStack Query for inventory list with infinite scroll
    const inventoryQueryParams = {
        inventoryType: INVENTORY_MANAGE_TYPE.MANAGED,
        limit: 25,
        search: searchInventory || '',
    };

    const {
        data: inventoryQueryData,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        refetch: refetchInventoryList,
    } = useInfiniteInventoryList(inventoryQueryParams);

    // Flatten the paginated data for the autocomplete
    const inventoryList = inventoryQueryData?.pages?.flatMap((page) => page.data || []) || [];
    const inventoryPageData = {
        totalpages: inventoryQueryData?.pages?.[0]?.totalPages || 0,
        currentPage: inventoryQueryData?.pages?.length || 1,
        totalCount: inventoryQueryData?.pages?.[0]?.totalCount || 0,
    };

    const {
        handleSubmit,
        control,
        formState: { errors },
        trigger,
        setValue,
        setError,
        getValues,
        reset,
        setFocus,
        clearErrors,
        watch,
    } = useForm();

    const watchedTermsAndWarranty = useWatch({ control, name: 'termsAndWarranty' });
    const showTermsPreview = Boolean(watchedTermsAndWarranty?.title && watchedTermsAndWarranty?.description);

    function handleClick(event) {
        event.preventDefault();
    }
    //new hook for new design
    const labourTextRef = useRef([]);
    const inputDivRef = useRef([]);
    const textFieldRef = useRef([]);
    const partNameFieldRef = useRef([]);
    const inputFielRef = useRef([]);
    const partQtyRef = useRef({}); // For storing refs to quantity inputs by key: `${outerIndex}-${innerIndex}`
    const preventCloseRef = useRef(false);

    const [customerInvoiceTaxes, setCustomerInvoiceTaxes] = useState([]);
    const [taxesBreakdown, setTaxesBreakdown] = useState([]);
    const [isNewTaxVersionActive, setIsNewTaxVersionActive] = useState(!id);

    const [addQty, setAddQty] = useState(false);

    const [deletePartConfirmation, setDeletePartConfirmation] = useState(false);
    const [deletePartLoader, setDeletePartLoader] = useState(false);

    const [isOpenFeeModal, setIsOpenFeeModal] = useState(false);
    const [addFeeLoader, setAddFeeLoader] = useState(false);
    const [selectedFees, setSelectedFees] = useState([]);
    const [FeesList, setFeesList] = useState([]);

    const [askServiceModal, setAskServiceModal] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);

    const [serviceExpanded, setServiceExpanded] = useState([]);
    const [accordianExpanded, setAccordianExpanded] = useState([0, 1]);

    // inventoryLoader is now managed by TanStack Query (see inventoryLoader variable above)
    const [inventoryModalType, setInventoryModalType] = useState('add');
    const [showAllInventoryTabs, setShowAllInventoryTabs] = useState(true);
    const [selectedInventory, setSelectedInventory] = useState([]);
    const [selectedService, setSelectedService] = useState([]);
    const [inventoryTabIndex, setInventoryTabIndex] = useState(0);
    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [batchNumber, setBatchNumber] = useState(null);

    const [showMenuLoader, setShowMenuLoader] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);

    const [isServiceModalOpen, setIsServiceModalOpen] = useState(false);
    const [openLabourModal, setOpenLabourModal] = useState(false);
    const [openPartModel, setOpenpartModel] = useState(false);
    const [saveIndexes, setSaveIndexes] = useState({
        outerIndex: 0,
        innerIndex: 0,
    });

    const [open, setOpen] = useState(false);
    const [storeValues, setStoreValues] = useState();

    const [openCreateSavedServiceFromInvoiceModal, setOpenCreateSavedServiceFromInvoiceModal] = useState(false);
    const [savedServiceOuterIndex, setSavedServiceOuterIndex] = useState(null);

    const [openSavedServicesModal, setOpenSavedServicesModal] = useState(false);
    const [savedServicesModalOuterIndex, setSavedServicesModalOuterIndex] = useState(null);

    const [openServiceModal, setOpenServiceModal] = useState(false);
    const [openProgramModal, setOpenProgramModal] = useState(false);

    const [openPartDetailModal, setOpenPartDetailModal] = useState(false);
    const [allService, setAllServices] = useState([]);

    const [serviceListPayload, setServiceListPayload] = useState([]);
    const [serviceFilteredData, setServiceFilteredData] = useState([]);

    // Use TanStack Query for shop config instead of Redux
    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();
    const { data: shopTaxesData } = useGetShopTaxes();
    const provinceTaxGroup = useProvinceTaxGroup();

    const allowCarfax = shopConfigData?.config?.carfaxSettings?.dailyROUploadEnabled || false;

    // Use TanStack Query for service data instead of localStorage
    const {
        data: servicesData,
        isLoading: servicesLoading,
        error: servicesError,
        refetch: refetchServices,
    } = useGetShopServices({
        pagination: false,
        limit: 2500,
        sortBy: 'name',
        sortType: 'ASC',
    });

    //Get invoice Number api
    const { data: invoiceNumberData } = useGenerateWorkOrderNumber(id);

    // Work order create/update — TanStack mutations, no Redux (spec §10 Phase 1)
    const createWorkOrder = useCreateWorkOrder();
    const updateWorkOrder = useUpdateWorkOrder();

    // Use mutation for creating service subcategory
    const createServiceMutation = useCreateServiceSubcategory({
        onSuccess: (data) => {
            // Success handling is done in handleSaveService function
            // The mutation automatically invalidates and refetches the services list
        },
        onError: (error) => {
            console.error('Error creating service:', error);
        },
    });

    // Get cached services from query data instead of localStorage
    const cachedServices = servicesData?.data || [];

    // Initialize serviceFilteredData when services are loaded
    useEffect(() => {
        if (cachedServices.length > 0) {
            setServiceFilteredData(cachedServices);
        }
    }, [cachedServices]);

    // Update anchorEls array when serviceListPayload length changes
    useEffect(() => {
        setAnchorEls(Array(serviceListPayload.length).fill(false));
    }, [serviceListPayload.length]);

    const isTableVisible = serviceListPayload.length > 0;

    const [paymentDetails, setPaymentDetails] = useState({
        discount: 0,
        discountPercentage: 0,
        discountSource: DISCOUNT_SOURCE.PERCENTAGE,
        tax: 0,
        taxPercentage: '0',
        fees: 0,
        subTotal: 0,
        labourTotal: 0,
        partsTotal: 0,
        packagesTotal: 0,
        total: 0,
    });

    const [anchorEls, setAnchorEls] = useState(Array(serviceListPayload.length).fill(false));
    const [isLoading, setIsLoading] = useState(false);
    const [checkChangeLoader, setCheckChangeLoader] = useState(false);
    const [selectedDiscount, setSelectedDiscount] = useState(null);

    const [shopSupplyData, setShopSupplyData] = useState([]);
    const [editShopSupply, setEditShopSupply] = useState({
        edit: false,
        index: '',
    });
    const [openCustomerInfo, setOpenCustomerInfo] = useState(false);
    const [openAddCustomerModal, setOpenAddCustomerModal] = useState(false);
    const [openTermsModal, setOpenTermsModal] = useState(false);
    const [termsModalMode, setTermsModalMode] = useState('add');
    const [termsModalInitial, setTermsModalInitial] = useState({ title: '', description: '' });
    const [isEditCustomer, setIsEditCustomer] = useState(false);
    const handleOpenCustomerInfo = () => setOpenAddCustomerModal(true);
    const [isDiscardModel, setIsDiscardModel] = useState(false);
    const [openZeroTaxModal, setOpenZeroTaxModal] = useState(false);
    const customerLimit = 50;

    // To Fix SAAS-3344
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation(); // stop going to MUI components
                e.preventDefault(); // stop browser default (if any)
            }
        };

        window.addEventListener('keydown', handleKeyDown, true);

        return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
        };
    }, []);

    // Clear customer detail when component unmounts (user leaves the page)
    useEffect(() => {
        return () => {
            // Cleanup: Clear customer detail from Redux when leaving the page
            dispatch(clearCustomerDetail());
        };
    }, [dispatch]);

    useEffect(() => () => resetGlobalState(), [resetGlobalState]);

    const createSavedServiceMutation = useCreateSavedService({
        onSuccess: (data) => {
            toast.success(data?.message);
            refreshSavedServices();
            setOpenCreateSavedServiceFromInvoiceModal(false);
            setSavedServiceOuterIndex(null);
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Failed to create saved service');
            console.error('Error creating saved service:', error);
        },
    });

    const handleCloseCustomerInfo = async (resp, check, convertedUser) => {
        //   setOpenCustomerInfo(false);
        setOpenAddCustomerModal(false);
        if (convertedUser) {
            const userData = resp.data;
            const customerObject = {
                ...userData,
                fullName: userData?.firstName + ' ' + userData?.lastName,
                createdFrom: SHOP_CREATED,
                refIdUsers: id,
                refIdImport: id,
                _id: userData._id || resp?.data?._id, // Ensure _id exists for proper comparison
            };

            setCustomerDetail([customerObject]);
            setCustomerData(customerObject);
            setValue('customerId', customerObject);
            setShowLoader(false);
        } else if (resp?.data?._id && !convertedUser) {
            setShowLoader(true);

            if (type != SHOP_IMPORTED) {
                resp = await dispatch(customerDetailApi(resp?.data?._id));
            }
            if (type == SHOP_IMPORTED) {
                resp = await dispatch(importedCustomerDetail(resp?.data?._id));
            }

            const customerObject = {
                ...resp,
                fullName: resp?.firstName + ' ' + resp?.lastName,
                refIdUsers: resp?.data?._id,
                refIdImport: resp?.data?._id,
                _id: resp._id || resp?.data?._id, // Ensure _id exists for proper comparison
            };

            setCustomerDetail([customerObject]);
            setCustomerData(customerObject);
            setValue('customerId', customerObject);
        } else if (!check) {
            setCustomerData(null);
        }
    };

    const [editServiceData, setEditServiceData] = useState({
        edit: false,
        index: '',
    });
    const isSaveDraftRef = useRef(false);
    const isSendEmailRef = useRef(false);
    const zeroTaxBypassRef = useRef(false);
    const pendingZeroTaxActionRef = useRef(null);
    const taxPercentageInputRef = useRef(null);
    //
    const [loading, setLoading] = useState(false);

    const [advisorInput, setAdvisorInput] = useState('');

    const [open1, setOpen1] = useState(false);
    const [reqDate, setreqDate] = useState(new Date());
    const [customerData, setCustomerData] = useState('');
    const [customerMembershipId, setCustomermemberShipId] = useState(null);
    const [isRemoveDiscount, setIsRemoveDiscount] = useState(false);
    const [vehicleData, setVehicleData] = useState('');
    const skipVehicleDetailRef = useRef(false);
    const [selectedVehicleMake, setSelectedVehicleMake] = useState(null);
    const [selectInvoiceDate, setSelectInvoiceDate] = useState(null);
    const [selectDate, setSelectDate] = useState(null);
    const [completionDate, setCompletionDate] = useState(null);
    const [customValidationErr, setCustomValidationErr] = useState(null);
    const [odoValidationErr, setOdoValidationErr] = useState(null);
    const [customerDetail, setCustomerDetail] = useState([]);
    const [customerSearch, setCustomerSearch] = useState('');
    const [customerListLoader, setCustomerListLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [servicePageData, setServicePageData] = useState({
        totalpages: '',
        currentPage: '',
    });
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [disabledFields, setDisabledFields] = useState([]);
    const [finalizedInventoryCount, setFinalizedInventoryCount] = useState({});
    const [openTrackedIncreaseModal, setOpenTrackedIncreaseModal] = useState(false);

    const [vehicleDropdownLoading, setVehicleDropdownLoading] = useState(false);
    const [appointmentData, setAppointmentData] = useState(null);
    const [googleReviewMessage, setGoogleReviewMessage] = useState('');
    const [customerTypeData, setCustomerTypeData] = useState([]);
    const [addVehicleInfoButton, setAddVehicleInfoButton] = useState(false);
    const [customerCreatedFrom, setCustomerCreatedFrom] = useState('');

    const shouldSkipAppointmentForInvoiceQuery = Boolean(id && invoiceData?.appointment?._id && invoiceData?.status !== 'draft');

    const SHOP_ID = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('apex-saas_details'))?._id || null;
        } catch (e) {
            return null;
        }
    }, []);

    const SHOP_NAME = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('apex-saas_details'))?.shopName || '';
        } catch (e) {
            return '';
        }
    }, []);

    const updateShopConfigMutation = useUpdateShopConfig();

    /**
     * The shop's default authorization wording, set in Account Settings → Work Order Authorization
     * Text. Falls back to the built-in wording for a shop that has never saved one (spec §4.5).
     */
    const defaultAuthorizationText = useMemo(
        () => shopConfigData?.config?.workOrderAuthorization?.defaultAuthorizationMessage || WORK_ORDER_AUTHORIZATION_TEXT(SHOP_NAME),
        [shopConfigData, SHOP_NAME]
    );

    // Work order authorization wording — editable per document (spec §4.5)
    const [authorizationText, setAuthorizationText] = useState('');
    // Tracks whether the box has been seeded, so the shop default landing late (or a refetch)
    // cannot overwrite what the user has typed or what an existing record carries.
    const authorizationSeededRef = useRef(false);

    /**
     * Offer SET AS DEFAULT only once the wording on this work order actually differs from the shop
     * default — editing it here is per-document, saving it as the default is a deliberate second step.
     */
    const authorizationDiffersFromDefault = useMemo(
        () => Boolean(authorizationText?.trim()) && authorizationText.trim() !== defaultAuthorizationText?.trim(),
        [authorizationText, defaultAuthorizationText]
    );

    /** Writes this work order's wording back to the shop config as the new default. */
    const handleSetAuthorizationAsDefault = async () => {
        try {
            await updateShopConfigMutation.mutateAsync({
                workOrderAuthorization: { defaultAuthorizationMessage: authorizationText?.trim() || '' },
            });
            toast.success('Default authorization text updated');
        } catch (error) {
            console.error('Error updating default authorization text:', error);
        }
    };

    useEffect(() => {
        if (authorizationSeededRef.current) return;
        // An existing record seeds from its own message; those paths set the ref themselves.
        if (id || invoiceData?._id || location.state?.estimateData?._id) return;
        if (!shopConfigData) return;

        authorizationSeededRef.current = true;
        setAuthorizationText(defaultAuthorizationText);
    }, [shopConfigData, defaultAuthorizationText, id, invoiceData?._id, location.state]);

    /**
     * A draft is still "unsaved" as far as the lifecycle goes. Editing one offers both
     * Save as Draft (stay a draft) and Create Work Order (promote it to open), sends `isDraft`
     * either way, and goes through **create** — the update endpoint is only for a record that
     * has already left draft. (spec §14.5)
     */
    const isDraftRecord = normalizeWorkOrderStatus(invoiceData?.status) === WORK_ORDER_STATUS.DRAFT;

    /**
     * Second breadcrumb on an existing work order: the record's own status, so a non-draft no
     * longer reads "Drafts". Matches the listing sub-menu wording, which uses the plural.
     */
    const breadcrumbStatusLabel = useMemo(() => {
        const status = normalizeWorkOrderStatus(invoiceData?.status);
        if (status === WORK_ORDER_STATUS.DRAFT) return 'Drafts';
        return WORK_ORDER_STATUS_LABEL[status] || 'Work Order';
    }, [invoiceData?.status]);
    const usesCreateEndpoint = !id || isDraftRecord;
    // Pending save held back by the "Reauthorization Required" prompt (spec §4.4) — the submit args to replay.
    const [reapprovalPrompt, setReapprovalPrompt] = useState(null);
    /*
     * Work order ⇒ Invoice (spec §6.5): saving a work order that already has an invoice asks whether to
     * carry the changes onto it — same "Update linked invoice?" prompt the estimate editor shows,
     * whether the invoice was made from this work order or auto-linked from its estimate (spec §6.4).
     * Holds the submit args to replay once the user picks SKIP or UPDATE.
     */
    const [invoiceSyncPrompt, setInvoiceSyncPrompt] = useState(null);
    // Also on the edit-from-estimate sync route, so Estimate ⇒ Work order ⇒ Invoice chains: after the work
    // order takes the estimate's changes, saving it offers to carry them on to its invoice.
    const linkedInvoiceToSync = !usesCreateEndpoint ? firstLinked(invoiceData?.linkedInvoiceId) : null;

    const [openVehicleModal, setOpenVehicleModal] = useState(false);
    const [editVehicleData, setEditVehicleData] = useState(null);
    const [newVehicleCreatedId, setVehicleCreatedId] = useState('');

    const [messageType, setMessageType] = useState('');
    const [discountError, setDiscountError] = useState(false);
    // Selector for the advisor list (a work order has no technician)
    const advisorList = useSelector((state) => state?.invoice?.advisorList?.data);
    const [data, setData] = useState('');
    // Only a brand new work order (plain or from the customer profile) warns about an open draft.
    const { openDraftModal, openDraftData, handleCloseOpenDraftModal, handleViewOpenDraft } = useOpenDraftAlert({
        documentType: 'workOrder',
        enabled: isNewInvoice && !appointmentId,
        vehicle: Array.isArray(data) ? data.find((v) => v._id === vehicleData) : null,
    });
    const [dropOffDate, setDropOffDate] = useState(null);
    const [discountList, setDiscountList] = useState([]);
    const [discountId, setDiscountId] = useState(null);
    const limit = 1000;

    // A work order records only the mileage the car came in on — there is no Mileage Out.
    const [state, setState] = useState({
        shop_created: true,
        shop_imported: true,
        apex_auto_app: true,
    });

    const [totals, setTotals] = useState({
        subTotal: 0,
        discount: 0,
        taxPercentage: 13,
        tax: 0,
        estimatedTotal: 0,
        discountPercentage: 0,
    });

    const usedQuantityOfInventory = useMemo(() => {
        const result = {};

        serviceListPayload.forEach((row) => {
            row.parts?.forEach((partEntry) => {
                if (partEntry?._id) {
                    const partId = partEntry?._id;
                    const qty = partEntry?.partQty || 0;

                    result[partId] = (result[partId] || 0) + qty;
                }
            });
        });

        return result;
    }, [serviceListPayload]);

    const allServiceListing = JSON.parse(localStorage.getItem('allServiceListing'));
    const handleSaveAdvisorInput = async (newOption) => {
        setLoading(true);
        const response = await addAdvisorApi({
            name: newOption,
        });
        if (response) {
            setOpenSuccessModal(true);
            setSuccessMessage(response?.message);
            fetchAdvisorApi('');
            setValue('serviceAdvisor', response?.data?._id);
            markSaved();
        }

        const autocompleteInput = document.getElementById('service-autocomplete');
        if (autocompleteInput) {
            autocompleteInput.blur();
        }
        setLoading(false);
    };

    const handleOpenServiceModal = () => setOpenServiceModal(true);
    const handleClose = () => {
        setOpen(false);
    };

    const handleVehicleOpen = () => {
        setOpenVehicleModal(true);
        handleClose();
    };

    // Inventory loading state - now managed by TanStack Query
    const inventoryLoader = isFetching || isFetchingNextPage;
    const [inventoryModalLoader, setInventoryModalLoader] = useState(false);

    // Get refetch function for manual inventory refresh
    const refetchInventoryListManual = useRefetchInventoryList(inventoryQueryParams);

    // No longer need useEffect for fetchInventoryList - TanStack Query handles this automatically

    /*
     * Latest shop config, read through a ref so applyNewInvoiceDefaults stays a stable callback.
     * If it depended on shopConfigData, every config refetch — e.g. after SET AS DEFAULT on the
     * authorization text — would re-create it and re-run the pathname effect below, which clears the
     * customer, vehicle, services, fees and dates of the work order being edited.
     */
    const shopConfigRef = useRef(shopConfigData);
    shopConfigRef.current = shopConfigData;

    const applyNewInvoiceDefaults = useCallback(() => {
        setDiscountId('none');
        setSelectedDiscount(null);
        setCustomermemberShipId(null);
        setLinkedEstimateId(null);

        const config = shopConfigRef.current?.config;
        if (config) {
            setIsGoogleReviewDetails({
                shouldSendInvoiceToCarfax: !!config.carfaxSettings?.autoPublishToCarfax,
                sendGoogleReviewRequest: !!config.invoiceReviewManualSelect,
                customMessage: '',
                shouldSendReviewSMSToCustomer: !!config.shouldSendReviewSMSToCustomer,
                shouldSendReviewEmailToCustomer: !!config.shouldSendReviewEmailToCustomer,
                shouldSendReviewNotificationToCustomer: !!config.shouldSendReviewNotificationToCustomer,
            });
        }
    }, []);

    useEffect(() => {
        if (!isPlainNewInvoice) return;
        applyNewInvoiceDefaults();
    }, [isPlainNewInvoice, location.pathname, applyNewInvoiceDefaults]);

    //window location pathaname useEffect
    useEffect(() => {
        isTermsInitializedRef.current = false;
        resetGlobalState();
        setOpenTrackedIncreaseModal(false);
        reset({
            invoicePreparedBy: '',
            odoDroppedOff: '',
        });

        setCompletionDate(null);
        setSelectDate(null);
        setSelectInvoiceDate(null);

        const dataToStore = { ...invoiceDataInStore };
        if (dataToStore?.appointmentCompletionDate) delete dataToStore.appointmentCompletionDate;
        if (dataToStore?.appointmentDroppedOffDate) delete dataToStore.appointmentDroppedOffDate;
        if (dataToStore?.invoiceDate) delete dataToStore.invoiceDate;
        setInvoiceDataInStore(dataToStore, false);

        setPaymentDetails({
            ...paymentDetails,
            discount: 0,
            discountPercentage: 0,
            discountSource: DISCOUNT_SOURCE.PERCENTAGE,
            tax: 0,
            fees: 0,
            subTotal: 0,
            labourTotal: 0,
            partsTotal: 0,
            packagesTotal: 0,
            total: 0,
        });
        setAllServices([]);
        setCustomerData(null);
        setVehicleData(null);
        setSelectedVehicleMake(null);
        setData([]);

        setShopSupplyData([]);
        if (!id && !appointmentId && !customerId && !type) {
            setCustomerTypeData(['shop_created', 'apex_auto_app', 'shop_imported']);
            setAdvisorInput('');
            setState({
                shop_created: true,
                apex_auto_app: true,
                shop_imported: true,
            });
            setServiceListPayload([]);
            setSelectedFees([]);
            applyNewInvoiceDefaults();
        }
        if (appointmentId) {
            fetchAppointmentDetails(appointmentId);
        }

        if (customerId) {
            setCustomerTypeData(['shop_created', 'apex_auto_app', 'shop_imported']);
            setValue('customerId', customerId);
            setState({
                shop_created: true,
                apex_auto_app: true,
                shop_imported: true,
            });
            customerDataDetail();
            const today = dayjs(dayjs().format('YYYY-MM-DD'));

            setSelectInvoiceDate(today, false);
            setValue('invoiceDate', today);
            setSelectDate(today);
            setValue('dropOffDate', today);
            setCompletionDate(today);
            setValue('completionDate', today);
            isDropOffManuallyChanged.current = false;
            isCompletionManuallyChanged.current = false;

            setInvoiceDataInStore(
                {
                    ...invoiceDataInStore,
                    appointmentDroppedOffDate: today,
                    appointmentCompletionDate: today,
                    invoiceDate: today,
                },
                false
            );
        }
    }, [location.pathname, applyNewInvoiceDefaults]);
    //default fetch and set hooks

    const shopPriceDetails = useSelector((state) => state?.account?.defaultShopPrice);

    console.log('country:', shopConfigData?.config?.country, shopConfigData?.country);

    useEffect(() => {
        if (!id && !customerId) {
            fetchDiscountProgram();
        }

        // Service data is now fetched via useGetShopServices hook
        fetchAdvisorApi('');
        fetchDefaultShopPrice();
        fetchFeesList(true);

        const today = dayjs(dayjs().format('YYYY-MM-DD'));
        setSelectInvoiceDate(today, false);
        setValue('invoiceDate', today);
        setSelectDate(today);
        setValue('dropOffDate', today);
        setCompletionDate(today);
        setValue('completionDate', today);
        isDropOffManuallyChanged.current = false;
        isCompletionManuallyChanged.current = false;

        setInvoiceDataInStore(
            {
                ...invoiceDataInStore,
                appointmentDroppedOffDate: today,
                appointmentCompletionDate: today,
                invoiceDate: today,
            },
            false
        );

        if (!id && !appointmentId && !customerId && !type) {
            applyNewInvoiceDefaults();
        }
    }, []);

    const fetchDefaultShopPrice = async () => {
        await dispatch(getDefaultShopPrice());
    };

    // Shop-config defaults (payment method, tax, review toggles) apply once, when the config first
    // arrives — a later refetch (SET AS DEFAULT) must not reset what the user has on screen.
    const shopConfigDefaultsAppliedRef = useRef(false);
    useEffect(() => {
        if (!shopConfigData || shopConfigDefaultsAppliedRef.current) return;
        shopConfigDefaultsAppliedRef.current = true;
        if (shopConfigData?.config?.customerInvoiceTaxes?.length > 0) {
            setCustomerInvoiceTaxes(shopConfigData?.config?.customerInvoiceTaxes);

            const isDefault = shopConfigData?.config?.customerInvoiceTaxes.find((item) => item?.isDefault);
            const paymentMethod = PAYEMNT_METHODS.find((method) => method.key === isDefault?.paymentMethod);

            setValue('paymentMethod', paymentMethod);

            if (!isNewTaxVersionActive) {
                setTimeout(() => {
                    if (!id && !location.state?.estimateData?._id) {
                        if (isDefault?.shouldIncludeTax) {
                            setPaymentDetails((prevDetails) => ({
                                ...prevDetails,
                                taxPercentage: NumericEngine.format(isDefault?.taxRate),
                            }));
                        }
                    }
                }, 300);
            }
        }
        if (!id) {
            setIsGoogleReviewDetails({
                shouldSendInvoiceToCarfax: shopConfigData?.config?.carfaxSettings?.autoPublishToCarfax ? true : false,
                sendGoogleReviewRequest: shopConfigData?.config?.invoiceReviewManualSelect ? true : false,
                customMessage: '',
                shouldSendReviewSMSToCustomer: shopConfigData?.config?.shouldSendReviewSMSToCustomer ? true : false,
                shouldSendReviewEmailToCustomer: shopConfigData?.config?.shouldSendReviewEmailToCustomer ? true : false,
                shouldSendReviewNotificationToCustomer: shopConfigData?.config?.shouldSendReviewNotificationToCustomer ? true : false,
            });
        }
    }, [shopConfigData, isNewTaxVersionActive]);

    const fetchFeesList = async (firstTime) => {
        const resp = await dispatch(getInvoiceFeesListApi({ type: 'invoice' }));

        if (resp?.data?.length > 0) {
            if (!id && firstTime) {
                // A new work order starts with the fees marked default for work orders in
                // Account Settings → Fees (`isDefaultWorkOrder`), not the invoice's defaults.
                let selected = resp.data.filter((item) => item.isDefaultWorkOrder === true);
                setSelectedFees(selected);
            }

            setFeesList(resp.data);
        }
    };

    useEffect(() => {
        if (customerData?.refIdUsers && customerData.refIdUsers !== '') {
            fetchCustomerMembership(customerData.refIdUsers, !id);
        }
        if (customerData && customerData?.createdFrom != 'shop_imported') {
            if (skipVehicleDetailRef.current) {
                skipVehicleDetailRef.current = false;
                return;
            }
            fetchVehicles();
        }
        if (customerData?.createdFrom == USER_TYPES.SHOP_IMPORTED) {
            setCustomerCreatedFrom(USER_TYPES.SHOP_IMPORTED);
            setIsEditCustomer(true);
            setOpenAddCustomerModal(true);
        } else {
            setCustomerCreatedFrom(USER_TYPES.SHOP_CREATED);
        }
    }, [customerData]);

    useEffect(() => {
        if (customerTypeData.length != 0) {
            if (!appointmentId && !customerId && !type) {
                customersLists(page, customerLimit);
            }
        } else {
            setCheckChangeLoader(false);
        }
    }, [customerTypeData]);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0 && newVehicleCreatedId) {
            setVehicleData(newVehicleCreatedId);
            setVehicleCreatedId('');
        }
    }, [data]);

    const appointmentForInvoiceParams = useMemo(() => {
        if (shouldSkipAppointmentForInvoiceQuery) return null;
        const customerIdVal = customerData?.refIdUsers || customerData?._id;
        if (!customerIdVal || !vehicleData || !SHOP_ID) return null;
        return {
            customerId: customerIdVal,
            vehicleId: vehicleData,
            shopId: SHOP_ID,
        };
    }, [customerData, vehicleData, SHOP_ID, shouldSkipAppointmentForInvoiceQuery]);

    const appointmentForInvoiceQuery = useGetAppointmentForInvoice(appointmentForInvoiceParams || {}, {
        enabled: !!appointmentForInvoiceParams,
    });

    useEffect(() => {
        if (shouldSkipAppointmentForInvoiceQuery) return;
        if (!appointmentForInvoiceQuery.isSuccess || !appointmentForInvoiceQuery.data) return;
        const data = appointmentForInvoiceQuery.data;
        const normalize = (item) => {
            const fullname = [item?.customer?.firstName, item?.customer?.lastName].filter(Boolean).join(' ') || item?.customer?.fullName || '—';
            const vehicleStr =
                typeof item?.vehicle === 'string'
                    ? item.vehicle
                    : [
                          item?.vehicle?.vehicleYear || item?.vehicle?.year,
                          item?.vehicle?.vehicleMake?.name,
                          item?.vehicle?.vehicleModel?.name,
                          item?.vehicle?.vehicleModelTrim?.name,
                      ]
                          .filter(Boolean)
                          .join(' ') || '—';
            const dropOff = item?.dropOffDateTime ? dayjs(item.dropOffDateTime).tz(USER_TIMEZONE) : null;
            const dateTimeStr = dropOff ? dropOff.format('DD-MMM-YYYY - hh:mm A') : '—';
            const servicesCount = item?.services?.length ? `${item.services.length} Service${item.services.length !== 1 ? 's' : ''}` : '0 Services';
            return {
                _id: item._id ?? item.appointmentId,
                status: item.appointmentStatus ?? item.status,
                customerName: fullname,
                appointmentId: item?.appointmentNumber || item?.appointmentId?.slice?.(-6) || item?._id?.slice?.(-6) || '—',
                vehicle: vehicleStr,
                dateTime: dateTimeStr,
                servicesCount,
            };
        };
        if (appointmentId && data?.appointments?.length > 0) {
            const match = data.appointments.find((item) => (item.appointmentId ?? item._id) === appointmentId);
            if (match) {
                setAppointmentData(normalize(match));
            } else {
                setAppointmentData(null);
            }
        } else if (data?.appointments?.length === 1) {
            setAppointmentData(normalize(data.appointments[0]));
        } else if (data?.appointments?.length > 1) {
            setAppointmentData(data.appointments.map(normalize));
        } else {
            setAppointmentData(null);
        }

        // Build googleReviewMessage from first googleReviewRequest group and its last reviewRequest entry
        const allReviewGroups = Array.isArray(data?.googleReviewRequest) ? data.googleReviewRequest : [];
        const firstReviewGroup = allReviewGroups.length > 0 ? allReviewGroups[0] : null;
        const reviewRequests = Array.isArray(firstReviewGroup?.reviewRequest) ? firstReviewGroup.reviewRequest : [];
        const lastRequest = reviewRequests.length > 0 ? reviewRequests[reviewRequests.length - 1] : null;
        const lastSentAt = firstReviewGroup?.lastSentAt;

        const isWithin24Hours = lastSentAt && dayjs(lastSentAt).tz(USER_TIMEZONE).isAfter(dayjs().tz(USER_TIMEZONE).subtract(24, 'hours'));

        if (!firstReviewGroup || reviewRequests.length === 0 || !lastSentAt) {
            setGoogleReviewMessage('');
        } else {
            const channels = [];

            if (lastRequest?.sms?.sent) channels.push('text');
            if (lastRequest?.email?.sent) channels.push('email');
            if (lastRequest?.notification?.sent) channels.push('app');

            let channelsLabel = '—';
            if (channels.length === 1) {
                channelsLabel = channels[0];
            } else if (channels.length === 2) {
                channelsLabel = `${channels[0]} and ${channels[1]}`;
            } else if (channels.length >= 3) {
                channelsLabel = `${channels[0]}, ${channels[1]} and ${channels[2]}`;
            }

            const formattedDate = dayjs(lastSentAt).tz(USER_TIMEZONE).format('DD-MMMM-YYYY');
            // const totalRequests = reviewRequests.length;
            const totalRequests = allReviewGroups.length;

            if (isWithin24Hours) {
                setGoogleReviewMessage(`Last sent via ${channelsLabel} today`);
            } else if (totalRequests === 1) {
                setGoogleReviewMessage(`Last sent via ${channelsLabel} on ${formattedDate}`);
            } else {
                setGoogleReviewMessage(`${totalRequests} review requests sent previously. Last sent via ${channelsLabel} on ${formattedDate}`);
            }
        }
    }, [appointmentForInvoiceQuery.isSuccess, appointmentForInvoiceQuery.data, appointmentId, shouldSkipAppointmentForInvoiceQuery]);

    useEffect(() => {
        const breakdownForCalc = resolveBreakdownForCalc({
            isNewTaxVersion: isNewTaxVersionActive,
            id,
            taxesBreakdown,
            shopTaxesData,
            documentType: DOCUMENT_TAX_TYPE.WORK_ORDER,
        });
        const mergedBreakdown = mergeShopTaxRulesIntoBreakdown(breakdownForCalc, getShopTaxRules(shopTaxesData));

        const result = calculateDocumentTotals({
            mode: isNewTaxVersionActive ? 'multi' : 'legacy',
            serviceListPayload,
            PRICING_TYPES,
            discountId,
            selectedDiscount,
            paymentDetails,
            selectedFees,
            taxesBreakdown: mergedBreakdown,
            documentType: DOCUMENT_TAX_TYPE.WORK_ORDER,
            provinceTaxGroup,
        });

        setPaymentDetails((prev) => ({
            ...prev,
            ...result.paymentDetails,
        }));

        if (isNewTaxVersionActive && shouldSyncCalculatedBreakdown(result.taxesBreakdown)) {
            setTaxesBreakdown((prev) => {
                const next = result.taxesBreakdown;
                return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
            });
        }

        setDiscountError(!result.isValidDiscount);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        serviceListPayload,
        selectedDiscount,
        customerMembershipId,
        selectedFees,
        paymentDetails.taxPercentage,
        paymentDetails.discountSource,
        paymentDetails.discount,
        paymentDetails.discountPercentage,
        discountId,
        isNewTaxVersionActive,
        shopTaxesData,
        provinceTaxGroup,
        JSON.stringify(taxesBreakdown.map((r) => ({ taxId: r.taxId, applyTax: r.applyTax, rate: getTaxRowRate(r, DOCUMENT_TAX_TYPE.WORK_ORDER) }))),
    ]);

    // Per-tax line summary for the payment-summary tri-state checkbox + hover card.
    const lineTaxSummary = useMemo(() => {
        if (!isNewTaxVersionActive) return [];
        const merged = mergeShopTaxRulesIntoBreakdown(taxesBreakdown, getShopTaxRules(shopTaxesData));
        return summarizeTaxAcrossLines({
            serviceListPayload,
            selectedFees,
            PRICING_TYPES,
            taxesBreakdown: merged,
            discount: Number(paymentDetails?.discount) || 0,
            subTotal: Number(paymentDetails?.subTotal) || 0,
            documentType: DOCUMENT_TAX_TYPE.WORK_ORDER,
            provinceTaxGroup,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isNewTaxVersionActive,
        serviceListPayload,
        selectedFees,
        shopTaxesData,
        provinceTaxGroup,
        paymentDetails?.discount,
        paymentDetails?.subTotal,
        JSON.stringify(taxesBreakdown.map((r) => ({ taxId: r.taxId, applyTax: r.applyTax, rate: getTaxRowRate(r, DOCUMENT_TAX_TYPE.WORK_ORDER) }))),
    ]);

    // Live taxable lines for the record-payment dialog, so it recalculates with the same per-line
    // engine as this page (rounds each line's tax, then sums) and can never shift the total.
    const recordTaxableLines = useMemo(() => {
        if (!isNewTaxVersionActive) return null;
        return buildTaxableLines({
            serviceListPayload,
            selectedFees,
            PRICING_TYPES,
            subTotal: String(Number(paymentDetails?.subTotal) || 0),
            provinceTaxGroup,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNewTaxVersionActive, serviceListPayload, selectedFees, paymentDetails?.subTotal, provinceTaxGroup]);

    // Whole-document composition for the Florida labour-only rule + the per-line tax chips.
    const documentHasPartsOrPackages = useMemo(() => editorHasPartsOrPackages(serviceListPayload, PRICING_TYPES), [serviceListPayload]);

    // Payment-summary bulk toggle: materialise the tax on/off across every line (per-line stays the
    // source of truth). Florida-suppressed labour is left untouched by the helper.
    const handleBulkTaxToggle = useCallback(
        (taxId, checked) => {
            const next = applyGlobalTaxToggle({ serviceListPayload, selectedFees, taxId, checked, shopTaxesData, provinceTaxGroup, PRICING_TYPES });
            setServiceListPayload(next.serviceListPayload);
            setSelectedFees(next.selectedFees);
        },
        [serviceListPayload, selectedFees, shopTaxesData, provinceTaxGroup]
    );

    useEffect(() => {
        zeroTaxBypassRef.current = false;
    }, [paymentDetails.tax, paymentDetails.taxPercentage]);

    const shouldWarnZeroTax = () => {
        if (isNewTaxVersionActive) {
            return shouldWarnZeroMultiTax(paymentDetails, taxesBreakdown);
        }
        const subTotal = Number(paymentDetails?.subTotal) || 0;
        const fees = Number(paymentDetails?.fees) || 0;
        const discount = Number(paymentDetails?.discount) || 0;
        const taxableAmount = subTotal + fees - discount;
        return taxableAmount > 0 && !Number(paymentDetails?.tax);
    };

    const runWithZeroTaxGuard = (action) => {
        if (!shouldWarnZeroTax() || zeroTaxBypassRef.current) {
            action();
            return;
        }
        pendingZeroTaxActionRef.current = action;
        setOpenZeroTaxModal(true);
    };

    const focusTaxPercentageInput = () => {
        setAccordianExpanded((prev) => (prev.includes(1) ? prev : [...prev, 1]));
        requestAnimationFrame(() => {
            taxPercentageInputRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            taxPercentageInputRef.current?.focus();
        });
    };

    const serviceSubtotalCache = new WeakMap();
    const selectServiceSubtotal = (service) => {
        if (!service) return '0';

        if (serviceSubtotalCache.has(service)) {
            return serviceSubtotalCache.get(service);
        }
        let subtotal = '0';

        // FIXED service pricing
        if (service.pricingType === PRICING_TYPES.FXIED) {
            subtotal = service.fixedPrice || '0';
        }

        // LABOUR & PARTS service pricing
        if (service.pricingType === PRICING_TYPES.LABOUR) {
            const laborAmount = service.amount || '0';

            // qty × (cost + per-unit fee): part.totalAmount is qty × cost only, the fee is billed on
            // its own row and must be counted here too (see partGrossAmount).
            const partsAmount = (service.parts || []).reduce((acc, part) => NumericEngine.add(acc, String(partGrossAmount(part))), '0');

            subtotal = NumericEngine.add(laborAmount, partsAmount);
        }

        serviceSubtotalCache.set(service, subtotal);

        return subtotal;
    };

    // Remove the Redux-based fetchServiceSubCategroy function as we now use TanStack Query

    // Debounced fetch functions
    const fetchAdvisorApi = async (searchTerm) => {
        await dispatch(getAdvisorListApi({ name: searchTerm }));
    };

    const fetchDiscountProgram = async () => {
        let resp = await dispatch(discountProgramApi());
        if (resp.length > 0) {
            setDiscountList(resp);
        }
    };
    const fetchCustomerMembership = async (ID, flag) => {
        let discount = await dispatch(discountProgramApi());
        if (discount.length > 0) {
            setDiscountList(discount);
        }

        let resp;
        if (type != SHOP_IMPORTED) {
            resp = await dispatch(customerDetailApi(ID));
        }
        if (type == SHOP_IMPORTED) {
            resp = await dispatch(importedCustomerDetail(ID));
        }
        resp.fullName = resp?.firstName + ' ' + resp?.lastName;
        resp.refIdUsers = ID;
        resp.refIdImport = ID;
        if (resp?.membershipProgram?._id && resp?.membershipProgram?._id !== '') {
            setCustomermemberShipId(resp.membershipProgram._id);
            if (flag) {
                setDiscountId(resp.membershipProgram._id);
                const selectedDiscount = discount.find((item) => item._id === resp.membershipProgram._id);
                setSelectedDiscount(selectedDiscount);
            }
        } else {
            if (paymentDetails.discount > 0) {
                setDiscountId('custom');
            } else {
                setDiscountId('none');
            }
        }
    };

    const fetchVehicles = async (customerIdArg, vehicleIdToSelectArg) => {
        try {
            setShowLoader(true);
            setVehicleDropdownLoading(true);

            let data;
            if (appointmentId) {
                data = await dispatch(vehicleDetails(10, 1, customerData?._id || customerIdArg));
            } else {
                const userId = customerData?.refIdUsers || customerData?._id || customerIdArg;
                if (userId) {
                    data = await dispatch(vehicleDetails(10, 1, userId));
                }
            }
            if (data) {
                setData(data);

                if (vehicleIdToSelectArg) {
                    let resolvedId = null;

                    if (typeof vehicleIdToSelectArg === 'string') {
                        resolvedId = vehicleIdToSelectArg;
                    } else if (typeof vehicleIdToSelectArg === 'object' && vehicleIdToSelectArg !== null) {
                        resolvedId = resolveSelectedVehicleId(data, vehicleIdToSelectArg);
                    }

                    if (resolvedId) {
                        const filter = data.find((item) => item._id === resolvedId);
                        setSelectedVehicleMake({
                            _id: filter?.vehicleMake?._id,
                            name: filter?.vehicleMake?.name,
                        });

                        setVehicleData(resolvedId);
                        setValue('vehicleId', resolvedId);
                        clearErrors('vehicleId');

                        // Do not auto-open if in edit mode or already selected
                        if (filter?.source === 'shop_imported' && !id && !appointmentId) {
                            setEditVehicleData(filter);
                            handleVehicleOpen();
                        }
                        return;
                    }
                }

                if (data.length == 0 && !id && !appointmentId) {
                    handleVehicleOpen();
                } else if (data.length == 1) {
                    setVehicleData(data[0]?._id);
                    setValue('vehicleId', data[0]?._id);
                    setSelectedVehicleMake({
                        _id: data[0].vehicleMake?._id,
                        name: data[0].vehicleMake?.name,
                    });
                    clearErrors('vehicleId');
                    // Only auto-open if NOT in edit mode
                    if (data[0].source && data[0].source == 'shop_imported' && !id && !appointmentId) {
                        setEditVehicleData(data[0]);
                        handleVehicleOpen();
                    }
                } else if (data.length > 1 && !id && !appointmentId && !location.state?.estimateData?._id) {
                    const autocompleteInput = document.getElementById('vehicle-select-autocomplete');

                    if (autocompleteInput) {
                        const event = new MouseEvent('mousedown', {
                            bubbles: true,
                            cancelable: true,
                            view: window,
                        });
                        autocompleteInput.dispatchEvent(event);
                        setTimeout(() => {
                            autocompleteInput.focus();
                        }, 100);
                    }
                } else {
                    handleCloseCustomerInfo(null, true);
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setVehicleDropdownLoading(false);
            setShowLoader(false);
        }
    };

    const customersLists = async (page, limit, createId, search) => {
        if (customerId) {
            setShowLoader(true);
        }
        try {
            // Cancel previous request if exists
            if (cancelTokenSourceRef.current) {
                cancelTokenSourceRef.current.cancel('Operation canceled due to new request.');
            }
            cancelTokenSourceRef.current = axios.CancelToken.source();

            setCustomerListLoader(true);
            let data;
            data = await dispatch(CustomersListBasedOnType(search || customerSearch, customerTypeData, page, limit, cancelTokenSourceRef.current.token));

            if (data && data.data) {
                // setCustomerDetail(data.data);
                setCustomerDetail(data.data);
                setServicePageData({
                    totalpages: data?.totalPages,
                    currentPage: data?.currentPage,
                });
                if (createId) {
                    setCustomerData(data.data.find((d) => d.refIdUsers === createId));
                    setValue('customerId', createId);
                } else if (id) {
                    if (getValues().customerId) {
                        /*
                         * The list is one page of 50, so a customer outside it is simply missing — and some
                         * customers are keyed by _id rather than refIdUsers. Keep the customer loaded from the
                         * record when the list has no match, instead of clearing it.
                         */
                        const savedCustomerId = getValues().customerId;
                        const selectuser = data.data.find((d) => d.refIdUsers == savedCustomerId || d._id == savedCustomerId);
                        if (selectuser) {
                            setCustomerData(selectuser);
                        }
                    }
                    // setCustomerData(data.data.find((d) => d._id == customerData?._id));
                } else if (appointmentId) {
                    setCustomerData(data.data.find((d) => d._id == customerData?._id));
                } else if (customerId) {
                    setCustomerData(data.data.find((d) => d._id == customerId));
                } else if (location.state?.estimateData?._id) {
                    // setCustomerData(data.data.find((d) => d._id == location.state?.estimateData?.customerId));
                } else {
                    setCustomerData(null);
                }
                setCustomerListLoader(false);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // Request was canceled, ignore
                return;
            }
            setCustomerListLoader(false);
        } finally {
            setShowLoader(false);
        }
        setCheckChangeLoader(false);
    };

    const customerDataDetail = async () => {
        setShowLoader(true);

        let resp;
        if (type != SHOP_IMPORTED) {
            resp = await dispatch(customerDetailApi(customerId));
        }
        if (type == SHOP_IMPORTED) {
            resp = await dispatch(importedCustomerDetail(customerId));
        }
        resp.fullName = resp?.firstName + ' ' + resp?.lastName;
        resp.refIdUsers = customerId;
        resp.refIdImport = customerId;

        setCustomerData(resp);
        setCustomerDetail([resp]);
        setShowLoader(false);
    };

    //Appointment invoice detail

    /**
     * Price for a service carried over from an appointment: the shop service's own fixed price, or the
     * "starting from" price. Anything else (range / no price) starts at 0 for the user to fill in.
     */
    const appointmentServicePrice = (shopService) => {
        if (shopService?.priceType === SHOP_SERVICE_PRICE_TYPES.FIXED && shopService?.fixedPrice != null) return String(shopService.fixedPrice);
        if (shopService?.priceType === SHOP_SERVICE_PRICE_TYPES.STARTING_FROM && shopService?.priceMin != null) return String(shopService.priceMin);
        return 0;
    };

    const fetchAppointmentDetails = async (appointmentId) => {
        setShowLoader(true);
        const resp = await dispatch(appointmentDetails(appointmentId));
        if (resp) {
            const { _id, firstName, lastName } = resp?.customer;
            let fullname = firstName;
            if (lastName) fullname = fullname + ' ' + lastName;
            const v = resp?.vehicle;
            const vehicleStr =
                [v?.vehicleYear || v?.year, v?.vehicleMake?.name, v?.vehicleModel?.name, v?.vehicleModelTrim?.name].filter(Boolean).join(' ') || '—';
            resp.customer = {
                ...resp?.customer,
                refIdUsers: _id,
                fullName: fullname,
            };

            setCustomerData(resp?.customer);
            setVehicleData(resp?.vehicle?._id);
            setValue('customerId', resp?.customer?._id);
            setValue('vehicleId', resp?.vehicle?._id);
            setSelectedVehicleMake({
                _id: resp?.vehicle?.vehicleMake?._id,
                name: resp?.vehicle?.vehicleMake?.name,
            });
            setValue('odoDroppedOff', FormatNumberForKm(resp?.dropOffODO));

            setCustomerTypeData(['shop_created', 'apex_auto_app']);
            if (resp?.customer?.createdFrom == 'shop_created' || resp?.customer?.createdFrom == 'apex_auto_app') {
                setState({ shop_created: true, apex_auto_app: true });
            } else if (resp?.customer?.createdFrom == 'shop_imported') {
                setState({ shop_imported: true });
            }

            const providedDate = resp?.dropOffDateTime ? dayjs(resp?.dropOffDateTime) : null;

            setSelectDate(resp?.dropOffDateTime ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

            setValue('dropOffDate', resp?.dropOffDateTime ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

            const providedDateComplete = resp?.pickupDateTime ? dayjs(resp?.pickupDateTime) : resp?.shopClosingTime ? dayjs(resp?.shopClosingTime) : null;

            setCompletionDate(resp?.shopClosingTime ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);
            setInvoiceDataInStore(
                {
                    ...invoiceDataInStore,
                    appointmentDroppedOffDate: resp?.dropOffDateTime
                        ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : invoiceDataInStore.appointmentDroppedOffDate,
                    appointmentCompletionDate: resp?.shopClosingTime
                        ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                        : invoiceDataInStore.appointmentCompletionDate,
                },
                false
            );
            setValue('completionDate', resp?.shopClosingTime ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

            // Shop services hold the prices; make sure they are loaded before mapping the appointment's.
            const loadedServices = cachedServices.length > 0 ? cachedServices : (await refetchServices())?.data?.data || [];
            const shopServiceById = {};
            loadedServices.forEach((shopService) => {
                if (shopService?.serviceSubCategory?._id) shopServiceById[shopService.serviceSubCategory._id] = shopService;
            });

            let services = [];

            let serviceInd = [];
            if (resp?.services?.length > 0) {
                resp?.services?.map((data, index) => {
                    serviceInd.push(index);
                    let serviceObj = { parts: [] };

                    serviceObj.serviceCategory = data?.serviceCategory;
                    serviceObj.service = {
                        _id: data?.serviceId,
                        name: data?.serviceName,
                    };
                    // Appointment → work order: open the description / fixed price row and carry the
                    // service's own price across (fixed, or "starting from"), like picking it by hand.
                    serviceObj.showDesc = true;
                    serviceObj.fixedPrice = appointmentServicePrice(shopServiceById[data?.serviceId]);
                    serviceObj.pricingType = PRICING_TYPES.FXIED;
                    serviceObj.type = 'select';

                    services.push(serviceObj);
                });
            }
            setServiceExpanded(serviceInd);
            setServiceListPayload(services);
        }
        setShowLoader(false);
    };

    useEffect(() => {
        if (!id) {
            setShowLoader(false);
            return;
        }

        setShowLoader(true);
        async function fetch() {
            const membershipResp = await dispatch(discountProgramApi());
            if (membershipResp.length > 0) {
                setDiscountList(membershipResp);
            }
            const resp = invoiceData;

            if (id && resp) {
                const rr = resp.reviewRequest;
                setIsGoogleReviewDetails({
                    shouldSendInvoiceToCarfax: resp.shouldSendInvoiceToCarfax ?? false,
                    sendGoogleReviewRequest:
                        (rr?.sendGoogleReviewRequest ?? resp.status === 'draft') ? shopConfigData?.config?.invoiceReviewManualSelect : false,
                    customMessage: rr?.customMessage ?? '',
                    shouldSendReviewSMSToCustomer: rr?.shouldSendReviewSMSToCustomer ?? shopConfigData?.config?.shouldSendReviewSMSToCustomer ?? false,
                    shouldSendReviewEmailToCustomer: rr?.shouldSendReviewEmailToCustomer ?? shopConfigData?.config?.shouldSendReviewEmailToCustomer ?? false,
                    shouldSendReviewNotificationToCustomer:
                        rr?.shouldSendReviewNotificationToCustomer ?? shopConfigData?.config?.shouldSendReviewNotificationToCustomer ?? false,
                });

                setLinkedEstimateId(resp?.linkedEstimateId?._id || null);

                // Set appointmentData from invoice's linked appointment (when editing invoice created from appointment)
                if (resp?.appointment?._id) {
                    const appt = resp.appointment;
                    const fullname = appt.customer?.fullName || [appt.customer?.firstName, appt.customer?.lastName].filter(Boolean).join(' ').trim() || '—';
                    const v = appt.vehicle;
                    const vehicleStr = [v?.year, v?.vehicleMake?.name, v?.vehicleModel?.name, v?.vehicleModelTrim?.name].filter(Boolean).join(' ') || '—';
                    const dropOff = appt.dropOffDateTime ? dayjs(appt.dropOffDateTime).tz(USER_TIMEZONE) : null;
                    const dateTimeStr = dropOff ? dropOff.format('DD-MMM-YYYY - hh:mm A') : '—';
                    const servicesCount = appt?.services?.length ? `${appt.services.length} Service${appt.services.length !== 1 ? 's' : ''}` : '0 Services';
                    setAppointmentData({
                        _id: appt._id,
                        status: appt.status,
                        customerName: fullname,
                        appointmentId: appt.appointmentNumber || appt._id?.slice(-6) || '—',
                        vehicle: vehicleStr,
                        dateTime: dateTimeStr,
                        servicesCount,
                    });
                } else {
                    setAppointmentData(null);
                }
                setValue('recommendationNotes', resp?.recommendationNotes);

                setCustomerSearch(resp?.customer?.fullName);
                setValue('customerId', resp.customer?._id);
                setValue('vehicleId', resp.vehicle?._id);
                setCustomerTypeData(['shop_created', 'apex_auto_app']);
                if (resp?.customer?.createdFrom == 'shop_created' || resp?.customer?.createdFrom == 'apex_auto_app') {
                    setState({
                        shop_created: true,
                        apex_auto_app: true,
                        shop_imported: false,
                    });
                } else if (resp?.customer?.createdFrom == 'shop_imported') {
                    setState({ shop_imported: true });
                }
                setVehicleData(resp?.vehicle?._id);
                setSelectedVehicleMake({
                    _id: resp?.vehicle?.vehicleMake?._id,
                    name: resp?.vehicle?.vehicleMake?.name,
                });
                let isFinalized = false;
                if (
                    resp.status === 'sent'
                    //  && !resp.isEmailSent
                ) {
                    setIsFinalizedEmail(true);
                    isFinalized = true;
                }
                const getPaymentMethod = PAYEMNT_METHODS.find((method) => method.key === resp.paymentMethod);
                setValue('paymentMethod', getPaymentMethod);
                const editDiscount = hydrateDiscountFromResponse({
                    subTotal: resp.subTotal || 0,
                    discount: resp.discount || 0,
                    discountPercentage: resp.discountPercentage,
                    discountSource: resp.discountSource,
                    membershipProgramId: resp.membershipProgram?._id,
                    programPercentage: resp.membershipProgram?.discount,
                });
                setPaymentDetails({
                    ...paymentDetails,
                    taxPercentage: resp.taxPercentage ? resp.taxPercentage.toString() : '0',
                    discount: Number(editDiscount.discountValue),
                    discountPercentage: editDiscount.discountPercentage.toString(),
                    discountSource: editDiscount.discountSource,
                });
                // Shared decision (see resolveTaxPreservation): a NEW-tax invoice keeps its own tax
                // setup only while the account tax settings have not moved on since it was last saved.
                // Account settings edited AFTER this invoice's last update → line taxes reset to the
                // current account defaults (customChange clears itself, since each line then matches the
                // default) with a toast. A LEGACY invoice keeps its untouched legacy behavior.
                const { sourceIsNew, preserveTax } = resolveTaxPreservation(resp, shopTaxesData);
                // Keep source per-line taxes for a preserved new-tax invoice; a legacy invoice uses no
                // per-line tax so the value is a no-op there. New source + changed settings → drop to
                // undefined (current account defaults).
                const keepSourceLineTax = sourceIsNew ? preserveTax : true;
                if (sourceIsNew) {
                    // NEW-tax invoice.
                    // PRESERVE (account settings unchanged since save) → keep the source's global tax
                    //   rows verbatim; per-line breakdowns were kept above via keepSourceLineTax.
                    // RESET (account settings changed since) → seed the global rows from the current
                    //   shop account defaults. This must be an explicit build, NOT [] — on an EDIT the
                    //   record has an id, and resolveBreakdownForCalc returns [] unchanged for an id
                    //   (empty means "GET hasn't loaded yet"), so [] would leave the summary with no
                    //   tax rows and zero tax. Per-line/fees already fell back to defaults via
                    //   keepSourceLineTax, so customChange clears itself.
                    setIsNewTaxVersionActive(true);
                    setTaxesBreakdown(
                        preserveTax
                            ? normalizeTaxesBreakdownFromResponse(resp.taxesBreakdown, DOCUMENT_TAX_TYPE.WORK_ORDER)
                            : buildTaxesBreakdownFromShopTaxes(shopTaxesData, DOCUMENT_TAX_TYPE.WORK_ORDER)
                    );
                    if (!preserveTax) {
                        showTaxSettingsNotice(
                            'Tax settings have changed since this invoice was last saved – invoice has been updated to reflect your current tax settings.'
                        );
                    }
                } else {
                    // Legacy invoice → untouched legacy behavior.
                    setIsNewTaxVersionActive(false);
                    setTaxesBreakdown([]);
                }
                setValue('customerPO', resp?.customerPO);
                setValue('note', resp?.note);
                authorizationSeededRef.current = true;
                setAuthorizationText(resp?.authorizationMessage || defaultAuthorizationText);
                // setValue('invoicePreparedBy', resp?.invoicePreparedBy);

                setValue('serviceAdvisor', resp?.serviceAdvisor?._id || resp?.serviceAdvisor);

                // The record carries `mileage` and `workOrderDate` (spec §14.5)
                setValue('odoDroppedOff', FormatNumberForKm(resp?.mileage));

                const provideInvoicedDate = dayjs(resp?.workOrderDate);
                setSelectInvoiceDate(resp?.workOrderDate ? dayjs(dayjs(provideInvoicedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

                setValue('invoiceDate', resp?.workOrderDate ? dayjs(dayjs(provideInvoicedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

                const providedDate = dayjs(resp?.appointmentDroppedOffDate);

                setSelectDate(resp?.appointmentDroppedOffDate ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

                setValue('dropOffDate', resp?.appointmentDroppedOffDate ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);
                const providedDateComplete = dayjs(resp?.appointmentCompletionDate);

                setCompletionDate(resp?.appointmentCompletionDate ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);
                setValue('completionDate', resp?.appointmentCompletionDate ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD')) : null);

                setInvoiceDataInStore(
                    {
                        ...invoiceDataInStore,
                        invoiceDate: resp?.invoiceDate
                            ? dayjs(dayjs(provideInvoicedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                            : invoiceDataInStore.invoiceDate,
                        appointmentDroppedOffDate: resp?.appointmentDroppedOffDate
                            ? dayjs(dayjs(providedDate).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                            : invoiceDataInStore.appointmentDroppedOffDate,
                        appointmentCompletionDate: resp?.appointmentCompletionDate
                            ? dayjs(dayjs(providedDateComplete).tz(USER_TIMEZONE).format('YYYY-MM-DD'))
                            : invoiceDataInStore.appointmentCompletionDate,
                    },
                    false
                );
                let services = [];
                let serviceInd = [];
                const batchQtyMap = {};
                let finalizedInventory = {};
                resp?.services?.map((data, serviceIndex) => {
                    serviceInd.push(serviceIndex);
                    let serviceObj = { parts: [] };

                    if (data.pricingType === PRICING_TYPES.NOPRICE) {
                    }

                    if (data.pricingType === PRICING_TYPES.FXIED) {
                        serviceObj.serviceCategory = data?.serviceId?.serviceCategory;

                        serviceObj.service = {
                            _id: data?.serviceId?._id || data?.serviceId,
                            name: data?.serviceId?.name || data?.serviceName,
                        };
                        serviceObj.fixedPrice = data?.fixedPrice;
                        serviceObj.showDesc = true;
                        if (data?.description) {
                            serviceObj.optionalDescription = data?.description;
                        }
                        serviceObj.pricingType = data?.pricingType;
                        serviceObj.type = 'select';
                        serviceObj.taxesBreakdown = keepSourceLineTax ? data?.taxesBreakdown : undefined;
                    }

                    if (data.pricingType === PRICING_TYPES.LABOUR) {
                        if (data?.labor?.qty && data?.labor?.ratePerHour) {
                            serviceObj.qty = data?.labor?.qty;
                            serviceObj.ratePerHour = data?.labor?.ratePerHour;
                            const qty = Number(data?.labor?.qty) || 0;
                            const rate = Number(data?.labor?.ratePerHour) || 0;
                            serviceObj.amount = qty && rate ? Number(NumericEngine.multiply(qty, rate)) : 0;
                        }

                        serviceObj.serviceCategory = data?.serviceId?.serviceCategory;
                        serviceObj.service = {
                            _id: data?.serviceId?._id || data?.serviceId,
                            name: data?.serviceId?.name || data?.serviceName,
                        };
                        if (data?.description) {
                            serviceObj.showDesc = true;
                            serviceObj.optionalDescription = data?.description;
                        }

                        serviceObj.pricingType = data?.pricingType;
                        serviceObj.type = 'select';
                        // rehydrateLabourLineTaxes: un-bake the Florida labour-only suppression that the SAVE
                        // wrote into this line, so it goes back to being a live mask over the account default.
                        // Without it, adding a part in EDIT leaves labour stuck on the stored N/T.
                        // No-op unless this record is a Florida labour-only one.
                        serviceObj.taxesBreakdown = keepSourceLineTax
                            ? rehydrateLabourLineTaxes(data?.labor?.taxesBreakdown, shopTaxesData, {
                                  provinceTaxGroup,
                                  hasPartsOrPackages: recordHasPartsOrPackages(resp),
                              })
                            : undefined;
                        if (data.parts?.length > 0) {
                            data.parts.map((prt, prtIndex) => {
                                if (isFinalized && prt?.inventoryId) {
                                    finalizedInventory[prt.inventoryId] = (finalizedInventory[prt.inventoryId] || 0) + prt.totalQty;
                                }
                                let part;
                                if (prt.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED || !prt?.inventoryType) {
                                    part = {
                                        partFromApi: true,
                                        _id: prt?.inventoryId || prt?.inventory?._id,
                                        partsType: prt?.partsType ?? prt?.part?.partsType,
                                        part: {
                                            _id: prt?.part?._id,
                                            partsType: prt?.partsType ?? prt?.part?.partsType,
                                            partName: prt?.partName,
                                        },
                                        supplier: {
                                            _id: prt?.supplier?._id,
                                            name: prt?.supplier?.name,
                                        },
                                        partsBrand: {
                                            _id: prt?.partsBrand?._id,
                                            name: prt?.partsBrand?.name,
                                        },
                                        partsCategory: {
                                            _id: prt?.partsCategory?._id,
                                            name: prt?.partsCategory?.name,
                                        },
                                        inventoryType: prt?.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                                        taxesBreakdown: keepSourceLineTax ? prt?.taxesBreakdown : undefined,
                                        fee: prt?.fee,
                                        feeAmount: NumericEngine.format(prt?.feeAmount || 0),
                                        batchNumber: prt?.batchNumber,
                                        partCost: NumericEngine.format(prt?.cost),
                                        partQty: prt?.totalQty,
                                        description: prt?.lastDescription || prt?.description,
                                        partNumber: prt?.partNumber,
                                        tyreDimension: prt?.tyreDimension,
                                        partsProvider: prt?.partsProvider,
                                        retailPrice: Number(prt?.cost),
                                        totalAmount: NumericEngine.format(prt.totalAmount),
                                        batchArray:
                                            prt?.inventoryBatches?.length > 0
                                                ? prt.inventoryBatches.map((batch, batchIndex) => {
                                                      if (batchQtyMap[batch.batchNumber]) {
                                                          batchQtyMap[batch.batchNumber] += batch.qty;
                                                      } else {
                                                          batchQtyMap[batch.batchNumber] = batch.qty;
                                                      }
                                                      return {
                                                          outerIndex: serviceIndex,
                                                          innerIndex: prtIndex,
                                                          batchIndex: batchIndex,
                                                          batchNumber: batch.batchNumber,
                                                          batchQty: batch.qty,
                                                      };
                                                  })
                                                : [],
                                    };
                                } else {
                                    part = {
                                        inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                        partName: prt.partName,
                                        partQty: prt.totalQty,
                                        partCost: NumericEngine.format(prt?.cost),
                                        totalAmount: NumericEngine.format(prt.totalAmount),
                                        taxesBreakdown: keepSourceLineTax ? prt?.taxesBreakdown : undefined,
                                    };
                                }

                                part.partRowId = createPartRowId();
                                serviceObj.parts.push(part);
                            });
                        }
                    }

                    services.push(serviceObj);
                });
                setFinalizedInventoryCount(finalizedInventory);
                setUsedBatchQty(batchQtyMap);
                setServiceExpanded(serviceInd);
                if (resp && resp?.vehicle && resp?.vehicle?._id) {
                    setVehicleData(resp?.vehicle?._id);
                    setSelectedVehicleMake({
                        _id: resp?.vehicle?.vehicleMake?._id,
                        name: resp?.vehicle?.vehicleMake?.name,
                    });
                }
                setServiceListPayload(services);

                if (resp?.membershipProgram?._id && resp?.membershipProgram?._id !== '') {
                    setDiscountId(resp.membershipProgram._id);
                    if (membershipResp.length > 0) {
                        const sd = membershipResp.find((item) => item._id === resp.membershipProgram._id);
                        setSelectedDiscount(sd);
                    }
                } else {
                    if (resp?.discount) {
                        setDiscountId('custom');
                    } else {
                        setDiscountId('none');
                    }
                }

                let feesArray = [];
                if (resp?.fees?.length > 0) {
                    resp.fees.map((item, index) => {
                        const calcType = item?.feesCalculationType || (Number(item?.feesAmount) > 0 ? 'fixed_amount' : 'percentage');
                        const hasId = !!item?.feesId?._id;
                        feesArray.push({
                            calculationType: calcType,
                            _id: item?.feesId?._id || null,
                            name: item?.feesName || item?.feesId?.name || '',
                            amount: item?.feesAmount,
                            percentage: item?.feesPercentage,
                            isDefaultInvoice: item?.isDefaultInvoice,
                            isDefaultEstimate: item?.isDefaultEstimate,
                            isDefaultWorkOrder: item?.isDefaultWorkOrder,
                            taxesBreakdown: keepSourceLineTax ? item?.taxesBreakdown : undefined,
                            ...(hasId ? {} : { forceSaveEnabled: true }),
                        });
                    });
                }

                setSelectedFees(feesArray);

                if (resp?.payments?.length > 0) {
                    setPaymentMethods(resp.payments);
                }
            }
        }

        // Always load the work order, the sync route included — the estimate is overlaid on top of it.
        fetch().then(() => setTargetHydrated(true));

        setShowLoader(false);
    }, [dispatch, id, invoiceData]);

    useEffect(() => {
        const fetchDuplicateApi = async () => {
            const membershipResp = await dispatch(discountProgramApi());
            if (membershipResp.length > 0) {
                setDiscountList(membershipResp);
            }
            let resp = duplicateInvoiceData;

            if (resp?._id) {
                authorizationSeededRef.current = true;
                setAuthorizationText(resp?.authorizationMessage || defaultAuthorizationText);

                let services = [];
                let serviceInd = [];
                const batchQtyMap = {};
                let finalizedInventory = {};
                resp?.services?.map((data, serviceIndex) => {
                    serviceInd.push(serviceIndex);
                    let serviceObj = { parts: [] };

                    if (data.pricingType === PRICING_TYPES.NOPRICE) {
                    }
                    if (data.pricingType === PRICING_TYPES.FXIED) {
                        serviceObj.serviceCategory = data?.serviceId?.serviceCategory;

                        serviceObj.service = {
                            _id: data?.serviceId?._id || data?.serviceId,
                            name: data?.serviceId?.name || data?.serviceName,
                        };
                        serviceObj.fixedPrice = data?.fixedPrice;
                        serviceObj.showDesc = true;
                        if (data?.description) {
                            serviceObj.optionalDescription = data?.description;
                        }
                        serviceObj.pricingType = data?.pricingType;
                        serviceObj.type = 'select';
                        serviceObj.taxesBreakdown = data?.taxesBreakdown;
                    }

                    if (data.pricingType === PRICING_TYPES.LABOUR) {
                        if (data?.labor?.qty && data?.labor?.ratePerHour) {
                            serviceObj.qty = data?.labor?.qty;
                            serviceObj.ratePerHour = data?.labor?.ratePerHour;
                            const qty = Number(formatDecimalNumber(data?.labor?.qty)) || 0;
                            const rate = Number(formatDecimalNumber(data?.labor?.ratePerHour)) || 0;
                            serviceObj.amount = qty && rate ? Number(NumericEngine.multiply(qty, rate)) : 0;
                        }

                        serviceObj.serviceCategory = data?.serviceId?.serviceCategory;
                        serviceObj.service = {
                            _id: data?.serviceId?._id || data?.serviceId,
                            name: data?.serviceId?.name || data?.serviceName,
                        };
                        if (data?.description) {
                            serviceObj.showDesc = true;
                            serviceObj.optionalDescription = data?.description;
                        }

                        serviceObj.pricingType = data?.pricingType;
                        serviceObj.type = 'select';
                        // Same un-bake as the edit flow above — see rehydrateLabourLineTaxes.
                        serviceObj.taxesBreakdown = rehydrateLabourLineTaxes(data?.labor?.taxesBreakdown, shopTaxesData, {
                            provinceTaxGroup,
                            hasPartsOrPackages: recordHasPartsOrPackages(resp),
                        });
                        if (data.parts?.length > 0) {
                            data.parts.map((prt, prtIndex) => {
                                let part;
                                if (prt.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED || !prt?.inventoryType) {
                                    part = {
                                        partFromApi: true,
                                        _id: prt?.inventoryId || prt?.inventory?._id,
                                        partsType: prt?.partsType ?? prt?.part?.partsType,
                                        part: {
                                            _id: prt?.part?._id,
                                            partsType: prt?.partsType ?? prt?.part?.partsType,
                                            partName: prt?.partName,
                                        },
                                        supplier: {
                                            _id: prt?.supplier?._id,
                                            name: prt?.supplier?.name,
                                        },
                                        partsBrand: {
                                            _id: prt?.partsBrand?._id,
                                            name: prt?.partsBrand?.name,
                                        },
                                        partsCategory: {
                                            _id: prt?.partsCategory?._id,
                                            name: prt?.partsCategory?.name,
                                        },
                                        inventoryType: prt?.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                                        taxesBreakdown: prt?.taxesBreakdown,
                                        fee: prt?.fee,
                                        feeAmount: NumericEngine.format(prt?.feeAmount || 0),
                                        batchNumber: prt?.batchNumber,
                                        partCost: formatDecimalNumber(prt?.cost),
                                        partQty: prt?.formatNumberDecimaWithoutRoundoff || part?.qty || 0,
                                        description: prt?.lastDescription || prt?.description,
                                        partNumber: prt?.partNumber,
                                        tyreDimension: prt?.tyreDimension,
                                        partsProvider: prt?.partsProvider,
                                        retailPrice: Number(prt?.cost),
                                        totalAmount: NumericEngine.format(prt.totalAmount),
                                        batchArray:
                                            prt?.inventoryBatches?.length > 0
                                                ? prt.inventoryBatches.map((batch, batchIndex) => {
                                                      if (batchQtyMap[batch.batchNumber]) {
                                                          batchQtyMap[batch.batchNumber] += batch.qty;
                                                      } else {
                                                          batchQtyMap[batch.batchNumber] = batch.qty;
                                                      }
                                                      return {
                                                          outerIndex: serviceIndex,
                                                          innerIndex: prtIndex,
                                                          batchIndex: batchIndex,
                                                          batchNumber: batch.batchNumber,
                                                          batchQty: batch.qty,
                                                      };
                                                  })
                                                : [],
                                    };
                                } else {
                                    part = {
                                        inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                        partName: prt.partName,
                                        partQty: prt.totalQty,
                                        partCost: NumericEngine.format(prt?.cost),
                                        totalAmount: NumericEngine.format(prt.totalAmount),
                                        taxesBreakdown: prt?.taxesBreakdown,
                                    };
                                }

                                part.partRowId = createPartRowId();
                                serviceObj.parts.push(part);
                            });
                        }
                    }

                    services.push(serviceObj);
                });
                setUsedBatchQty(batchQtyMap);
                setServiceExpanded(serviceInd);
                if (resp && resp?.vehicle && resp?.vehicle?._id) {
                    setVehicleData(resp?.vehicle?._id);
                    setSelectedVehicleMake({
                        _id: resp?.vehicle?.vehicleMake?._id,
                        name: resp?.vehicle?.vehicleMake?.name,
                    });
                }
                setServiceListPayload(services);

                if (resp?.membershipProgram?._id && resp?.membershipProgram?._id !== '') {
                    setDiscountId(resp.membershipProgram._id);
                    if (membershipResp.length > 0) {
                        const sd = membershipResp.find((item) => item._id === resp.membershipProgram._id);
                        setSelectedDiscount(sd);
                    }
                } else {
                    if (resp?.discount) {
                        setDiscountId('custom');
                    } else {
                        setDiscountId('none');
                    }
                }

                let feesArray = [];
                if (resp?.fees?.length > 0) {
                    resp.fees.map((item, index) => {
                        const calcType = item?.feesCalculationType || (Number(item?.feesAmount) > 0 ? 'fixed_amount' : 'percentage');
                        const hasId = !!item?.feesId?._id;
                        feesArray.push({
                            isEdit: true,
                            calculationType: calcType,
                            _id: item?.feesId?._id || null,
                            name: item?.feesName || item?.feesId?.name || '',
                            amount: item?.feesAmount,
                            percentage: item?.feesPercentage,
                            ...(hasId ? {} : { forceSaveEnabled: true }),
                        });
                    });
                }

                setSelectedFees(feesArray);
                const dupDiscount = hydrateDiscountFromResponse({
                    subTotal: resp.subTotal || 0,
                    discount: resp.discount || 0,
                    discountPercentage: resp.discountPercentage,
                    discountSource: resp.discountSource,
                    membershipProgramId: resp.membershipProgram?._id,
                    programPercentage: resp.membershipProgram?.discount,
                });
                setPaymentDetails({
                    ...paymentDetails,
                    discount: Number(dupDiscount.discountValue),
                    discountPercentage: dupDiscount.discountPercentage.toString(),
                    discountSource: dupDiscount.discountSource,
                });
            }
        };

        if (duplicateInvoiceData?._id) {
            fetchDuplicateApi();
        }
    }, [duplicateInvoiceData]);

    useEffect(() => {
        const isSyncEditRoute = pathname.includes('edit-from-estimate') && id;
        const fetchEstimateApi = async () => {
            setShowLoader(true); // Show loader immediately when processing estimate data
            try {
                const membershipResp = await dispatch(discountProgramApi());
                if (membershipResp.length > 0) {
                    setDiscountList(membershipResp);
                }
                const resp = location.state?.estimateData;
                const fullEstimate = resp?._id ? await dispatch(estimateData(resp._id)) : null;
                const source = fullEstimate || resp;

                console.log('🚀 ~ fetchEstimateApi ~ resp:', resp);
                if (source?._id) {
                    setLinkedEstimateId(source._id);
                    // On a refresh the work order keeps its own authorization wording; only a new work
                    // order takes the estimate's (or the shop default).
                    if (!isSyncEditRoute) {
                        authorizationSeededRef.current = true;
                        setAuthorizationText(source?.authorizationMessage || defaultAuthorizationText);
                    }

                    // Estimate → work order is ALWAYS a new-tax record, and work orders share the
                    // invoice tax rate (spec §8.3), so this is the same decision the invoice makes
                    // (see resolveTaxPreservation): keep the estimate's own per-line + summary tax
                    // choices only for a NEW-tax estimate whose account settings have not changed
                    // since it was saved. A legacy estimate, or one whose account tax settings moved
                    // on since, resets every line to the current account defaults, with a notice.
                    const { preserveTax } = resolveTaxPreservation(source, shopTaxesData);
                    const keepSourceLineTax = preserveTax;

                    let services = [];
                    let serviceInd = [];
                    const batchQtyMap = {};
                    source?.services?.map((data, serviceIndex) => {
                        serviceInd.push(serviceIndex);
                        let serviceObj = { parts: [] };

                        if (data.pricingType === PRICING_TYPES.FXIED) {
                            serviceObj.serviceCategory = data?.serviceId?.serviceCategory;

                            serviceObj.service = {
                                _id: data?.serviceId?._id || data?.serviceId,
                                name: data?.serviceId?.name || data?.serviceName,
                            };
                            serviceObj.fixedPrice = data?.fixedPrice;
                            serviceObj.showDesc = true;
                            if (data?.description) {
                                serviceObj.optionalDescription = data?.description;
                            }
                            serviceObj.pricingType = data?.pricingType;
                            serviceObj.type = 'select';
                            serviceObj.taxesBreakdown = keepSourceLineTax ? data?.taxesBreakdown : undefined;
                        }

                        if (data.pricingType === PRICING_TYPES.LABOUR) {
                            if (data?.labor?.qty && data?.labor?.ratePerHour) {
                                serviceObj.qty = data?.labor?.qty;
                                serviceObj.ratePerHour = data?.labor?.ratePerHour;
                                const qty = Number(formatDecimalNumber(data?.labor?.qty)) || 0;
                                const rate = Number(formatDecimalNumber(data?.labor?.ratePerHour)) || 0;
                                serviceObj.amount = qty && rate ? Number(NumericEngine.multiply(qty, rate)) : 0;
                            }

                            serviceObj.serviceCategory = data?.serviceId?.serviceCategory;
                            serviceObj.service = {
                                _id: data?.serviceId?._id || data?.serviceId,
                                name: data?.serviceId?.name || data?.serviceName,
                            };
                            if (data?.description) {
                                serviceObj.showDesc = true;
                                serviceObj.optionalDescription = data?.description;
                            }

                            serviceObj.pricingType = data?.pricingType;
                            serviceObj.type = 'select';
                            // Same un-bake as the edit flow — see rehydrateLabourLineTaxes. The estimate's
                            // labour suppression must not survive as an explicit choice on the invoice.
                            serviceObj.taxesBreakdown = keepSourceLineTax
                                ? rehydrateLabourLineTaxes(data?.labor?.taxesBreakdown, shopTaxesData, {
                                      provinceTaxGroup,
                                      hasPartsOrPackages: recordHasPartsOrPackages(source),
                                  })
                                : undefined;
                            if (data.parts?.length > 0) {
                                // Estimate parts are inventory-backed, so they carry across with their
                                // inventory record and batches — same shape the edit flow rebuilds.
                                data.parts.map((prt, prtIndex) => {
                                    if (prt.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED || !prt?.inventoryType) {
                                        serviceObj.parts.push({
                                            partFromApi: true,
                                            _id: prt?.inventoryId || prt?.inventory?._id,
                                            partsType: prt?.partsType ?? prt?.part?.partsType,
                                            part: {
                                                _id: prt?.part?._id,
                                                partsType: prt?.partsType ?? prt?.part?.partsType,
                                                partName: prt?.partName,
                                            },
                                            supplier: { _id: prt?.supplier?._id, name: prt?.supplier?.name },
                                            partsBrand: { _id: prt?.partsBrand?._id, name: prt?.partsBrand?.name },
                                            partsCategory: { _id: prt?.partsCategory?._id, name: prt?.partsCategory?.name },
                                            inventoryType: INVENTORY_MANAGE_TYPE.MANAGED,
                                            fee: prt?.fee,
                                            feeAmount: NumericEngine.format(prt?.feeAmount || 0),
                                            batchNumber: prt?.batchNumber,
                                            partCost: NumericEngine.format(prt?.cost),
                                            partQty: prt?.totalQty ?? Number(prt?.qty),
                                            description: prt?.lastDescription || prt?.description,
                                            partNumber: prt?.partNumber,
                                            tyreDimension: prt?.tyreDimension,
                                            partsProvider: prt?.partsProvider,
                                            retailPrice: Number(prt?.cost),
                                            totalAmount: NumericEngine.format(prt.totalAmount),
                                            batchArray:
                                                prt?.inventoryBatches?.length > 0
                                                    ? prt.inventoryBatches.map((batch, batchIndex) => {
                                                          batchQtyMap[batch.batchNumber] = (batchQtyMap[batch.batchNumber] || 0) + batch.qty;
                                                          return {
                                                              outerIndex: serviceIndex,
                                                              innerIndex: prtIndex,
                                                              batchIndex: batchIndex,
                                                              batchNumber: batch.batchNumber,
                                                              batchQty: batch.qty,
                                                          };
                                                      })
                                                    : [],
                                            partRowId: createPartRowId(),
                                            taxesBreakdown: keepSourceLineTax ? prt?.taxesBreakdown : undefined,
                                        });
                                        return;
                                    }
                                    let part = {
                                        inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                        partName: prt.partName,
                                        partQty: prt?.totalQty ?? Number(prt?.qty),
                                        partCost: NumericEngine.format(prt?.cost),
                                        totalAmount: NumericEngine.format(prt.totalAmount),
                                        partRowId: createPartRowId(),
                                        taxesBreakdown: keepSourceLineTax ? prt?.taxesBreakdown : undefined,
                                    };
                                    serviceObj.parts.push(part);
                                });
                            }
                        }

                        services.push(serviceObj);
                    });
                    setServiceExpanded(serviceInd);
                    if (source && source?.vehicle && source?.vehicle?._id) {
                        setVehicleData(source?.vehicle?._id);
                        setSelectedVehicleMake({
                            _id: source?.vehicle?.vehicleMake?._id,

                            name: source?.vehicle?.vehicleMake?.name,
                        });
                    }
                    setServiceListPayload(services);

                    let sd = null;
                    if (source?.membershipProgram?._id && source?.membershipProgram?._id !== '') {
                        setCustomermemberShipId(source.membershipProgram._id);
                        setDiscountId(source.membershipProgram._id);
                        if (membershipResp.length > 0) {
                            sd = membershipResp.find((item) => item._id === source.membershipProgram._id);
                            setSelectedDiscount(sd);
                        }
                    } else {
                        if (source?.discount) {
                            setDiscountId('custom');
                        } else {
                            setDiscountId('none');
                        }
                    }

                    let feesArray = [];
                    if (source?.fees?.length > 0) {
                        source.fees.map((item, index) => {
                            const calcType = item?.feesCalculationType || (Number(item?.feesAmount) > 0 ? 'fixed_amount' : 'percentage');
                            const hasId = !!item?.feesId?._id;
                            feesArray.push({
                                isEdit: true,
                                calculationType: calcType,
                                _id: item?.feesId?._id || null,
                                name: item?.feesName || item?.feesId?.name || '',
                                amount: item?.feesAmount,
                                percentage: item?.feesPercentage,
                                taxesBreakdown: keepSourceLineTax ? item?.taxesBreakdown : undefined,
                                ...(hasId ? {} : { forceSaveEnabled: true }),
                            });
                        });
                    }

                    setSelectedFees(feesArray);

                    if (invoiceData?.payments?.length > 0) {
                        setPaymentMethods(invoiceData?.payments);
                    }

                    const subTotal = source.subTotal || 0;

                    const estimateDiscount = hydrateDiscountFromResponse({
                        subTotal,
                        discount: source?.discount || 0,
                        discountPercentage: source?.discountPercentage,
                        discountSource: source?.discountSource,
                        membershipProgramId: sd?._id,
                        programPercentage: sd?.discount,
                    });
                    const discountValue = estimateDiscount.discountValue;
                    const discountPercentage = estimateDiscount.discountPercentage;
                    const discountSource = estimateDiscount.discountSource;

                    // Calculate fees if applicable
                    let totalFeesAmount = '0';
                    if (feesArray?.length > 0) {
                        totalFeesAmount = feesArray.reduce((acc, fee) => {
                            const feePercentage = Number(fee.percentage) || 0;
                            const feeAmount = NumericEngine.divide(NumericEngine.multiply(subTotal, feePercentage), 100);
                            return NumericEngine.add(acc, feeAmount);
                        }, '0');
                    }

                    // The invoice is new-tax: seed the global tax rows, then let the multi-tax recalc
                    // effect compute tax + total from them (per-line, round-then-sum). PRESERVE keeps
                    // the estimate's summary on/off overlaid on the INVOICE rates; RESET seeds pure
                    // account defaults. Build them explicitly (not []) — the edit-from-estimate
                    // route carries an id, and resolveBreakdownForCalc returns [] unchanged for an id.
                    setIsNewTaxVersionActive(true);
                    setTaxesBreakdown(
                        preserveTax
                            ? buildInvoiceBreakdownFromEstimate(source?.taxesBreakdown, shopTaxesData, DOCUMENT_TAX_TYPE.WORK_ORDER)
                            : buildTaxesBreakdownFromShopTaxes(shopTaxesData, DOCUMENT_TAX_TYPE.WORK_ORDER)
                    );
                    if (!preserveTax) {
                        showTaxSettingsNotice(
                            'Estimate was created with a different tax rate. This work order has been updated to reflect your current tax settings.'
                        );
                    }

                    // Seed the money bases; tax + total are (re)computed by the recalc effect.
                    const taxableAmount = NumericEngine.subtract(NumericEngine.add(subTotal, totalFeesAmount), discountValue);
                    setPaymentDetails({
                        ...paymentDetails,
                        subTotal: Number(subTotal),
                        discountPercentage: discountPercentage.toString(),
                        discount: Number(discountValue),
                        discountSource,
                        tax: 0,
                        taxPercentage: '0',
                        fees: Number(totalFeesAmount),
                        total: Number(taxableAmount),
                    });
                    // Pre-fill other fields
                    setValue('customerId', source?.customer?._id);
                    setCustomerData(source?.customer);
                    setValue('vehicleId', source?.vehicle?._id);
                    setValue('customerPO', source?.customerPO);
                    setValue('note', source?.note);
                    setValue('recommendationNotes', source?.recommendationNotes || '');
                    setValue('odoDroppedOff', FormatNumberForKm(source?.odo));
                    setValue('serviceAdvisor', source?.serviceAdvisor?._id || source?.serviceAdvisor || undefined);
                    setUsedBatchQty(batchQtyMap);

                    // Handle dates if needed, or leave as current date
                }
            } catch (error) {
                console.error('Error fetching estimate data:', error);
            } finally {
                setShowLoader(false); // Hide loader after processing is complete
            }
        };

        if (location.state?.estimateData?._id) {
            const isSyncEdit = pathname.includes('edit-from-estimate') && id;
            // The sync route overlays the estimate onto the loaded work order, so wait for that load.
            if (isSyncEdit && (!invoiceData?._id || !targetHydrated)) return;
            // The tax preserve/reset decision + the invoice tax rows are built from shop taxes. Hold
            // the loader until they load, then convert exactly once (ref stops a shop-taxes refetch
            // from re-hydrating and wiping edits) — so the loader runs from the start and only closes
            // once the converted data is set.
            if (!shopTaxesData) {
                setShowLoader(true);
                return;
            }
            if (conversionInitRef.current) return;
            conversionInitRef.current = true;
            fetchEstimateApi();
        }
    }, [location.state, invoiceData, shopTaxesData, targetHydrated]);

    const applyTermsToForm = useCallback(
        (item) => {
            const value = toTermsFormValue(item);
            setValue('termsAndWarranty', value);
            if (!value) {
                if (invoiceDataInStore?.termsAndWarranty) {
                    const { termsAndWarranty, ...rest } = invoiceDataInStore;
                    setInvoiceDataInStore(rest);
                }
            } else {
                setInvoiceDataInStore({ ...invoiceDataInStore, termsAndWarranty: value });
            }
        },
        [setValue, invoiceDataInStore, setInvoiceDataInStore]
    );

    useEffect(() => {
        if (id || duplicateInvoiceData?._id || location.state?.estimateData?._id) return;
        if (!termsOptions.length || termsLoading) return;
        if (isTermsInitializedRef.current) return;

        const current = getValues('termsAndWarranty');
        if (current?.title && current?.description) {
            isTermsInitializedRef.current = true;
            return;
        }

        const defaultTerm = termsOptions.find(termIsInvoiceDefault);
        if (defaultTerm) {
            applyTermsToForm(defaultTerm);
        }
        isTermsInitializedRef.current = true;
    }, [id, duplicateInvoiceData, location.state?.estimateData?._id, termsOptions, termsLoading, getValues, applyTermsToForm]);

    // Edit: invoice API often returns title/description without _id; link to shop option when list loads
    useEffect(() => {
        if (!id || termsLoading || !termsOptions.length) return;

        const current = getValues('termsAndWarranty');
        if (!current?.title) return;

        const resolvedId = resolveTermsOptionId(current, termsOptions);
        if (!resolvedId) return;

        if (normalizeTermId(current._id) === resolvedId && current?.description) return;

        const matched = termsOptions.find((o) => normalizeTermId(o._id) === resolvedId);
        if (matched) {
            setValue('termsAndWarranty', toTermsFormValue(matched));
            return;
        }

        setValue('termsAndWarranty', {
            ...current,
            _id: resolvedId,
        });
    }, [id, termsOptions, termsLoading, getValues, setValue]);

    const handleNewTerms = () => {
        setTermsModalMode('add');
        setTermsModalInitial({ title: '', description: '' });
        setOpenTermsModal(true);
    };

    const handleEditTerms = () => {
        const current = getValues('termsAndWarranty');
        const resolvedId = resolveTermsOptionId(current, termsOptions);
        const item = termsOptions.find((o) => o._id === resolvedId) || current;
        setTermsModalMode('edit');
        setTermsModalInitial({
            _id: resolvedId || item?._id,
            title: item?.title || '',
            description: item?.description || '',
            isInvoiceDefault: Boolean(item?.isInvoiceDefault ?? item?.isDefaultInvoice),
            isEstimateDefault: Boolean(item?.isEstimateDefault ?? item?.isDefaultEstimate),
        });
        setOpenTermsModal(true);
    };

    const handleTermsModalSuccess = (saved) => {
        applyTermsToForm(saved);
    };

    const handleTermsDeleted = () => {
        applyTermsToForm(null);
    };

    const removeServicesClicked = (idx) => {
        const newdata = [...allService];
        let newArray = [...newdata.slice(0, idx), ...newdata.slice(idx + 1)];
        setAllServices(newArray);
    };
    const EditServiceHandler = (idx) => {
        handleOpenServiceModal();
        setEditServiceData({ edit: true, index: idx });
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSubmit(onSubmitInvoice)();
        }
    };
    async function handleInputChange(newInputValue) {
        setCustomerSearch(newInputValue);
        setCustomerDetail([]);
        try {
            // Cancel previous request if exists
            if (cancelTokenSourceRef.current) {
                cancelTokenSourceRef.current.cancel('Operation canceled due to new request.');
            }
            cancelTokenSourceRef.current = axios.CancelToken.source();

            setCustomerListLoader(true);
            let data;
            data = await dispatch(CustomersListBasedOnType(newInputValue, customerTypeData, 1, customerLimit, cancelTokenSourceRef.current.token));
            if (data && data.data) {
                setCustomerDetail(data.data);
                setCustomerListLoader(false);
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // Request was canceled, ignore
                return;
            }
            setCustomerListLoader(false);
        }
    }
    const debouncedHandleInputChange = debounce(handleInputChange, 300);
    const handleInputDebounced = (event, newInputValue) => {
        debouncedHandleInputChange(newInputValue);
    };

    const handleCheckChange = (event) => {
        setCheckChangeLoader(true);

        setCustomerDetail([]);
        setCustomerSearch('');
        setPage(1);
        if (event.target.name && event.target.checked == true) {
            setCustomerTypeData((prevArray) => [...prevArray, event.target.name]);
        } else {
            const filterData = customerTypeData.filter((value) => value !== event.target.name);
            setCustomerTypeData(filterData);
        }
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    const handleBlur = () => {
        if (customerSearch != '') {
            setCustomerSearch('');
            handleInputChange(''); // Clear the search text when the Autocomplete loses focus
        }
    };
    const handleScroll = (e) => {
        const listboxNode = e.currentTarget;

        if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight && servicePageData.totalpages > page) {
            setPage(page + 1);
            customersLists(page + 1, customerLimit);
        }
    };

    const [open3, setOpen3] = React.useState(false);

    const handleOpen3 = () => setOpen3(true);
    const handleClose3 = () => {
        setOpen3(false);
        setEditShopSupply({ edit: false, index: '' });
    };

    const disablePrevDates = (startDate) => {
        const startSeconds = Date.parse(startDate);
        return (date) => {
            return Date.parse(date) < startSeconds;
        };
    };

    const deleteshopSupplies = (idx) => {
        const filteredShopSupplyData = shopSupplyData.filter((item, index) => index !== idx);
        setShopSupplyData(filteredShopSupplyData);
    };

    const onInvalid = (errors) => {
        const firstErrorField = Object.keys(errors)[0];

        if (firstErrorField) {
            const errorElement = document.querySelector(`[name = ${firstErrorField}]`);
            if (errorElement) {
                errorElement.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    const offset = 250; // Adjust the offset value as needed
                    const elementPosition = errorElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition - offset;
                    window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
                    setFocus(firstErrorField);
                }, 0);
            }
        }
    };

    const cancelInvoice = () => {
        // if (id) {
        //     customersLists(page, customerLimit);
        //     fetchInvoceDetailData(id);
        // }
        navigate(-1);
        // setPaymentDetails({
        //     ...paymentDetails,
        //     discount: 0,
        //     discountPercentage: 0,
        //     tax: 0,
        //     fees: 0,
        //     subTotal: 0,
        //     total: 0,
        // });
        // if (appointmentId) {
        //     customersLists(page, customerLimit);
        //     fetchAppointmentDetails(appointmentId);
        //     setValue('invoicePreparedBy', '');

        //     setTermsData('');
        //     setDemoDescription('');
        //     setShopSupplyData([]);
        //     setAllServices([]);
        // } else {
        //     setValue('invoicePreparedBy', '');
        //     setValue('odoDroppedOff', '');
        //     setValue('odoReturned', '');

        //     setCustomerData('');
        //     setVehicleData('');
        //     setSelectedVehicleMake(null);
        //     setSelectDate(null);
        //     const dataToStore = { ...invoiceDataInStore };
        //     if (dataToStore?.appointmentCompletionDate) delete dataToStore.appointmentCompletionDate;
        //     if (dataToStore?.appointmentDroppedOffDate) delete dataToStore.appointmentDroppedOffDate;
        //     setInvoiceDataInStore(dataToStore, false);
        //     setCompletionDate(null);

        //     setTermsData('');
        //     setDemoDescription('');
        //     setShopSupplyData([]);
        //     setAllServices([]);
        // }
    };

    //   New Service Flow Fucntions
    const handleToggle = (index) => {
        setServiceExpanded(
            (prevExpanded) =>
                prevExpanded.includes(index)
                    ? prevExpanded.filter((item) => item !== index) // Remove index if already open
                    : [...prevExpanded, index] // Add index if closed
        );
    };

    //   New Service Flow Fucntions
    const handleAccordianToggle = (index) => {
        setAccordianExpanded(
            (prevAccoridan) =>
                prevAccoridan.includes(index)
                    ? prevAccoridan.filter((item) => item !== index) // Remove index if already open
                    : [...prevAccoridan, index] // Add index if closed
        );
    };

    const handleAddService = () => {
        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
        cloneService.push({
            type: 'select',
            serviceCategory: { _id: '', name: '' },
            service: { _id: '', name: '' },
            pricingType: PRICING_TYPES.FXIED,
            optionalDescription: '',
            showDesc: true,
            fixedPrice: '0',
            // parts: [{ type: "search", partQty: 1, partCost: 0 }],
        });
        setServiceListPayload(cloneService);
        setServiceExpanded((prevExpanded) => [
            ...prevExpanded,
            cloneService.length - 1, // New item's index
        ]);
        markSaved();

        // Cursor straight into the new row's service name field (both ADD SERVICE buttons use this).
        focusServiceSearch(cloneService.length - 1);
    };

    const handleOpenSavedServicesModal = (outerIndex) => {
        setSavedServicesModalOuterIndex(serviceListPayload.length);
        setOpenSavedServicesModal(true);
    };

    const handleCloseSavedServicesModal = () => {
        setOpenSavedServicesModal(false);
        setSavedServicesModalOuterIndex(null);
    };

    const handleAddSavedServicesToInvoice = (selectedServices) => {
        if (!selectedServices || selectedServices.length === 0) {
            return false;
        }

        // Check for duplicate services before adding any
        const duplicateServices = [];
        selectedServices.forEach((savedService) => {
            const existingService = serviceListPayload.find((existingService) => existingService?.service?._id === savedService.service?._id);
            if (existingService) {
                duplicateServices.push(savedService.service?.name || 'Unknown Service');
            }
        });

        // If duplicates found, show error and prevent adding any services
        if (duplicateServices.length > 0) {
            const duplicateNames = duplicateServices.join(', ');
            toast.error(`The following service(s) already exist in the invoice: ${duplicateNames}`);
            return false;
        }

        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));

        // Add each selected saved service to the serviceListPayload
        selectedServices.forEach((savedService) => {
            const servicePayload = {
                type: 'select',
                savedServiceId: savedService.id,
                service: savedService.service,
                serviceCategory: savedService.serviceCategory,
                pricingType: savedService.pricingType,
                optionalDescription: savedService.description || '',
                showDesc: true,
                fixedPrice: savedService.fixedPrice || '0', // Map from savedService.fixedPrice
            };

            if (savedService.pricingType === PRICING_TYPES.LABOUR) {
                if (savedService.laborCost || savedService.labour) {
                    servicePayload.qty = savedService.labour || 1;
                    servicePayload.ratePerHour = savedService.laborCost || 0;
                    const qty = Number(savedService.labour) || 0;
                    const rate = Number(savedService.laborCost) || 0;
                    servicePayload.amount = qty && rate ? Number(NumericEngine.multiply(qty, rate)) : 0;
                }
                servicePayload.parts =
                    savedService.partsData?.length > 0
                        ? savedService.partsData?.map((part) => ({
                              inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                              partName: part.partName || '',
                              partQty: part.partQty || '1',
                              partCost: part.partCost || '0',
                              totalAmount: part.amount || 0,
                          }))
                        : [];
            }

            cloneService.push(servicePayload);
        });

        setServiceListPayload(cloneService);
        setServiceExpanded((prevExpanded) => [
            ...prevExpanded,
            ...Array.from({ length: selectedServices.length }, (_, i) => cloneService.length - selectedServices.length + i),
        ]);
        markSaved();
        return true; // Indicate successful addition
    };
    //PartsFucntion
    const handleClosePartModel = () => {
        setOpenpartModel(false);
        setSaveIndexes({ outerIndex: 0, innerIndex: 0 });
        setSelectedInventoryId(null);
        setBatchNumber(null);
        setShowAllInventoryTabs(true);
        setInventoryTabIndex(0);
        setAddQty(false);
        setDisabledFields([]);
        setIsUsedInvoiceQty(null);
        setOpenTrackedIncreaseModal(false);
        // setOutOfStockStatus(null);
        // setInventoryOption(null);
        setInventoryModalType('add');
    };

    const handleSavePartModel = (data, noCLose, detailBatch, detailQty) => {
        const cloneService = JSON.parse(JSON.stringify(serviceListPayload));
        const { outerIndex, innerIndex } = saveIndexes;
        const isValidIndex =
            outerIndex >= 0 && outerIndex < cloneService.length && innerIndex >= 0 && innerIndex <= (cloneService[outerIndex]?.parts?.length || 0);

        if (!isValidIndex) return; // Exit if indices are invalid

        if (!data) {
            // Case: No data provided, process selectedInventory
            const updatedParts = selectedInventory.map((item) => {
                const partQty = Number(item.partQty) || 1;
                const partCost = NumericEngine.format(item.partCost || 0);

                const qty = Number(item?.batchNumber?.length === 1 ? partQty : 1) || 0;
                const cost = Number(partCost) || 0;
                return {
                    ...item,
                    description: item.lastDescription || item?.description,
                    partQty: item?.batchNumber?.length === 1 ? partQty : 1,
                    inventoryType: item.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                    totalAmount: qty && cost ? Number(NumericEngine.multiply(qty, cost)) : 0,
                    batchArray:
                        item?.batchNumber?.length > 0
                            ? item.batchNumber.map((batch, index) => {
                                  return {
                                      outerIndex: outerIndex,
                                      innerIndex: innerIndex,
                                      batchIndex: index,
                                      batchNumber: batch,
                                      batchQty: item?.batchNumber?.length === 1 ? partQty : index === 0 ? 1 : 0,
                                  };
                              })
                            : [
                                  {
                                      batchNumber: data?.batchNumber?.length > 0 ? data?.batchNumber[0] : null,
                                      batchQty: partQty,
                                      outerIndex,
                                      innerIndex,
                                      batchIndex: 0,
                                  },
                              ],
                };
            });

            cloneService[outerIndex].parts = updatedParts;
        } else {
            if (outOfStockStatus === 'update') {
                const alreadyExists = cloneService[outerIndex].parts.some((part, index) => part?._id === data._id && index !== innerIndex);

                if (alreadyExists) {
                    refetchInventoryListManual();
                    toast.error('This part is already added.');

                    return;
                }
            }

            const partQty = cloneService[outerIndex]?.parts[innerIndex]?.partQty || 1;
            const partCost = truncateToFixed(data.lastRetailPrice) || cloneService[outerIndex]?.parts[innerIndex]?.partCost || 0; // Take new last retail price instead of old from cloneService

            if (outOfStockStatus === 'create' && data?.batchNumber?.length > 1) {
                const usedQty = isUsedInvoiceQty || isUsedInvoiceQty === 0 ? Number(isUsedInvoiceQty) : undefined;
                const newPartQty = usedQty || partQty;
                const existingPartRowId = cloneService[outerIndex]?.parts[innerIndex]?.partRowId;

                let updatedPart = {
                    ...data,
                    ...(existingPartRowId ? { partRowId: existingPartRowId } : {}),
                    partQty: newPartQty,
                    partCost,

                    description: data?.lastDescription || data?.description,
                    inventoryType: data.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                    totalAmount: (() => {
                        const qty = Number(newPartQty) || 0;
                        const cost = Number(partCost) || 0;
                        return qty && cost ? Number(NumericEngine.multiply(qty, cost)) : 0;
                    })(),
                };

                // Start with existing batches from the initial part (if any)
                let batchArray = [];

                const lastBatchAdded = data.batchNumber?.length > 0 ? data.batchNumber[data.batchNumber.length - 1] : null;

                if (cloneService[outerIndex]?.parts[innerIndex]?.batchArray?.length > 0) {
                    batchArray = cloneService[outerIndex]?.parts[innerIndex]?.batchArray.map((batch, index) => {
                        return {
                            batchNumber: batch.batchNumber,
                            batchQty: batch.batchQty,
                            outerIndex,
                            innerIndex,
                            batchIndex: index,
                        };
                    });
                }
                // Add the newly created batch(es) from data.batchNumber
                // Filter out batches that already exist in batchArray
                const existingBatchNumbers = new Set(batchArray.map((b) => b.batchNumber));
                data.batchNumber.forEach((batchNum, index) => {
                    if (!existingBatchNumbers.has(batchNum)) {
                        batchArray.push({
                            batchNumber: batchNum,
                            batchQty: lastBatchAdded === batchNum ? newPartQty : 0,
                            isSelected: lastBatchAdded === batchNum ? true : false,
                            outerIndex,
                            innerIndex,
                            batchIndex: batchArray.length,
                        });
                    }
                });

                updatedPart.batchArray = batchArray;

                setInventoryOption(updatedPart);
                setBatchSelectionModal(true);
                setTimeout(() => {
                    setSaveIndexes({ outerIndex, innerIndex });
                }, 500);
                return;
            }
            const usedQty = isUsedInvoiceQty || isUsedInvoiceQty === 0 ? Number(isUsedInvoiceQty) : undefined;
            const existingPartRowId = cloneService[outerIndex]?.parts[innerIndex]?.partRowId;

            // Case: Data is provided and it's an object
            let updatedPart = {
                ...data,
                ...(existingPartRowId ? { partRowId: existingPartRowId } : {}),
                partQty: usedQty || partQty,
                partCost,
                description: data?.lastDescription || data?.description,
                inventoryType: data.inventoryType || INVENTORY_MANAGE_TYPE.MANAGED,
                totalAmount: (() => {
                    const qty = Number(usedQty || partQty) || 0;
                    const cost = Number(partCost) || 0;
                    return qty && cost ? Number(NumericEngine.multiply(qty, cost)) : 0;
                })(),
            };
            if (cloneService[outerIndex]?.parts[innerIndex]?.batchArray?.length > 0) {
                let totalPart = '0';
                updatedPart.batchArray = cloneService[outerIndex]?.parts[innerIndex]?.batchArray.map((batch, index) => {
                    const batchQty = detailBatch && detailBatch === batch.batchNumber ? detailQty : formatNumberAsWhole(batch.batchQty);
                    totalPart = NumericEngine.add(totalPart, Number(batchQty) || 0);
                    if (detailBatch && detailBatch === batch.batchNumber) {
                        updatedPart.partQty = Number(totalPart) || 1;
                    }
                    return {
                        batchNumber: batch.batchNumber,
                        batchQty:
                            detailBatch && detailBatch === batch.batchNumber
                                ? detailQty
                                : data?.batchNumber[0] === batch.batchNumber
                                  ? usedQty || partQty
                                  : formatNumberAsWhole(batch.batchQty),
                        outerIndex,
                        innerIndex,
                        batchIndex: index,
                    };
                });
            } else {
                const lastBatchIndex = data.batchNumber?.length > 0 ? data.batchNumber.length - 1 : 0;
                const lastBatchNumber = data.batchNumber?.[lastBatchIndex] ?? data.batchNumber?.[0];
                updatedPart.batchArray = [
                    {
                        batchNumber: lastBatchNumber,
                        batchQty: usedQty || partQty,
                        outerIndex,
                        innerIndex,
                        batchIndex: lastBatchIndex,
                    },
                ];
            }
            cloneService[outerIndex].parts = [
                ...cloneService[outerIndex].parts.slice(0, innerIndex),
                updatedPart,
                ...cloneService[outerIndex].parts.slice(innerIndex + 1),
            ];

            refetchInventoryListManual();
        }

        //code
        if (isAddPartAgain) {
            setServiceListPayload(cloneService);
            setTimeout(() => {
                setSelectedInventoryId(null);
                setInventoryModalType('add');
                setSaveIndexes({ outerIndex: outerIndex, innerIndex: innerIndex + 1 });
                setOpenpartModel(true);
                setIsUsedInvoiceQty(1);
            }, 400);

            return;
        }
        setIsUsedInvoiceQty(null);
        setServiceListPayload(cloneService);
        setAddQty(false);
        setSelectedInventoryId(null);
        setDisabledFields([]);
        setOpenTrackedIncreaseModal(false);
        // setBatchNumber(null);
        setOutOfStockStatus(null);
        setSaveIndexes({ outerIndex: 0, innerIndex: 0 });
        setInventoryModalType('add');
        if (!noCLose) {
            setOpenpartModel(false); // Close the model
        }
    };

    const autoCompleteChangeFunction = (newValue, outerIndex) => {
        const payload = {
            type: 'select',
            pricingType: 'labor_&_parts',
            serviceCategory: {
                _id: newValue?.serviceCategory?._id,
                name: newValue?.serviceCategory?.name,
            },
            service: {
                _id: newValue?.serviceSubCategory?._id,
                name: newValue?.serviceSubCategory?.name,
            },
            category: newValue?.serviceCategory?._id,
        };
        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
        cloneService[outerIndex] = {
            ...cloneService[outerIndex],
            ...payload,
        };

        setServiceListPayload(cloneService);
    };

    const validateServiceBeforeOpen = async (outerIndex) => {
        setIsUpdate(false);
        setAskServiceModal(true);
        return;
        if (serviceListPayload[outerIndex]) {
            if (!serviceListPayload[outerIndex]?.service?._id) {
                toast.error(`Service ${outerIndex + 1}: Please select or add a service name.`);
                return;
            }

            if (serviceListPayload[outerIndex]?.pricingType === PRICING_TYPES.LABOUR) {
                if (!serviceListPayload[outerIndex]?.parts?.length) {
                    toast.error(`Service "${serviceListPayload[outerIndex]?.service?.name}": Please select parts for this service.`);
                    return;
                }

                if (!serviceListPayload[outerIndex]?.qty && !serviceListPayload[outerIndex]?.ratePerHour) {
                    toast.error(`Service "${serviceListPayload[outerIndex]?.service?.name}": Please provide  labor quantity and rate per hour.`);
                    return;
                }

                const qty = Number(serviceListPayload[outerIndex]?.qty);
                if (isNaN(qty)) {
                    toast.error(`Service "${serviceListPayload[outerIndex]?.service?.name}": Please provide a valid value for labor quantity.`);
                    return;
                }

                if (qty <= 0) {
                    toast.error(`Service "${serviceListPayload[outerIndex]?.service?.name}": Labor quantity must be greater than 0.`);
                    return;
                }

                if (serviceListPayload[outerIndex]?.parts?.length > 0) {
                    for (const [partIndex, part] of serviceListPayload[outerIndex].parts.entries()) {
                        if (!part?._id) {
                            toast.error(`Service "${serviceListPayload[outerIndex]?.service?.name}", Part ${partIndex + 1}: Please select a valid part.`);
                            return;
                        }

                        const partQty = Number(part?.partQty);
                        if (isNaN(partQty)) {
                            toast.error(
                                `Service "${serviceListPayload[outerIndex]?.service?.name}", Part ${
                                    partIndex + 1
                                }: Please provide a valid value for part quantity.`
                            );
                            return;
                        }

                        if (partQty <= 0) {
                            toast.error(
                                `Service "${serviceListPayload[outerIndex]?.service?.name}", Part ${partIndex + 1}: Part quantity must be greater than 0.`
                            );
                            return;
                        }
                    }
                }
                const resp = await dispatch(checkServiceExistance(serviceListPayload[outerIndex]?.service?._id));
                if (resp?.savedServiceExist) {
                    setIsUpdate(true);
                    setAskServiceModal(true);
                } else {
                    setIsUpdate(false);
                    setAskServiceModal(true);
                }
            }
        }
    };

    const handleCreateOrSelectService = (selectedItem, outerIndex) => {
        preventCloseRef.current = true;
        const value = selectedItem.serviceSubCategory.name;

        const isDuplicate = serviceListPayload.some((service, index) => service?.service?.name === value && index !== outerIndex);
        // if (isDuplicate) {
        //     toast.error(`A service with the same name already exists.`);
        //     preventCloseRef.current = false; // Reset to allow dropdown close
        //     return;
        // }

        if (isDuplicate) {
            toast.error(`A service with the same name already exists.`);

            setServiceListPayload(serviceListPayload);

            setAnchorEls((prev) => {
                const next = [...prev];
                next[outerIndex] = true;
                return next;
            });

            preventCloseRef.current = false;
            return;
        }

        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
        let storeDescription = cloneService[outerIndex]?.optionalDescription || '';

        const payload = {
            type: 'select',
            pricingType: cloneService[outerIndex].pricingType,
            // selectedItem?.priceType === PRICING_TYPES.FXIED
            //   ? PRICING_TYPES.FXIED
            //   : PRICING_TYPES.LABOUR,
            serviceCategory: {
                _id: selectedItem?.serviceCategory?._id || '',
                name: selectedItem?.serviceCategory?.name || '',
            },
            service: {
                _id: selectedItem?.serviceSubCategory?._id || '',
                name: selectedItem?.serviceSubCategory?.name || '',
            },
            category: selectedItem?.serviceCategory?._id,
            optionalDescription: storeDescription,
        };

        const hasNoParts = !(cloneService[outerIndex]?.parts?.length > 0);
        const hasNoLabour =
            (cloneService[outerIndex]?.qty == null || cloneService[outerIndex]?.qty === undefined) &&
            (cloneService[outerIndex]?.ratePerHour == null || cloneService[outerIndex]?.ratePerHour === undefined);

        if (hasNoParts && hasNoLabour) {
            if (selectedItem?.priceType === SHOP_SERVICE_PRICE_TYPES.FIXED && selectedItem?.fixedPrice != null) {
                payload.fixedPrice = String(selectedItem.fixedPrice);
                payload.pricingType = PRICING_TYPES.FXIED;
            } else if (selectedItem?.priceType === SHOP_SERVICE_PRICE_TYPES.STARTING_FROM && selectedItem?.priceMin != null) {
                payload.fixedPrice = String(selectedItem.priceMin);
                payload.pricingType = PRICING_TYPES.FXIED;
            } else {
                payload.fixedPrice = '0';
                payload.pricingType = PRICING_TYPES.FXIED;
            }
        }

        if (cloneService[outerIndex].pricingType === PRICING_TYPES.FXIED) {
            cloneService[outerIndex] = {
                ...cloneService[outerIndex],
                ...payload,
            };
        } else {
            // payload.parts = [{ type: "search", partQty: 1, partCost: 0 }];
            cloneService[outerIndex] = {
                ...cloneService[outerIndex],
                ...payload,
            };
        }

        setServiceListPayload(cloneService);

        // Close the dropdown
        const newAnchorEls = [...anchorEls];
        newAnchorEls[outerIndex] = false;
        setAnchorEls(newAnchorEls);

        setTimeout(() => {
            preventCloseRef.current = false; // Reset after a short delay
        }, 300);
    };

    const handleServiceSelection = (item, outerIndex) => {
        handleCreateOrSelectService(item, outerIndex);
    };

    const handleSaveService = async (serviceName, outerIndex) => {
        preventCloseRef.current = true;
        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
        setShowMenuLoader(true);
        setInputValue(serviceName);

        try {
            const newServiceData = await createServiceMutation.mutateAsync({ name: serviceName.trim() });

            if (newServiceData) {
                // Invalidate all service queries to ensure fresh data
                queryClient.invalidateQueries({ queryKey: businessServicesKeys.all, refetchType: 'all' });

                // Immediately refetch services to get the latest data
                const { data: updatedServicesData } = await refetchServices();
                setInputValue(serviceName.trim());

                // Find newly created service from the updated list
                const updatedServices = updatedServicesData?.data || [];
                const newService = updatedServices.find((item) => item.serviceSubCategory.name.toLowerCase() === serviceName.trim().toLowerCase());

                if (newService) {
                    // Update the service list at the correct index
                    const payload = {
                        type: 'select',
                        pricingType: cloneService[outerIndex].pricingType || PRICING_TYPES.FXIED,
                        serviceCategory: {
                            _id: newService?.serviceCategory?._id || '',
                            name: newService?.serviceCategory?.name || '',
                        },
                        service: {
                            _id: newService?.serviceSubCategory?._id || '',
                            name: newService?.serviceSubCategory?.name || '',
                        },
                        category: newService?.serviceCategory?._id || '',
                    };

                    setServiceListPayload((prevList) => prevList.map((service, i) => (i === outerIndex ? { ...service, ...payload } : service)));

                    // Close the dropdown
                    setAnchorEls((prev) => {
                        const newAnchors = [...prev];
                        newAnchors[outerIndex] = false;
                        return newAnchors;
                    });

                    // **Remove cursor focus from input field**
                    setTimeout(() => {
                        inputFielRef.current[outerIndex]?.blur();
                    }, 100);
                }
            }
        } catch (error) {
            console.error('Error creating service:', error);
            setInputValue(serviceName);
        }

        setShowMenuLoader(false);

        // Reset preventCloseRef after short delay
        setTimeout(() => {
            preventCloseRef.current = false;
        }, 300);
    };

    const handleServiceChange = (eventOrValue, index) => {
        // Handle both Autocomplete onInputChange (which passes event) and direct value
        const value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue?.target?.value || '';
        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));

        const isDuplicate = serviceListPayload.some((service, serviceIndex) => service?.service?.name === value && serviceIndex !== index);
        if (isDuplicate) {
            setAnchorEls((prev) => {
                const next = [...prev];
                next[index] = true;
                return next;
            });

            setServiceFilteredData(cachedServices);
            preventCloseRef.current = false;
            return;
        }

        if (value !== '') {
            if (cloneService[index]) {
                cloneService[index] = {
                    ...cloneService[index],
                    service: {
                        ...cloneService[index].service, // Ensure existing properties are preserved
                        name: value, // Set only the name
                    },
                };
            }

            setServiceListPayload(cloneService);
        }

        if (value === '') {
            let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
            cloneService[index] = {
                ...cloneService[index],
                type: 'select',
                serviceCategory: {},
                service: { _id: '', name: '' }, // Reset service
            };
            // if (!isDirty) {
            //     markSaved();
            // }
            setServiceListPayload(cloneService);
            setServiceFilteredData(cachedServices);
        } else {
            const filtered = cachedServices.filter((item) => item.serviceSubCategory.name.toLowerCase().includes(value.toLowerCase().trim()));
            const exactMatch = filtered.some((item) => item.serviceSubCategory.name.toLowerCase() === value.toLowerCase().trim());
            const updatedFilteredData = exactMatch ? filtered : [{ _id: 'new', serviceSubCategory: { name: value } }, ...filtered];
            if (!isDirty) {
                markSaved();
            }

            setServiceFilteredData(updatedFilteredData);
        }
    };

    const handleOnFocus = (event, outerIndex) => {
        const value = event?.currentTarget?.value?.trim() || serviceListPayload[outerIndex]?.service?.name || '';
        const isDuplicate = serviceListPayload.some((service, index) => service?.service?.name === value && index !== outerIndex);

        if (isDuplicate) {
            setAnchorEls((prev) => {
                const next = [...prev];
                next[outerIndex] = true;
                return next;
            });

            setServiceFilteredData(cachedServices);
            preventCloseRef.current = false;
            return;
        }

        if (value !== '' && !isDuplicate) {
            setAnchorEls((prev) => {
                const newAnchors = prev.map(() => false);
                newAnchors[outerIndex] = true;
                return newAnchors;
            });
            const filtered = cachedServices.filter((item) => item.serviceSubCategory.name.toLowerCase().includes(value?.toLowerCase()));

            const exactMatch = filtered.some((item) => item.serviceSubCategory.name.toLowerCase() === value?.toLowerCase());

            // If no exact match, allow creating a new option
            const updatedFilteredData = exactMatch ? filtered : [{ _id: 'new', serviceSubCategory: { name: value } }, ...filtered];

            setServiceFilteredData(updatedFilteredData);
        } else {
            setAnchorEls((prev) => {
                const newAnchors = prev.map(() => false);
                newAnchors[outerIndex] = true;
                return newAnchors;
            });

            setServiceFilteredData(cachedServices);
        }
    };
    //validateFucntion
    const validateInvoiceForPayment = (values) => {
        // Discount validation
        if (discountError) {
            toast.error('Discount cannot be more than subtotal amount.');
            return false;
        }

        if (!values.customerId) {
            setError('customerId', { message: 'Customer is required' });
            toast.error('Please select a customer to continue');
            return false;
        }

        if (!vehicleData) {
            setError('vehicleId', { message: 'Vehicle is required' });
            toast.error('Please select a vehicle to continue');
            return false;
        }

        setCustomValidationErr(null);

        // At least one service required
        if (serviceListPayload.length === 0) {
            setMessageType('error');
            setOpenSuccessModal(true);
            setSuccessMessage('Atleast one service is required.');
            return false;
        }

        // Service list validations
        if (serviceListPayload?.length > 0) {
            for (const [index, item] of serviceListPayload.entries()) {
                if (!item?.service?._id) {
                    toast.error(`Service ${index + 1}: Please select or add a service name.`);
                    return false;
                }
                if (item?.pricingType === PRICING_TYPES.FXIED) {
                    const fixedPriceNum = Number(item?.fixedPrice);
                    if (!item?.fixedPrice || isNaN(fixedPriceNum) || fixedPriceNum <= 0) {
                        toast.error(`Service "${item?.service?.name}": Please add fixed price greater then 0.`);
                        return false;
                    }
                }
                if (item?.pricingType === PRICING_TYPES.LABOUR) {
                    if (item?.parts?.length > 0) {
                        for (const [partIndex, part] of item.parts.entries()) {
                            const partQty = Number(part?.partQty);
                            if (isNaN(partQty)) {
                                toast.error(`Service "${item?.service?.name}", Part ${partIndex + 1}: Please provide a valid value for part quantity.`);
                                return false;
                            }
                            if (partQty <= 0) {
                                toast.error(`Service "${item?.service?.name}", Part ${partIndex + 1}: Part quantity must be greater than 0.`);
                                return false;
                            }
                        }
                    }
                }
            }
        }

        // Fees validation
        if (selectedFees?.length > 0) {
            for (const [index, fee] of selectedFees.entries()) {
                // Check if fee name is empty
                if (!fee.name || fee.name.trim() === '') {
                    toast.error(`Please enter a fee name to continue`);
                    return false;
                }

                // Check if fee has no value set (neither amount nor percentage)
                if (fee.calculationType === 'fixed_amount') {
                    if (fee.amount === undefined || fee.amount === null || fee.amount === '' || Number(fee.amount) <= 0) {
                        toast.error(`Fee "${fee.name}": Please enter a valid amount.`);
                        return false;
                    }
                } else if (fee.calculationType === 'percentage') {
                    if (fee.percentage === undefined || fee.percentage === null || fee.percentage === '' || Number(fee.percentage) <= 0) {
                        toast.error(`Fee "${fee.name}": Please enter a valid percentage.`);
                        return false;
                    }
                } else {
                    // calculationType not set at all
                    toast.error(`Fee ${index + 1}: Please select a calculation type (fixed amount or percentage).`);
                    return false;
                }
            }
        }

        return true;
    };
    const validateInvoice = (values, isDelete, outerIndex, innerIndex, overrides) => {
        try {
            // Discount validation
            if (discountError) {
                toast.error('Discount cannot be more than subtotal amount.');
                return false;
            }
            if (!values.customerId) {
                setError('customerId', {
                    message: 'Customer is required',
                });
                toast.error('Please select a customer to continue');
                return false;
            }

            if (!vehicleData) {
                setError('vehicleId', {
                    message: 'Vehicle is required',
                });
                toast.error('Please select a vehicle to continue');
                return false;
            }

            setOdoValidationErr(null);

            setCustomValidationErr(null);

            if (!isSaveDraftRef.current && serviceListPayload.length === 0) {
                setMessageType('error');
                setOpenSuccessModal(true);
                setSuccessMessage('Atleast one service is required.');
                return false;
            }

            if (serviceListPayload?.length > 0) {
                for (const [index, item] of serviceListPayload.entries()) {
                    if (!item?.service?._id) {
                        toast.error(`Service ${index + 1}: Please select or add a service name.`);
                        return;
                    }
                    if (item?.pricingType === PRICING_TYPES.FXIED) {
                        const fixedPriceNum = Number(item?.fixedPrice);
                        if (!item?.fixedPrice || isNaN(fixedPriceNum) || fixedPriceNum <= 0) {
                            toast.error(`Service "${item?.service?.name}": Please add fixed price greater then 0.`);
                            return;
                        }
                    }

                    if (item?.pricingType === PRICING_TYPES.LABOUR) {
                        // if (!item?.parts?.length) {
                        //   toast.error(
                        //     `Service "${item?.service?.name}": Please select parts for this service.`
                        //   );
                        //   return;
                        // }

                        // if (!item?.qty && !item?.ratePerHour) {
                        //   toast.error(
                        //     `Service "${item?.service?.name}": Please provide  labor quantity and rate per hour.`
                        //   );
                        //   return;
                        // }

                        // const qty = Number(item?.qty);
                        // if (isNaN(qty)) {
                        //   toast.error(
                        //     `Service "${item?.service?.name}": Please provide a valid value for labor quantity.`
                        //   );
                        //   return;
                        // }

                        // if (qty <= 0) {
                        //   toast.error(
                        //     `Service "${item?.service?.name}": Labor quantity must be greater than 0.`
                        //   );
                        //   return;
                        // }

                        if (item?.parts?.length > 0) {
                            for (const [partIndex, part] of item.parts.entries()) {
                                // if ((!part?._id || !part?.partName) && !isSaveDraftRef.current) {
                                //   toast.error(
                                //     `Service "${item?.service?.name}", Part ${
                                //       partIndex + 1
                                //     }: Please select a valid part.`
                                //   );
                                //   return;
                                // }

                                const partQty = Number(part?.partQty);
                                if (isNaN(partQty)) {
                                    toast.error(`Service "${item?.service?.name}", Part ${partIndex + 1}: Please provide a valid value for part quantity.`);
                                    return;
                                }

                                if (partQty <= 0) {
                                    toast.error(`Service "${item?.service?.name}", Part ${partIndex + 1}: Part quantity must be greater than 0.`);
                                    return;
                                }
                            }
                        }
                    }
                }
            }

            // if (!values.paymentMethod?.key) {
            //     toast.error('Please select a payment method.');
            //     return false;
            // }

            if (customerMembershipId && customerMembershipId !== '' && (discountId === 'none' || discountId === 'custom')) {
                setIsRemoveDiscount(true);
            }
            const discountClone = discountId && discountId !== '' && discountId !== 'none' && discountId !== 'custom' ? discountId : null;
            if (discountClone && discountClone !== customerMembershipId) {
                setOpenProgramModal(true);
                setStoreValues(values);
                return false;
            } else if (customerMembershipId === discountClone) {
            } else if (customerMembershipId && customerMembershipId !== '') {
                setOpenProgramModal(true);
                setStoreValues(values);
                return false;
            }

            onSubmitInvoice(values, isDelete, outerIndex, innerIndex, overrides);
            return true;
        } catch (error) {
            const filteredPayments = paymentMethods.filter((payment) => payment.amount !== undefined && payment.amount !== null && payment.amount !== '');
            setPaymentMethods(filteredPayments);
            setIsLoading(false);
        }
    };
    // Helper function to convert dates to UTC ISO string
    const toISOStringUTC = (date) => {
        // Convert the input date to a UTC date
        const startOfDay = dayjs(date).startOf('day');

        // Then set the time to the start of the day (00:00:00) in UTC
        const startOfDateUtc = startOfDay.utc();

        // Return the ISO string representation in UTC
        return startOfDateUtc.toISOString();
    };

    // onSubmitFunction
    const onSubmitInvoice = async (values, isDelete, outerIndex, innerIndex, overrides) => {
        if (isSubmittingRef.current || submitCompletedRef.current) return;

        runWithZeroTaxGuard(() => {
            void submitInvoice(values, isDelete, outerIndex, innerIndex, overrides);
        });
    };

    const submitInvoice = async (values, isDelete, outerIndex, innerIndex, overrides) => {
        isSubmittingRef.current = true;
        setIsSubmitting(true);

        try {
            clearErrors();

            // if (!isSaveDraftRef.current && !isCheckedRecord && isDelete !== true) {
            //     setIsCheckedRecord(true);
            //     setIsRecordModal(true);
            //     return;
            // }

            const dropOdo = values?.odoDroppedOff?.toString()?.replace(/,/g, '');
            const selectInvoiceDateisoString = selectInvoiceDate ? toISOStringUTC(selectInvoiceDate) : '';

            // Work order contract — see docs/work-orders/WORK_ORDERS_SPEC.md §14.5.
            // `isDraft` is create-only; on update the backend owns the status.
            let payload = {
                serviceAdvisor: values.serviceAdvisor,
                customerId: customerData?.refIdUsers || customerData?._id || getValues('customerId'),
                vehicleId: vehicleData || values?.vehicleId || undefined,
                workOrderDate: selectInvoiceDateisoString || undefined,
                mileage: dropOdo || undefined,
                customerPO: values.customerPO || undefined,
                note: values?.note || undefined,
                recommendationNotes: values?.recommendationNotes || undefined,
                // Work orders carry authorization wording instead of terms & warranty (spec §4.5)
                authorizationMessage: authorizationText,
            };

            if (usesCreateEndpoint) {
                payload.isDraft = isSaveDraftRef.current;
            }
            // Per-line taxesBreakdown builder (new tax version only): use the line's own override,
            // else derive defaults from the shop rules by line kind.
            const buildLineTax = (breakdown, kind) =>
                buildLineTaxesBreakdownPayload(
                    Array.isArray(breakdown) && breakdown.length ? breakdown : buildLineDefaultTaxes(shopTaxesData, kind),
                    shopTaxesData,
                    DOCUMENT_TAX_TYPE.WORK_ORDER,
                    taxesBreakdown,
                    kind
                );

            // Florida labour-only: whole document has no part/package → bake labour tax off in the
            // saved payload, so the stored record already encodes it and every read path agrees.
            const flLabourSuppress = isFloridaLabourOnlySuppressed(provinceTaxGroup, editorHasPartsOrPackages(serviceListPayload, PRICING_TYPES));
            const buildLabourTax = (breakdown) => applyFloridaLabourSuppression(buildLineTax(breakdown, LINE_TAX_KIND.LABOUR), shopTaxesData, flLabourSuppress);

            let fees = [];
            if (selectedFees.length > 0) {
                selectedFees.forEach((item) => {
                    const calcType = item.calculationType || (Number(item.amount) > 0 ? 'fixed_amount' : 'percentage');
                    const isOneTime = !item._id;

                    const feeEntry = {
                        feesCalculationType: calcType,
                        ...(isOneTime ? { feesName: (item.name || '').trim() } : { feesId: item._id, feesName: (item.name || '').trim() }),
                    };

                    if (calcType === 'fixed_amount') {
                        feeEntry.feesAmount = Number(item.amount) || 0;
                    } else {
                        feeEntry.feesPercentage = Number(item.percentage) || 0;
                    }
                    if (isNewTaxVersionActive) {
                        feeEntry.taxesBreakdown = buildLineTax(item.taxesBreakdown, LINE_TAX_KIND.FEES);
                    }
                    fees.push(feeEntry);
                });
            }

            payload.fees = fees;
            payload.appointmentId = overrides?.appointmentId ?? appointmentId ?? invoiceData?.appointment?._id ?? undefined;
            // Links the work order back to the estimate it was converted from.
            payload.linkedEstimateId = linkedEstimateId || undefined;
            // The sync flags (isSyncedWithEstimate / isSyncedWithWOA) are the backend's: it decides which
            // linked documents are in step on every create and update, so nothing is sent from here.

            // Process services
            let allServices = [];
            let priceNotAvailable = false;

            serviceListPayload?.forEach((d, oi) => {
                let data = {
                    serviceId: d?.service?._id,
                    description: d?.optionalDescription,
                };
                data.pricingType = d?.pricingType;
                if (d?.pricingType === PRICING_TYPES.FXIED) {
                    data.fixedPrice = Number(d.fixedPrice) || '';
                    if (!d.fixedPrice && !Number(d.fixedPrice) > 0) {
                        priceNotAvailable = true;
                        toast.error('Please add a price for all services.');
                        return;
                    }
                    if (isNewTaxVersionActive) {
                        data.taxesBreakdown = buildLineTax(d.taxesBreakdown, LINE_TAX_KIND.PACKAGE);
                    }
                }
                if (d?.pricingType === PRICING_TYPES.NOPRICE) {
                }
                if (d?.pricingType === PRICING_TYPES.LABOUR) {
                    if (Number(d?.ratePerHour) > 0 && Number(d?.qty) > 0) {
                        data.labor = {
                            qty: d.qty || 1,
                            ratePerHour: d.ratePerHour || 0,
                        };
                        if (isNewTaxVersionActive) {
                            data.labor.taxesBreakdown = buildLabourTax(d.taxesBreakdown);
                        }
                    }

                    data.parts = d?.parts
                        ?.filter((_, ii) => !(outerIndex === oi && innerIndex === ii))
                        .map((part) => {
                            if (!part.inventoryType || part.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED) {
                                if (!part?._id) return null;
                                const mappedPart = {
                                    inventoryType: INVENTORY_MANAGE_TYPE.MANAGED,
                                    inventoryId: part?._id,
                                    totalQty: Number(part.partQty),
                                    retailPrice: Number(part.partCost),
                                };

                                if (Array.isArray(part.batchArray) && part.batchArray.length > 0) {
                                    mappedPart.batches = part.batchArray.map((batch) => ({
                                        batchNumber: batch.batchNumber,
                                        qty: batch.batchQty.toString(),
                                    }));
                                }
                                if (isNewTaxVersionActive) {
                                    mappedPart.taxesBreakdown = buildLineTax(part.taxesBreakdown, LINE_TAX_KIND.PARTS);
                                }
                                return mappedPart;
                            } else {
                                const unmanagedPart = {
                                    inventoryType: INVENTORY_MANAGE_TYPE.UNMANAGED,
                                    partName: part.partName,
                                    totalQty: Number(part.partQty),
                                    retailPrice: Number(part.partCost),
                                };
                                if (isNewTaxVersionActive) {
                                    unmanagedPart.taxesBreakdown = buildLineTax(part.taxesBreakdown, LINE_TAX_KIND.PARTS);
                                }
                                return unmanagedPart;
                            }
                        })
                        .filter(Boolean); // Filters out null values
                }

                allServices.push(data);
            });

            if (priceNotAvailable) {
                if (!submitCompletedRef.current) {
                    isSubmittingRef.current = false;
                    setIsSubmitting(false);
                }
                return;
            }

            payload.services = allServices;
            payload.discount = Number(paymentDetails.discount);
            payload.discountPercentage = Number(paymentDetails.discountPercentage) || 0;
            payload.discountSource = paymentDetails.discountSource || DISCOUNT_SOURCE.PERCENTAGE;
            payload.taxPercentage = paymentDetails.taxPercentage;
            if (isNewTaxVersionActive) {
                payload.taxesBreakdown = buildTaxesBreakdownPayload(taxesBreakdown, DOCUMENT_TAX_TYPE.WORK_ORDER);
                // payload.tax = paymentDetails.tax;
            }

            // A work order takes no payment — the invoice does that after conversion (spec §5).

            // Remove empty fields in draft save mode
            if (isSaveDraftRef.current) {
                ['mileage', 'workOrderDate', 'services', 'recommendationNotes'].forEach((field) => {
                    if (!payload[field] || (Array.isArray(payload[field]) && payload[field].length === 0)) {
                        delete payload[field];
                    }
                });
            }

            // Add discount if applicable
            if (discountId && discountId !== '' && discountId !== 'none' && discountId !== 'custom') {
                payload.membershipProgram = discountId;
            } else if (customerMembershipId && customerMembershipId !== '') {
                // payload.membershipProgram = ""; If membership program is empty, then don't pass membershipProgram key in payload
            }

            /*
             * requireReapproval on update (spec §4.4). The check runs when the work order has been
             * authorized at some point and the customer would have to authorize again:
             *   Authorized  → always
             *   Invoiced    → always (its invoice was built from authorized work)
             *   anything else, Reapprove included → skipped; the record's own flag is passed back
             *
             * A work order already waiting on re-approval never asks again, whatever is linked to it;
             * the linked-invoice prompt still runs as usual.
             *
             * Reauthorization wins over the linked-invoice prompt: when it is asked, the invoice question
             * is not — the invoice is updated later, once the customer has re-authorized.
             */
            const savedStatus = normalizeWorkOrderStatus(invoiceData?.status);
            const checksReapproval = savedStatus === WORK_ORDER_STATUS.AUTHORIZED || savedStatus === WORK_ORDER_STATUS.INVOICED;
            let reapprovalAsked = false;
            if (!usesCreateEndpoint) {
                if (typeof overrides?.requireReapproval === 'boolean') {
                    payload.requireReapproval = overrides.requireReapproval;
                    reapprovalAsked = true;
                } else if (checksReapproval) {
                    const workOrderDay = selectInvoiceDate ? dayjs(selectInvoiceDate).format('YYYY-MM-DD') : '';
                    const reapprovalChanges = getReapprovalDiff(invoiceData, payload, {
                        workOrderDay,
                        timezone: USER_TIMEZONE,
                        customerIds: [customerData?._id, customerData?.refIdUsers],
                    });
                    if (reapprovalChanges.length) {
                        // Which field asked for reapproval — shows in the console if the popup seems unexpected.
                        console.info(`[work order] reapproval needed — changed fields (saved → current):\n${JSON.stringify(reapprovalChanges, null, 2)}`);
                        setReapprovalPrompt({ values, isDelete, outerIndex, innerIndex, overrides });
                        return;
                    }
                    payload.requireReapproval = false;
                } else if (typeof invoiceData?.requireReapproval === 'boolean') {
                    payload.requireReapproval = invoiceData.requireReapproval;
                }
            }

            // Only when reauthorization was not asked: offer to carry the changes onto the linked invoice.
            if (!reapprovalAsked && linkedInvoiceToSync?._id && isDelete !== true && typeof overrides?.syncLinkedInvoice !== 'boolean') {
                setInvoiceSyncPrompt({ values, isDelete, outerIndex, innerIndex, overrides });
                return;
            }

            if (isDelete === true) {
            } else {
                setIsLoading(true);
            }

            /*
             * Which endpoint (spec §14.5):
             *   new record                  → create
             *   editing a DRAFT             → create, carrying its id — draft→draft and
             *                                 draft→open are both a create with isDraft set
             *   editing any other status    → update
             */
            let result;
            const requestParams = isSaveDraftRef.current ? {} : { sendEmail: isSendEmailRef.current };
            if (usesCreateEndpoint) {
                if (id) payload._id = id;
                result = await createWorkOrder.mutateAsync({ payload: filterUndefined(payload), params: requestParams });
            } else {
                result = await updateWorkOrder.mutateAsync({ id, payload: filterUndefined(payload), params: requestParams });
            }
            if (result && isDelete === true) {
                // If the data is truthy (meaning the appointment was created successfully)
                queryClient.invalidateQueries({ queryKey: businessWorkOrdersKeys.all, refetchType: 'all' });
                queryClient.invalidateQueries({ queryKey: [...reviewRequestKeys.all, 'quickReviewUsers'], refetchType: 'all' });
                setLinkedEstimateId(null);
                setDeletePartConfirmation(false);
                setDeletePartLoader(false);
                setAppointmentData(null);
                setIsGoogleReviewDetails((prev) => ({
                    shouldSendInvoiceToCarfax: false,
                    sendGoogleReviewRequest: true,
                    customMessage: '',
                    shouldSendReviewSMSToCustomer: false,
                    shouldSendReviewEmailToCustomer: false,
                    shouldSendReviewNotificationToCustomer: false,
                }));
                fetchInvoceDetailData(id);
                refetchInventoryListManual();
            } else if (result && result?._id) {
                // If the data is truthy (meaning the appointment was created successfully)
                queryClient.invalidateQueries({ queryKey: businessWorkOrdersKeys.all, refetchType: 'all' });
                queryClient.invalidateQueries({ queryKey: businessInventoryKeys.all, refetchType: 'all' });
                queryClient.invalidateQueries({ queryKey: [...reviewRequestKeys.all, 'quickReviewUsers'], refetchType: 'all' });

                if (payload.appointmentId) {
                    queryClient.invalidateQueries({
                        queryKey: appointmentKeys.details(payload.appointmentId),
                        refetchType: 'all',
                    });
                }
                setLinkedEstimateId(null);
                setAppointmentData(null);
                setIsGoogleReviewDetails((prev) => ({
                    shouldSendInvoiceToCarfax: false,
                    sendGoogleReviewRequest: true,
                    customMessage: '',
                    shouldSendReviewSMSToCustomer: false,
                    shouldSendReviewEmailToCustomer: false,
                    shouldSendReviewNotificationToCustomer: false,
                }));
                setStoreValues(null);
                setSubmitCompleted(true);
                submitCompletedRef.current = true;
                // setMessageType('success');
                toast.success(
                    isSaveDraftRef.current
                        ? `Work order draft was successfully ${id ? 'updated' : 'created'}`
                        : isSendEmailRef.current
                          ? 'Work order was successfully emailed to customer'
                          : id && !isDraftRecord
                            ? 'Work order was successfully updated'
                            : 'Work order was successfully created'
                );
                /*
                 * Route by the status the record actually ends up with. The update response can carry
                 * no status, and the backend recomputes it a moment after the write, so on an update we
                 * wait for the detail endpoint to report it (spec §4.4) — the loader stays up meanwhile,
                 * and the detail page opens already showing Reapprove instead of flipping to it.
                 */
                const expectedStatus =
                    typeof payload.requireReapproval === 'boolean'
                        ? payload.requireReapproval
                            ? WORK_ORDER_STATUS.REAPPROVAL
                            : WORK_ORDER_STATUS.AUTHORIZED
                        : '';
                let nextStatus = normalizeWorkOrderStatus(result?.status);
                if (!usesCreateEndpoint) {
                    setIsLoading(true);
                    nextStatus = (await waitForWorkOrderStatus(result?._id, expectedStatus)) || nextStatus;
                }
                if (!nextStatus) {
                    nextStatus = isSaveDraftRef.current ? WORK_ORDER_STATUS.DRAFT : WORK_ORDER_STATUS.OPEN;
                }
                queryClient.removeQueries({ queryKey: businessWorkOrdersKeys.detail(result?._id) });
                if (overrides?.syncLinkedInvoice === true && linkedInvoiceToSync?._id) {
                    // UPDATE on "Update linked invoice?": rebuild the invoice from the saved work order.
                    navigate(getInvoiceSyncFromWorkOrderUrl(linkedInvoiceToSync._id), { state: { workOrderData: { _id: result?._id } } });
                } else {
                    navigate(`/work-orders/${nextStatus}/${result?._id}`);
                }
            }

            if (isDelete === true) {
                setDeletePartConfirmation(false);
                setDeletePartLoader(false);
            } else {
                setIsLoading(true);
            }
            resetGlobalState();
        } catch (error) {
            const filteredPayments = paymentMethods.filter((payment) => payment.amount !== undefined && payment.amount !== null && payment.amount !== '');
            setPaymentMethods(filteredPayments);
            setIsLoading(false);
        } finally {
            if (!submitCompletedRef.current) {
                isSubmittingRef.current = false;
                setIsSubmitting(false);
            }
            setIsLoading(false);
        }
    };
    console.log('getValues', getValues());
    // TermsAndConditionnBox
    const TermsAndConditionnBox = () => {
        return (
            <Grid item container xs={12} marginTop={'24px'} className="customBoxWrapper" gap={3}>
                <Grid item xs={12} className="accordianTitleWrapper">
                    <TermsAndWarrantySvg />
                    <Typography className="accordianTitle">{watchedTermsAndWarranty?.title}</Typography>
                </Grid>
                <Grid xs={12} width={'100%'}>
                    <Typography
                        variant="body1"
                        whiteSpace="pre-line"
                        sx={{
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            fontWeight: 'inherit',
                            width: '100%',
                            overflow: 'hidden',
                            wordBreak: 'break-word',
                        }}
                    >
                        {watchedTermsAndWarranty?.description}
                    </Typography>
                </Grid>
            </Grid>
        );
    };

    const handleDeletePartFunction = (outerIndex, innerIndex) => {
        try {
            let cloneService = JSON.parse(JSON.stringify(serviceListPayload));

            if (innerIndex === 0 && cloneService[outerIndex].parts?.length === 1 && !cloneService[outerIndex]?.qty && !cloneService[outerIndex]?.ratePerHour) {
                cloneService[outerIndex].parts.splice(innerIndex, 1);
            } else {
                cloneService[outerIndex].parts.splice(innerIndex, 1);
            }

            if (
                !cloneService[outerIndex]?.parts?.length > 0 &&
                (cloneService[outerIndex]?.qty === null || cloneService[outerIndex]?.qty === undefined) &&
                (cloneService[outerIndex]?.ratePerHour === null || cloneService[outerIndex]?.ratePerHour === undefined)
            ) {
                cloneService[outerIndex].pricingType = PRICING_TYPES.FXIED;
            }

            setServiceListPayload(cloneService);
            // Removing a part is an unsaved change too.
            if (!isDirty) {
                markSaved();
            }
            setSearchInventory('');
        } catch (error) {
        } finally {
            setIsOpenPartDeleteModal({
                open: false,
                outerIndex: 0,
                innerIndex: 0,
            });
        }
    };

    const handleClosePriceChangeModal = (outerIndex, innerIndex) => {
        const clone = JSON.parse(JSON.stringify(serviceListPayload));
        const partCost = clone[outerIndex].parts[innerIndex].partCost || 0;
        clone[outerIndex].parts[innerIndex].partCost = partCost;
        const partQty = clone[outerIndex].parts[innerIndex].partQty || 0;
        const qty = Number(partQty) || 0;
        const cost = Number(partCost) || 0;
        clone[outerIndex].parts[innerIndex].totalAmount = qty && cost ? Number(NumericEngine.multiply(qty, cost)) : 0;

        if (clone[outerIndex].parts[innerIndex].batchArray?.length > 0) {
            clone[outerIndex].parts[innerIndex].batchArray = clone[outerIndex].parts[innerIndex].batchArray.map((batch) => ({
                ...batch,
                batchCost: partCost,
            }));
        } else {
            clone[outerIndex].parts[innerIndex].batchArray = [{ batchCost: partCost }];
        }

        setServiceListPayload(clone);
        setOpenPriceChangeModal({
            open: false,
            outerIndex: 0,
            innerIndex: 0,
        });
        previousPriceRef.current = null;
    };

    const [openBatchSelectionModal, setBatchSelectionModal] = useState(false);
    const [usedBatchQty, setUsedBatchQty] = useState({});
    const [inventoryOption, setInventoryOption] = useState(null);

    const partItemRowStyle = (isLast) => ({
        borderBottom: isLast ? '1px solid #E0E0E0' : 'none',
        paddingBottom: isLast ? '' : '0px',
    });

    return (
        <>
            <form
                onSubmit={handleSubmit(validateInvoice)}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    position: 'relative',
                    width: '100%',
                    minHeight: 'calc(100vh - 64px)',
                }}
            >
                <Box
                    padding={'24px'}
                    sx={{
                        width: '100%',
                    }}
                >
                    {/* PageHeader  */}
                    <Grid container gap={'8px'}>
                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <div role="presentation" onClick={handleClick}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link to="/work-orders/all" style={{ color: 'black', textDecoration: 'none' }}>
                                        Work Orders
                                    </Link>
                                    <Link style={{ color: 'black', textDecoration: 'none' }}>{id ? breadcrumbStatusLabel : 'New Work Order '}</Link>
                                </Breadcrumbs>
                            </div>

                            {/* Linked documents — on the breadcrumb row, right-aligned, as on the detail page. */}
                            <Stack alignItems="flex-end" spacing={0.5}>
                                <LinkedDocumentLink
                                    to={getEstimateDetailUrl(firstLinked(invoiceData?.linkedEstimateId) || location.state?.estimateData)}
                                    documentNumber={(firstLinked(invoiceData?.linkedEstimateId) || location.state?.estimateData)?.estimateNumber}
                                />
                                <LinkedDocumentLink
                                    to={getInvoiceDetailUrl(firstLinked(invoiceData?.linkedInvoiceId))}
                                    documentNumber={firstLinked(invoiceData?.linkedInvoiceId)?.invoiceNumber}
                                />
                            </Stack>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center">
                                <Typography variant="h4" sx={{ fontWeight: '500' }}>
                                    {id ? 'Edit ' : 'New '}
                                    Work Order
                                </Typography>
                                {(!id ? invoiceNumberData?.workOrderNumber : invoiceData?.workOrderNumber) && (
                                    <Typography variant="h4" sx={{ fontWeight: '500' }}>
                                        {!id ? invoiceNumberData?.workOrderNumber : invoiceData?.workOrderNumber}
                                    </Typography>
                                )}
                            </Stack>
                        </Grid>
                    </Grid>

                    {/* MainBodyGrid  */}
                    <Grid container margin={'32px 0'}>
                        <Grid item container spacing={3}>
                            {/* LeftSideGrid InvoiceDetail section */}
                            <Grid item container xs={12} sm={12} md={12} lg={4} spacing={3} style={{ height: 'max-content' }}>
                                {/* InvoiceDetaailAccordian  */}
                                <Grid item xs={12}>
                                    <Accordion
                                        expanded={accordianExpanded.includes(0)}
                                        style={{
                                            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.10)',
                                            borderRadius: '8px',
                                            background: '#fff',
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={
                                                <IconButton style={{ background: '#334FA9', padding: '0', width: '30px', height: '30px' }}>
                                                    <KeyboardArrowDown sx={{ color: '#fff', fontSize: '26px' }} />
                                                </IconButton>
                                            }
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            className="accordianSummaryPadding"
                                            style={{
                                                minHeight: '80px',
                                            }}
                                            onClick={() => {
                                                handleAccordianToggle(0);
                                            }}
                                        >
                                            <div className="accordianTitleWrapper">
                                                <InvoiceDetailSvg /> <Typography className="accordianTitle">Work Order Details</Typography>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordianDetailsWrapper">
                                            <Grid container>
                                                <Grid item container columns={12} spacing={3}>
                                                    {/* CustomerField  */}
                                                    <Grid item xs={12} sm={12}>
                                                        <Stack spacing={0}>
                                                            <FormControl fullWidth required error={!!errors.customerId}>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    <Typography className="formLabelTitle" mb={1}>
                                                                        Customer <span style={{ color: REQUIRED_RED }}>*</span>
                                                                    </Typography>
                                                                    <Grid item>
                                                                        {customerCreatedFrom == 'shop_imported' ? (
                                                                            <Typography
                                                                                color={'secondary'}
                                                                                fontWeight={500}
                                                                                fontSize={'15px'}
                                                                                onClick={() => {
                                                                                    //  setOpenCustomerInfo(true);
                                                                                    setIsEditCustomer(true);
                                                                                    setOpenAddCustomerModal(true);
                                                                                }}
                                                                                sx={{ cursor: 'pointer' }}
                                                                            >
                                                                                {' '}
                                                                                + Add Customer Info
                                                                            </Typography>
                                                                        ) : (
                                                                            <Grid item display="flex" alignItems="center" gap={0}>
                                                                                {/* {customerData?.createdFrom === SHOP_CREATED && customerData?.refIdUsers && ( */}
                                                                                {customerData && (customerData?.refIdUsers || customerData?._id) && (
                                                                                    <>
                                                                                        <Stack
                                                                                            direction="row"
                                                                                            alignItems="center"
                                                                                            spacing={0}
                                                                                            onClick={() => {
                                                                                                setIsEditCustomer(true);
                                                                                                setOpenAddCustomerModal(true);
                                                                                            }}
                                                                                        >
                                                                                            <Edit
                                                                                                color="secondary"
                                                                                                sx={{
                                                                                                    width: '16px',
                                                                                                    height: '16px',
                                                                                                    mr: '6px',
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                            />

                                                                                            <Typography
                                                                                                color={'secondary'}
                                                                                                fontWeight={500}
                                                                                                fontSize={'15px'}
                                                                                                sx={{ cursor: 'pointer' }}
                                                                                                // onClick={() => {
                                                                                                //     setOpenAddCustomerModal(true);
                                                                                                //     setIsEditCustomer(true);

                                                                                                // }}
                                                                                            >
                                                                                                Edit
                                                                                            </Typography>
                                                                                        </Stack>
                                                                                        {!customerId && !appointmentId && (
                                                                                            <Divider
                                                                                                orientation="vertical"
                                                                                                variant="middle"
                                                                                                flexItem
                                                                                                sx={{ mx: 1, height: '20px' }}
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                                {!customerId && !appointmentId && (
                                                                                    <Stack
                                                                                        direction={'row'}
                                                                                        alignItems={'center'}
                                                                                        sx={{ cursor: 'pointer' }}
                                                                                        onClick={() => {
                                                                                            setOpenAddCustomerModal(true);

                                                                                            setIsEditCustomer(false);
                                                                                        }}
                                                                                    >
                                                                                        <Add color="secondary" sx={{ mr: '2px' }} />
                                                                                        <Typography
                                                                                            color={'secondary'}
                                                                                            fontWeight={500}
                                                                                            fontSize={'15px'}
                                                                                            sx={{ cursor: 'pointer' }}
                                                                                        >
                                                                                            New
                                                                                        </Typography>
                                                                                    </Stack>
                                                                                )}
                                                                            </Grid>
                                                                        )}
                                                                    </Grid>
                                                                </div>

                                                                <Controller
                                                                    name="customerId" // Form field name
                                                                    control={control}
                                                                    rules={{ required: 'Customer is required' }} // Validation rule
                                                                    render={({ field: { onChange, value, name, ref } }) => {
                                                                        const selectedCustomer =
                                                                            (customerDetail &&
                                                                                customerDetail.length > 0 &&
                                                                                customerDetail.find(
                                                                                    (customer) =>
                                                                                        value &&
                                                                                        customer._id &&
                                                                                        customer.refIdUsers &&
                                                                                        (customer._id === value || customer.refIdUsers === value)
                                                                                )) ||
                                                                            customerData ||
                                                                            null;

                                                                        return (
                                                                            <Autocomplete
                                                                                ref={ref}
                                                                                name={name}
                                                                                disablePortal
                                                                                id="combo-box-demo"
                                                                                options={customerDetail ? customerDetail : []}
                                                                                getOptionLabel={(option) =>
                                                                                    // option.firstName + " " + option.lastName
                                                                                    option.fullName || option.firstName + ' ' + option.lastName
                                                                                }
                                                                                onClose={() => {
                                                                                    const isCustomer = getValues()?.customerId;
                                                                                    if (!isCustomer) {
                                                                                        setPage(1);
                                                                                        customersLists(1, customerLimit, null);
                                                                                    }
                                                                                }}
                                                                                value={selectedCustomer}
                                                                                onChange={(event, newValue) => {
                                                                                    if (newValue?.refIdUsers || newValue?._id) {
                                                                                        if (invoiceDataInStore.vehicleId) {
                                                                                            const { vehicleId, ...rest } = invoiceDataInStore;
                                                                                            setInvoiceDataInStore({
                                                                                                ...rest,
                                                                                                customerId: newValue?.refIdUsers || newValue?._id,
                                                                                            });
                                                                                        } else {
                                                                                            setInvoiceDataInStore({
                                                                                                ...invoiceDataInStore,
                                                                                                customerId: newValue?.refIdUsers || newValue?._id,
                                                                                            });
                                                                                        }
                                                                                    } else if (invoiceDataInStore.vehicleId || invoiceDataInStore.customerId) {
                                                                                        const { vehicleId, customerId, ...rest } = invoiceDataInStore;
                                                                                        setInvoiceDataInStore(rest);
                                                                                    }
                                                                                    setValue('vehicleId', null);
                                                                                    setVehicleData('');
                                                                                    setCustomerData(newValue);
                                                                                    clearErrors('customerId');
                                                                                    onChange(newValue);
                                                                                    setCustomerCreatedFrom(newValue?.createdFrom);
                                                                                    if (customerData != null) {
                                                                                        setData('');
                                                                                    }
                                                                                }}
                                                                                loading={customerListLoader}
                                                                                loadingText={
                                                                                    <div
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            justifyContent: 'center',
                                                                                        }}
                                                                                    >
                                                                                        {' '}
                                                                                        <CircularProgress />
                                                                                    </div>
                                                                                }
                                                                                renderInput={(params) => {
                                                                                    const endAdornment = params.InputProps.endAdornment;

                                                                                    // Extract clear and dropdown icons
                                                                                    const clearIcon = endAdornment?.props?.children?.[0] || null;
                                                                                    const dropdownIcon = endAdornment?.props?.children?.[1] || null;

                                                                                    return (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            label=""
                                                                                            onChange={(e) => handleInputDebounced(e, e.target.value)}
                                                                                            onBlur={handleBlur}
                                                                                            InputProps={{
                                                                                                ...params.InputProps,
                                                                                                endAdornment: (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '6px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {/* Clear icon */}
                                                                                                        {clearIcon && (
                                                                                                            <Box
                                                                                                                sx={{
                                                                                                                    display: 'flex',
                                                                                                                    alignItems: 'center',
                                                                                                                    mr: '2px',
                                                                                                                }}
                                                                                                            >
                                                                                                                {clearIcon}
                                                                                                            </Box>
                                                                                                        )}

                                                                                                        {/* Fleet icon */}
                                                                                                        {(customerData?.isFleetCustomer ||
                                                                                                            customerData?.shopCustomer?.isFleetCustomer) && (
                                                                                                            <FleetIconSvg width="42px" height="30px" />
                                                                                                        )}

                                                                                                        {/* Dropdown arrow icon */}
                                                                                                        {dropdownIcon && (
                                                                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                                                {dropdownIcon}
                                                                                                            </Box>
                                                                                                        )}
                                                                                                    </Box>
                                                                                                ),
                                                                                            }}
                                                                                        />
                                                                                    );
                                                                                }}
                                                                                ListboxProps={{
                                                                                    style: { maxHeight: '300px' },
                                                                                    onScroll: (event) => {
                                                                                        handleScroll(event);
                                                                                    },
                                                                                }}
                                                                                disabled={customerId || appointmentId || customerTypeData.length == 0}
                                                                                renderOption={(props, option) => (
                                                                                    <>
                                                                                        <Box component="li" {...props} style={{ padding: '0' }}>
                                                                                            <li
                                                                                                {...props}
                                                                                                style={{
                                                                                                    width: '100%',
                                                                                                    display: 'flex',
                                                                                                    justifyContent: 'space-between',
                                                                                                    alignItems: 'center',
                                                                                                    padding: '16px',
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    if (option.createdFrom == 'shop_imported') {
                                                                                                        setCustomerData(option);
                                                                                                        setIsEditCustomer(true);
                                                                                                        setOpenAddCustomerModal(true);
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                {/* Left block (name + phone) */}
                                                                                                <Box
                                                                                                    sx={{
                                                                                                        display: 'flex',
                                                                                                        flexDirection: 'column',
                                                                                                        gap: '6px',
                                                                                                        flex: 1,
                                                                                                        minWidth: 0,
                                                                                                    }}
                                                                                                >
                                                                                                    <Typography
                                                                                                        fontWeight={600}
                                                                                                        fontSize={16}
                                                                                                        sx={{
                                                                                                            whiteSpace: 'nowrap',
                                                                                                            overflow: 'hidden',
                                                                                                            textOverflow: 'ellipsis',
                                                                                                        }}
                                                                                                    >
                                                                                                        {option.fullName}
                                                                                                    </Typography>

                                                                                                    <Typography
                                                                                                        fontSize={14}
                                                                                                        fontWeight={400}
                                                                                                        letterSpacing={'0.15px'}
                                                                                                        lineHeight={'150%'}
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '6px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {PhoneTypeIcon(
                                                                                                            option?.primaryPhoneNumberType || 'mobile'
                                                                                                        )}
                                                                                                        {option.phoneNumber
                                                                                                            ? inputFormatPhoneNumber(option.phoneNumber)
                                                                                                            : ''}
                                                                                                    </Typography>

                                                                                                    {option.company && (
                                                                                                        <Typography
                                                                                                            fontSize={14}
                                                                                                            fontWeight={400}
                                                                                                            letterSpacing={'0.15px'}
                                                                                                            lineHeight={'150%'}
                                                                                                            sx={{
                                                                                                                display: 'flex',
                                                                                                                alignItems: 'center',
                                                                                                                gap: '6px',
                                                                                                            }}
                                                                                                        >
                                                                                                            <svg
                                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                                width="20"
                                                                                                                height="21"
                                                                                                                viewBox="0 0 20 21"
                                                                                                                fill="none"
                                                                                                            >
                                                                                                                <path
                                                                                                                    d="M3.33268 18.0001C2.87435 18.0001 2.48213 17.837 2.15602 17.5109C1.8299 17.1848 1.66657 16.7923 1.66602 16.3334V7.16675C1.66602 6.70841 1.82935 6.31619 2.15602 5.99008C2.48268 5.66397 2.8749 5.50064 3.33268 5.50008H6.66602V3.83341C6.66602 3.37508 6.82935 2.98286 7.15602 2.65675C7.48268 2.33064 7.8749 2.1673 8.33268 2.16675H11.666C12.1243 2.16675 12.5168 2.33008 12.8435 2.65675C13.1702 2.98341 13.3332 3.37564 13.3327 3.83341V5.50008H16.666C17.1243 5.50008 17.5168 5.66341 17.8435 5.99008C18.1702 6.31675 18.3332 6.70897 18.3327 7.16675V16.3334C18.3327 16.7917 18.1696 17.1842 17.8435 17.5109C17.5174 17.8376 17.1249 18.0006 16.666 18.0001H3.33268ZM8.33268 5.50008H11.666V3.83341H8.33268V5.50008Z"
                                                                                                                    fill="#006CDD"
                                                                                                                />
                                                                                                            </svg>
                                                                                                            {option.company}
                                                                                                        </Typography>
                                                                                                    )}
                                                                                                </Box>

                                                                                                {/* Right block (icon + chip) */}
                                                                                                <Box
                                                                                                    sx={{
                                                                                                        display: 'flex',
                                                                                                        alignItems: 'center',
                                                                                                        justifyContent: 'flex-end',
                                                                                                        gap: '12px',
                                                                                                        pl: 2,
                                                                                                    }}
                                                                                                >
                                                                                                    {(option?.isFleetCustomer ||
                                                                                                        option?.shopCustomer?.isFleetCustomer) && (
                                                                                                        <FleetIconSvg height="30px" width="42px" />
                                                                                                    )}
                                                                                                    <Chip
                                                                                                        label={
                                                                                                            option.createdFrom === SHOP_CREATED
                                                                                                                ? 'Shop Created'
                                                                                                                : option.createdFrom === SHOP_IMPORTED
                                                                                                                  ? 'Shop Imported'
                                                                                                                  : 'Apex Auto'
                                                                                                        }
                                                                                                        sx={{
                                                                                                            borderRadius: '100px',
                                                                                                            fontSize: '13px',
                                                                                                            fontWeight: 500,
                                                                                                            lineHeight: '18px',
                                                                                                            height: '30px',
                                                                                                            px: '8px',
                                                                                                            backgroundColor:
                                                                                                                option.createdFrom === SHOP_CREATED
                                                                                                                    ? CHIP_COLOR.SHOP_CREATED_BG
                                                                                                                    : option.createdFrom === SHOP_IMPORTED
                                                                                                                      ? CHIP_COLOR.SHOP_IMPORTED_BG
                                                                                                                      : CHIP_COLOR.APEX_AUTO_APP_BG,
                                                                                                            color:
                                                                                                                option.createdFrom === SHOP_CREATED
                                                                                                                    ? CHIP_COLOR.SHOP_CREATED_COLOR
                                                                                                                    : option.createdFrom === SHOP_IMPORTED
                                                                                                                      ? CHIP_COLOR.SHOP_IMPORTED_COLOR
                                                                                                                      : CHIP_COLOR.APEX_AUTO_APP_COLOR,
                                                                                                        }}
                                                                                                    />
                                                                                                </Box>
                                                                                            </li>
                                                                                        </Box>

                                                                                        {customerListLoader && (
                                                                                            <Box component="li" {...props}>
                                                                                                {props['data-option-index'] + 1 == customerDetail?.length &&
                                                                                                    customerListLoader && (
                                                                                                        <li
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                justifyContent: 'center',

                                                                                                                display: 'flex',
                                                                                                            }}
                                                                                                        >
                                                                                                            <CircularProgress />
                                                                                                        </li>
                                                                                                    )}
                                                                                            </Box>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                                sx={{
                                                                                    height: '50px',
                                                                                    boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                                    borderRadius: '8px',
                                                                                    '& .MuiInputBase-root': {
                                                                                        padding: '0 0 0 12px',
                                                                                        border: 'none',
                                                                                        height: '50px',
                                                                                    },
                                                                                    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                                                        borderRadius: '8px',
                                                                                    },
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        paddingRight: '6px!important',
                                                                                    },
                                                                                }}
                                                                            />
                                                                        );
                                                                    }}
                                                                />
                                                                {errors.customerId && <FormHelperText error>{errors.customerId.message}</FormHelperText>}
                                                            </FormControl>
                                                            {/* Shop Imported */}
                                                            <Stack direction={'row'} gap={0} flexWrap={'wrap'}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={state.shop_created}
                                                                            onChange={handleCheckChange}
                                                                            name="shop_created"
                                                                            disabled={customerId || appointmentId}
                                                                        />
                                                                    }
                                                                    labelPlacement="end"
                                                                    label="Shop Created"
                                                                />
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={state.shop_imported}
                                                                            onChange={handleCheckChange}
                                                                            name="shop_imported"
                                                                            disabled={customerId || appointmentId}
                                                                        />
                                                                    }
                                                                    labelPlacement="end"
                                                                    label="Shop Imported"
                                                                />
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={state.apex_auto_app}
                                                                            onChange={handleCheckChange}
                                                                            name="apex_auto_app"
                                                                            disabled={customerId || appointmentId}
                                                                        />
                                                                    }
                                                                    labelPlacement="end"
                                                                    label="Apex Auto"
                                                                />
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>

                                                    {/* Vehcle field */}
                                                    <Grid item xs={12} sm={12}>
                                                        <FormControl
                                                            fullWidth
                                                            error={!!errors.vehicleId} // Show error if validation fails
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Typography className="formLabelTitle" mb={1}>
                                                                    Vehicle <span style={{ color: REQUIRED_RED }}>*</span>
                                                                </Typography>

                                                                <Stack direction={'row'} alignItems={'center'}>
                                                                    {vehicleData && getValues().vehicleId && (
                                                                        <>
                                                                            <Stack
                                                                                direction={'row'}
                                                                                alignItems={'center'}
                                                                                sx={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    // open new VehicleModalV4 in edit mode
                                                                                    const selected = Array.isArray(data)
                                                                                        ? data.find((v) => v._id === getValues().vehicleId)
                                                                                        : null;
                                                                                    setEditVehicleData(selected || null);

                                                                                    handleVehicleOpen();
                                                                                }}
                                                                            >
                                                                                <Edit color="secondary" sx={{ width: '18px', height: '18px', mr: '6px' }} />

                                                                                <Typography
                                                                                    color={'secondary'}
                                                                                    fontWeight={500}
                                                                                    fontSize={'15px'}
                                                                                    sx={{ cursor: 'pointer' }}
                                                                                >
                                                                                    Edit
                                                                                </Typography>
                                                                            </Stack>

                                                                            {!appointmentId && (
                                                                                <Divider
                                                                                    orientation="vertical"
                                                                                    variant="middle"
                                                                                    flexItem
                                                                                    sx={{ mx: 1, height: '20px' }}
                                                                                />
                                                                            )}
                                                                        </>
                                                                    )}

                                                                    {customerData && customerData?.createdFrom != 'shop_imported' && !appointmentId && (
                                                                        <Stack
                                                                            direction={'row'}
                                                                            alignItems={'center'}
                                                                            sx={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                // open add vehicle modal (existing flow)

                                                                                setEditVehicleData(null);
                                                                                handleVehicleOpen();
                                                                            }}
                                                                        >
                                                                            <Add color="secondary" sx={{ mr: '2px' }} />

                                                                            <Typography
                                                                                color={'secondary'}
                                                                                fontWeight={500}
                                                                                fontSize={'15px'}
                                                                                sx={{ cursor: 'pointer' }}
                                                                            >
                                                                                Add
                                                                            </Typography>
                                                                        </Stack>
                                                                    )}
                                                                </Stack>
                                                            </div>

                                                            <Controller
                                                                name="vehicleId" // Form field name
                                                                control={control}
                                                                rules={{ required: 'Vehicle is required' }} // Validation rule
                                                                render={({ field: { onChange, value, name, ref } }) => (
                                                                    <Autocomplete
                                                                        open={vehicleDropdownOpen}
                                                                        onOpen={() => setVehicleDropdownOpen(true)}
                                                                        onClose={() => setVehicleDropdownOpen(false)}
                                                                        disabled={appointmentId}
                                                                        id="vehicle-select-autocomplete"
                                                                        name={name}
                                                                        ref={ref}
                                                                        options={data?.length > 0 ? data : []}
                                                                        loading={vehicleDropdownLoading}
                                                                        value={
                                                                            Array.isArray(data) && customerData
                                                                                ? data.find((item) => item._id === vehicleData) || ''
                                                                                : ''
                                                                        }
                                                                        filterOptions={(options, state) => {
                                                                            const inputValue = state.inputValue.toLowerCase().trim();

                                                                            // Add this guard — MUI sometimes calls with empty string on open
                                                                            if (!inputValue) return options;

                                                                            const searchWords = inputValue.split(' ').filter(Boolean);

                                                                            return options.filter((option) => {
                                                                                const valuesToCheck = [
                                                                                    option?.vehicleMake?.name,
                                                                                    option?.vehicleModel?.name,
                                                                                    option?.vehicleModelTrim?.name,
                                                                                    option?.vehicleModelTrim?.description,
                                                                                    option?.vehicleYear?.toString(),
                                                                                    option?.year?.toString(),
                                                                                    option?.vin,
                                                                                    option?.licenseNumber,
                                                                                    option?.fleetUnitNumber,
                                                                                    option?.provinceCode,
                                                                                ]
                                                                                    .filter(Boolean)
                                                                                    .map((v) => v.toLowerCase());

                                                                                return searchWords.every((word) =>
                                                                                    valuesToCheck.some((field) => field.includes(word))
                                                                                );
                                                                            });
                                                                        }}
                                                                        getOptionKey={(option) => option._id}
                                                                        getOptionLabel={(option) => {
                                                                            if (!option) return '';
                                                                            return [
                                                                                option.vehicleYear || option.year || '',
                                                                                option?.vehicleMake?.name || '',
                                                                                option?.vehicleModel?.name || '',
                                                                            ]
                                                                                .filter(Boolean) // remove empty values
                                                                                .join(' '); // join with space (trim shown in dropdown rows, not title)
                                                                        }}
                                                                        loadingText={
                                                                            <div
                                                                                style={{
                                                                                    display: 'flex',
                                                                                    justifyContent: 'center',
                                                                                }}
                                                                            >
                                                                                {' '}
                                                                                <CircularProgress />
                                                                            </div>
                                                                        }
                                                                        onChange={(event, newValue) => {
                                                                            if (newValue?.source && newValue?.source == 'shop_imported') {
                                                                                setEditVehicleData(newValue);
                                                                                handleVehicleOpen();
                                                                                return;
                                                                            }
                                                                            if (newValue?._id) {
                                                                                setInvoiceDataInStore({
                                                                                    ...invoiceDataInStore,
                                                                                    vehicleId: newValue?._id,
                                                                                });
                                                                                // Save vehicle make information
                                                                                if (newValue?.vehicleMake) {
                                                                                    setSelectedVehicleMake({
                                                                                        _id: newValue.vehicleMake._id,
                                                                                        name: newValue.vehicleMake.name,
                                                                                    });
                                                                                }
                                                                            } else if (invoiceDataInStore.vehicleId) {
                                                                                const { vehicleId, ...rest } = invoiceDataInStore;
                                                                                setInvoiceDataInStore(rest);
                                                                                // Clear selected vehicle make when vehicle is cleared
                                                                                setSelectedVehicleMake(null);
                                                                            }
                                                                            setVehicleData(newValue?._id);
                                                                            clearErrors('vehicleId');
                                                                            onChange(newValue?._id);
                                                                        }}
                                                                        ListboxProps={{
                                                                            style: { maxHeight: '300px' },
                                                                        }}
                                                                        renderInput={(params) => {
                                                                            const endAdornment = params.InputProps.endAdornment;
                                                                            const clearIcon = endAdornment?.props?.children?.[0] || null;
                                                                            const dropdownIcon = endAdornment?.props?.children?.[1] || null;

                                                                            return (
                                                                                <TextField
                                                                                    {...params}
                                                                                    label=""
                                                                                    InputProps={{
                                                                                        ...params.InputProps,
                                                                                        endAdornment: (
                                                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                                                {/* Clear icon */}
                                                                                                {clearIcon && (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            mr: '2px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {clearIcon}
                                                                                                    </Box>
                                                                                                )}

                                                                                                {/* Show License Plate chip only after selection */}
                                                                                                {/* {vehicleData?._id && vehicleData.licenseNumber && (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                                                                                            borderRadius: '100px',
                                                                                                            padding: '4px 10px',
                                                                                                            fontSize: '14px',
                                                                                                            fontWeight: 500,
                                                                                                            color: '#000',
                                                                                                            display: 'flex',
                                                                                                            justifyContent: 'center',
                                                                                                            alignItems: 'center',
                                                                                                            flexShrink: 0,
                                                                                                        }}
                                                                                                    >
                                                                                                        {`${
                                                                                                            vehicleData?.provinceCode
                                                                                                                ? vehicleData.provinceCode + ' '
                                                                                                                : ''
                                                                                                        }${vehicleData.licenseNumber}`}
                                                                                                    </Box>
                                                                                                )} */}

                                                                                                {/* Dropdown arrow icon */}
                                                                                                {dropdownIcon && (
                                                                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                                        {dropdownIcon}
                                                                                                    </Box>
                                                                                                )}
                                                                                            </Box>
                                                                                        ),
                                                                                    }}
                                                                                />
                                                                            );
                                                                        }}
                                                                        renderOption={(props, option) => {
                                                                            const vehicleTitle = [
                                                                                option.vehicleYear || option.year || '',
                                                                                option?.vehicleMake?.name || '',
                                                                                option?.vehicleModel?.name || '',
                                                                                // option?.vehicleModelTrim?.name || '',
                                                                            ]
                                                                                .filter(Boolean)
                                                                                .join(' ');

                                                                            const trimDetail =
                                                                                option?.vehicleModelTrim?.description?.trim() ||
                                                                                option?.vehicleModelTrim?.name?.trim() ||
                                                                                '';
                                                                            const showTrimRow = Boolean(trimDetail);
                                                                            const showVinRow = Boolean(option?.vin);
                                                                            const showFleetRow = Boolean(option?.fleetUnitNumber);

                                                                            return (
                                                                                <Box
                                                                                    component="li"
                                                                                    {...props}
                                                                                    sx={{
                                                                                        display: 'flex',
                                                                                        justifyContent: 'space-between',
                                                                                        alignItems: 'center',
                                                                                        gap: 1.5,
                                                                                        width: '100%',
                                                                                        maxWidth: '100%',
                                                                                        overflow: 'hidden',
                                                                                        py: 1.25,
                                                                                    }}
                                                                                >
                                                                                    <Box
                                                                                        sx={{
                                                                                            flex: 1,
                                                                                            minWidth: 0,
                                                                                            overflow: 'hidden',
                                                                                        }}
                                                                                    >
                                                                                        <Typography
                                                                                            sx={{
                                                                                                fontSize: '16px',
                                                                                                fontWeight: 500,
                                                                                                color: '#212121',
                                                                                                lineHeight: '130%',
                                                                                                overflow: 'hidden',
                                                                                                textOverflow: 'ellipsis',
                                                                                                whiteSpace: 'nowrap',
                                                                                                lineHeight: '130%',
                                                                                            }}
                                                                                        >
                                                                                            {vehicleTitle}
                                                                                        </Typography>

                                                                                        {(showTrimRow || showVinRow || showFleetRow) && (
                                                                                            <Stack spacing={0.5} sx={{ mt: 0.75 }}>
                                                                                                {showTrimRow && (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '8px',
                                                                                                            minWidth: 0,
                                                                                                        }}
                                                                                                    >
                                                                                                        <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                                            <CustomerTrim />
                                                                                                        </Box>
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '14px',
                                                                                                                fontWeight: 400,
                                                                                                                color: 'rgba(0, 0, 0, 0.6)',
                                                                                                                lineHeight: '143%',
                                                                                                                overflow: 'hidden',
                                                                                                                letterSpacing: '0.15px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {trimDetail}
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {showVinRow && (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '8px',
                                                                                                            minWidth: 0,
                                                                                                        }}
                                                                                                    >
                                                                                                        <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                                            <CustomerVin />
                                                                                                        </Box>
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '14px',
                                                                                                                fontWeight: 400,
                                                                                                                color: 'rgba(0, 0, 0, 0.6)',
                                                                                                                lineHeight: '143%',
                                                                                                                letterSpacing: '0.15px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {option.vin}
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                )}
                                                                                                {showFleetRow && (
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            display: 'flex',
                                                                                                            alignItems: 'center',
                                                                                                            gap: '8px',
                                                                                                            minWidth: 0,
                                                                                                        }}
                                                                                                    >
                                                                                                        <Box sx={{ flexShrink: 0, display: 'flex' }}>
                                                                                                            <CustomerFleet />
                                                                                                        </Box>
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '14px',
                                                                                                                fontWeight: 400,
                                                                                                                color: 'rgba(0, 0, 0, 0.6)',
                                                                                                                lineHeight: '143%',
                                                                                                                overflow: 'hidden',
                                                                                                                letterSpacing: '0.15px',
                                                                                                            }}
                                                                                                        >
                                                                                                            {option.fleetUnitNumber}
                                                                                                        </Typography>
                                                                                                    </Box>
                                                                                                )}
                                                                                            </Stack>
                                                                                        )}
                                                                                    </Box>

                                                                                    {(option.licenseNumber || option.license) && (
                                                                                        <Box
                                                                                            sx={{
                                                                                                backgroundColor: '#f5f5f5',
                                                                                                border: '1px solid #dcdcdc',
                                                                                                borderRadius: '6px',
                                                                                                padding: '4px 12px',
                                                                                                fontSize: '14px',
                                                                                                fontWeight: 400,
                                                                                                lineHeight: '150%',
                                                                                                letterSpacing: '0.15px',
                                                                                                color: '#333333',
                                                                                                display: 'flex',
                                                                                                justifyContent: 'center',
                                                                                                alignItems: 'center',
                                                                                                flexShrink: 0,
                                                                                                alignSelf: 'center',
                                                                                                textTransform: 'uppercase',
                                                                                            }}
                                                                                        >
                                                                                            {`${option?.provinceCode ? `${option.provinceCode} ` : ''}${
                                                                                                option.licenseNumber || option.license || ''
                                                                                            }`}
                                                                                        </Box>
                                                                                    )}
                                                                                </Box>
                                                                            );
                                                                        }}
                                                                        sx={{
                                                                            height: '50px',
                                                                            boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                            borderRadius: '8px',
                                                                            '& .MuiInputBase-root': {
                                                                                padding: '0 0 0 12px',
                                                                                border: 'none',
                                                                                height: '50px',
                                                                            },
                                                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                                                borderRadius: '8px',
                                                                            },
                                                                            '& .MuiOutlinedInput-root': {
                                                                                paddingRight: '6px!important',
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />

                                                            {errors.vehicleId && <FormHelperText error>{errors.vehicleId.message}</FormHelperText>}
                                                        </FormControl>
                                                    </Grid>

                                                    {/*
                                                     * Work Order Date — shares its row with Mileage. Between ~1200px and ~1390px the
                                                     * side column is too narrow for the two of them: the label wrapped and the fields
                                                     * squeezed. There they each take the full width, like Service Advisor below; they
                                                     * share the row again once there is room.
                                                     */}
                                                    <Grid item xs={12} sm={6} lg={12} xl={6}>
                                                        <Typography className="formLabelTitle" mb={1} sx={{ whiteSpace: 'nowrap' }}>
                                                            Work Order Date <span style={{ color: REQUIRED_RED }}>*</span>
                                                        </Typography>
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <Controller
                                                                name="invoiceDate" // Field name
                                                                control={control}
                                                                render={({ field: { onChange, value, ref, onBlur, name }, fieldState: { error } }) => {
                                                                    return (
                                                                        <DatePicker
                                                                            format={selectInvoiceDate ? 'DD-MMM-YYYY' : 'DD-MM-YYYY'}
                                                                            name={name}
                                                                            ref={ref}
                                                                            onBlur={onBlur}
                                                                            value={selectInvoiceDate ?? null}
                                                                            onChange={(date) => {
                                                                                if (date) {
                                                                                    const formatted = dayjs(dayjs(date).format('YYYY-MM-DD'));
                                                                                    setInvoiceDataInStore({
                                                                                        ...invoiceDataInStore,
                                                                                        invoiceDate: formatted,
                                                                                    });
                                                                                    setSelectInvoiceDate(formatted);
                                                                                    onChange(formatted);

                                                                                    // Sync bottom dates if not manually overridden
                                                                                    if (!isDropOffManuallyChanged.current) {
                                                                                        setSelectDate(formatted);
                                                                                        setValue('dropOffDate', formatted);
                                                                                        setInvoiceDataInStore((prev) => ({
                                                                                            ...prev,
                                                                                            appointmentDroppedOffDate: formatted,
                                                                                        }));
                                                                                    }
                                                                                    if (!isCompletionManuallyChanged.current) {
                                                                                        setCompletionDate(formatted);
                                                                                        setValue('completionDate', formatted);
                                                                                        setInvoiceDataInStore((prev) => ({
                                                                                            ...prev,
                                                                                            appointmentCompletionDate: formatted,
                                                                                        }));
                                                                                    }
                                                                                } else {
                                                                                    const updatedStore = { ...invoiceDataInStore };
                                                                                    delete updatedStore.invoiceDate;
                                                                                    setInvoiceDataInStore(updatedStore);
                                                                                    setSelectInvoiceDate(null);
                                                                                    onChange(null);
                                                                                }
                                                                            }}
                                                                            sx={{
                                                                                height: '50px',
                                                                                width: '100%',
                                                                                boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                                borderRadius: '8px',
                                                                                '& .MuiInputBase-root': {
                                                                                    border: 'none',
                                                                                    padding: '12px 12px 12px 0',
                                                                                    height: '50px',
                                                                                },
                                                                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                                                    borderRadius: '8px',
                                                                                },
                                                                                '& .MuiSvgIcon-root': {
                                                                                    fontSize: '18px',
                                                                                },
                                                                            }}
                                                                            error={!!errors.invoiceDate}
                                                                            helperText={errors.invoiceDate ? errors.invoiceDate.message : ''}
                                                                            slots={{
                                                                                openPickerIcon: CalendarToday,
                                                                            }}
                                                                            slotProps={{
                                                                                field: {
                                                                                    clearable: true,
                                                                                },
                                                                                textField: {
                                                                                    error: !!error, // Set error state for TextField
                                                                                    helperText: error ? error.message : undefined, // Set helper text
                                                                                    required: false, // Always optional since validation rules are commented out
                                                                                    placeholder: 'DD-MM-YYYY',
                                                                                },
                                                                            }}
                                                                        />
                                                                    );
                                                                }}
                                                            />{' '}
                                                        </LocalizationProvider>
                                                    </Grid>

                                                    {/* A work order has no Dropped Off / Work Completion dates — only its own date. */}

                                                    {/* Mileage — shares its row with Work Order Date */}
                                                    <Grid item xs={12} sm={6} lg={12} xl={6}>
                                                        <Typography className="formLabelTitle" mb={1}>
                                                            Mileage
                                                        </Typography>
                                                        <Controller
                                                            name="odoDroppedOff"
                                                            control={control}
                                                            // rules={{
                                                            //   required: !isSaveDraftRef.current
                                                            //     ? "Dropped off odo is required"
                                                            //     : undefined,
                                                            // }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    // type="number"
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                {shopConfigData?.config?.mileageUnit === MILEAGE_UNIT.MILES
                                                                                    ? MILEAGE_UNIT.MILES
                                                                                    : MILEAGE_UNIT.KM}
                                                                                {/* km */}
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                    error={!!errors.odoDroppedOff}
                                                                    helperText={errors.odoDroppedOff ? errors.odoDroppedOff.message : ''}
                                                                    {...field}
                                                                    onChange={(event) => {
                                                                        clearErrors('odoDroppedOff');
                                                                        setValue('odoDroppedOff', FormatNumberForKm(event.target.value));
                                                                        setInvoiceDataInStore({
                                                                            ...invoiceDataInStore,
                                                                            odoDroppedOff: FormatNumberForKm(event.target.value),
                                                                        });
                                                                    }}
                                                                    onKeyDown={handlePreventKeyDownDecimal}
                                                                    InputLabelProps={{
                                                                        shrink: field.value?.length > 0,
                                                                    }}
                                                                    sx={{
                                                                        height: '50px',
                                                                        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                        borderRadius: '8px',
                                                                        '& .MuiInputBase-root': {
                                                                            border: 'none',
                                                                            padding: '12px 12px 12px 0',
                                                                            height: '50px',
                                                                        },
                                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                                            borderRadius: '8px',
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    {/* Service Advisor — full width; a work order has no Technician */}
                                                    <Grid item xs={12}>
                                                        <FormControl
                                                            fullWidth
                                                            error={!!errors.serviceAdvisor} // Show error if validation fails
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <Typography className="formLabelTitle" mb={1}>
                                                                    Service Advisor
                                                                </Typography>
                                                            </div>
                                                            <Controller
                                                                name="serviceAdvisor"
                                                                control={control}
                                                                render={({ field }) => (
                                                                    <Autocomplete
                                                                        id="service-autocomplete"
                                                                        freeSolo
                                                                        forcePopupIcon
                                                                        clearIcon={null}
                                                                        onBlur={() => {
                                                                            if (!field.value || !getValues().serviceAdvisor) {
                                                                                setAdvisorInput('');
                                                                            }
                                                                        }}
                                                                        options={
                                                                            advisorList?.length > 0
                                                                                ? !advisorInput ||
                                                                                  advisorList.some(
                                                                                      (item) => item.name?.toLowerCase() === advisorInput?.toLowerCase()
                                                                                  )
                                                                                    ? advisorList
                                                                                    : [
                                                                                          {
                                                                                              _id: 'new',
                                                                                              name: advisorInput,
                                                                                          },
                                                                                          ...advisorList,
                                                                                      ]
                                                                                : advisorInput
                                                                                  ? [{ _id: 'new', name: advisorInput }]
                                                                                  : []
                                                                        }
                                                                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                                                                        value={
                                                                            (advisorList && advisorList.find((option) => option._id === field.value)) || null
                                                                        }
                                                                        ListboxProps={{
                                                                            style: { maxHeight: '280px' },
                                                                        }}
                                                                        inputValue={advisorInput}
                                                                        onChange={(event, newValue) => {
                                                                            if (
                                                                                typeof newValue === 'string' &&
                                                                                advisorList.find((option) => option.name.toLowerCase() === newValue)
                                                                            ) {
                                                                            } else if (newValue && newValue._id !== 'new') {
                                                                                field.onChange(newValue._id);
                                                                                markSaved();
                                                                            } else {
                                                                                field.onChange(null);
                                                                            }
                                                                        }}
                                                                        onInputChange={(event, newInputValue) => {
                                                                            setAdvisorInput(newInputValue); // Clear the value if the input value changes
                                                                            if (!advisorList.some((option) => option.name === newInputValue)) {
                                                                                field.onChange(null); // Reset selected value when typing
                                                                            }
                                                                        }}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                event.preventDefault();
                                                                                event.stopPropagation();

                                                                                const inputLowerCase = advisorInput.trim().toLowerCase();

                                                                                const filteredOptions = advisorList.filter((option) =>
                                                                                    option.name.toLowerCase().includes(inputLowerCase)
                                                                                );
                                                                                const exactMatch = advisorList.find(
                                                                                    (option) => option.name.toLowerCase() === inputLowerCase
                                                                                );

                                                                                if (exactMatch) {
                                                                                    // If there's an exact match, select it
                                                                                    field.onChange(exactMatch._id);
                                                                                    markSaved();
                                                                                    setAdvisorInput(exactMatch.name);

                                                                                    // Close dropdown after selection
                                                                                    setTimeout(() => document.activeElement.blur(), 0);
                                                                                } else if (inputLowerCase) {
                                                                                    // If no exact match and input is not empty, open modal to save new category
                                                                                    handleSaveAdvisorInput(advisorInput);
                                                                                } else if (filteredOptions.length > 0) {
                                                                                    // If input is empty, select the first filtered option
                                                                                    const firstOption = filteredOptions[0];
                                                                                    field.onChange(firstOption._id);
                                                                                    markSaved(true);
                                                                                    setAdvisorInput(firstOption.name);

                                                                                    // Close dropdown after selection
                                                                                    setTimeout(() => document.activeElement.blur(), 0);
                                                                                }
                                                                            }
                                                                        }}
                                                                        renderOption={(props, option) => {
                                                                            if (option._id === 'new') {
                                                                                return (
                                                                                    <li
                                                                                        {...props}
                                                                                        key={`temp-${option.name}-${Math.random()}`}
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            justifyContent: 'space-between',
                                                                                            height: '44px',
                                                                                            paddingRight: '0px',
                                                                                        }}
                                                                                    >
                                                                                        <span>{`${advisorInput}`}</span>
                                                                                        <Button
                                                                                            size="small"
                                                                                            color="primary"
                                                                                            style={{
                                                                                                background: '#2196F326',
                                                                                            }}
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation(); // Prevent dropdown close
                                                                                                handleSaveAdvisorInput(advisorInput);
                                                                                            }}
                                                                                        >
                                                                                            {loading ? <CircularProgress disableShrink /> : 'Save'}
                                                                                        </Button>
                                                                                    </li>
                                                                                );
                                                                            }
                                                                            return (
                                                                                <li
                                                                                    key={option._id || `temp-${option.name}-${Math.random()}`}
                                                                                    {...props}
                                                                                    style={{
                                                                                        height: '44px',
                                                                                        paddingRight: '0px',
                                                                                    }}
                                                                                >
                                                                                    {option.name}
                                                                                </li>
                                                                            );
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                variant="outlined"
                                                                                error={!!errors.serviceAdvisor}
                                                                                helperText={errors.serviceAdvisor ? errors.serviceAdvisor.message : ''}
                                                                            />
                                                                        )}
                                                                        sx={{
                                                                            height: '50px',
                                                                            boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                            borderRadius: '8px',
                                                                            '& .MuiInputBase-root': {
                                                                                padding: '0 0 0 12px',
                                                                                border: 'none',
                                                                                height: '50px',
                                                                            },
                                                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                                                borderRadius: '8px',
                                                                            },
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.serviceAdvisor && <FormHelperText error>{errors.serviceAdvisor.message}</FormHelperText>}
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>

                                {/* AdditionalDetailsAccordian  */}
                                {screenWidth >= 1200 && (
                                    <AdditionalDetailsAccrodian
                                        type={'workOrder'}
                                        setInvoiceDataInStore={setInvoiceDataInStore}
                                        invoiceDataInStore={invoiceDataInStore}
                                        index={2}
                                        accordianExpanded={accordianExpanded}
                                        handleAccordianToggle={handleAccordianToggle}
                                        setValue={setValue}
                                        errors={errors}
                                        control={control}
                                        hideTerms
                                    />
                                )}
                            </Grid>

                            {/* RightSideGrid AddService section */}
                            <Grid item xs={12} sm={12} md={12} lg={8}>
                                {/* AddServiceSection  */}
                                <Grid item container xs={12}>
                                    <div
                                        className="customBoxWrapper"
                                        style={{
                                            background: isTableVisible ? 'transparent' : '',
                                            boxShadow: isTableVisible ? 'none' : '',
                                            padding: isTableVisible ? '0' : '',
                                        }}
                                    >
                                        {/* ServiceHeader  */}
                                        {!isTableVisible && (
                                            <Grid container alignItems={'center'} justifyContent={'space-between'}>
                                                <Grid>
                                                    <div className="accordianTitleWrapper">
                                                        <ServiceBlueSvg />
                                                        <Typography className="accordianTitle">Services</Typography>
                                                    </div>
                                                </Grid>
                                                <Grid sm="auto">
                                                    <Button
                                                        startIcon={<Add />}
                                                        color="secondary"
                                                        variant={'contained'}
                                                        className="btn-text-size-manage"
                                                        style={{ height: '42px' }}
                                                        onClick={handleAddService}
                                                        sx={{ mr: 2 }}
                                                    >
                                                        ADD SERVICE
                                                    </Button>
                                                    <Button
                                                        startIcon={<Add />}
                                                        color="primary"
                                                        variant={'outlined'}
                                                        className="btn-text-size-manage"
                                                        style={{ height: '42px' }}
                                                        onClick={() => handleOpenSavedServicesModal(null)}
                                                    >
                                                        Saved Service
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {isTableVisible &&
                                            serviceListPayload.map((outerItem, outerIndex) => {
                                                let hasManagedPart = false;
                                                const serviceSubtotal = selectServiceSubtotal(outerItem) ?? '0';
                                                const currentService = serviceListPayload[outerIndex];

                                                if (currentService.pricingType === PRICING_TYPES.LABOUR) {
                                                    if (currentService.parts && currentService.parts.length > 0) {
                                                        const hasPart = currentService.parts.some(
                                                            (part) => part.inventoryType === INVENTORY_MANAGE_TYPE.MANAGED
                                                        );

                                                        if (hasPart) {
                                                            hasManagedPart = true;
                                                        }
                                                    }
                                                }

                                                return (
                                                    <Accordion
                                                        key={outerIndex}
                                                        expanded={serviceExpanded.includes(outerIndex)}
                                                        style={{
                                                            boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.10)',
                                                            borderRadius: '8px',
                                                            background: '#fff',
                                                            marginTop: outerIndex > 0 ? '24px' : '0',
                                                        }}
                                                    >
                                                        <AccordionSummary
                                                            expandIcon={
                                                                <IconButton
                                                                    style={{
                                                                        background: '#334FA9',
                                                                        padding: '0',
                                                                        width: '30px',
                                                                        height: '30px',
                                                                        // marginLeft: "12px",
                                                                    }}
                                                                    onClick={(e) => {
                                                                        e.stopPropagation(); // Prevents summary click from toggling
                                                                        handleToggle(outerIndex);
                                                                    }}
                                                                >
                                                                    <KeyboardArrowDown sx={{ color: '#fff', fontSize: '26px' }} />
                                                                </IconButton>
                                                            }
                                                            aria-controls="panel1-content"
                                                            id="panel1-header"
                                                            className="accordianSummaryPadding"
                                                            style={{
                                                                cursor: 'default',
                                                                background: '#002394',
                                                                minHeight: '62px',
                                                                padding: '16px 24px',
                                                                borderRadius: '4px 4px 0 0',
                                                            }}
                                                        >
                                                            <Stack
                                                                width={'100%'}
                                                                direction={'row'}
                                                                justifyContent={'space-between'}
                                                                alignItems={'center'}
                                                                gap={'12px'}
                                                                position={'relative'}
                                                            >
                                                                <Stack direction={'row'} alignItems={'center'} gap={'4px'}>
                                                                    <ServiceWhiteSvg />
                                                                    <Typography fontSize={24} style={{ color: '#fff' }}>
                                                                        {outerIndex + 1}
                                                                    </Typography>
                                                                </Stack>
                                                                <div
                                                                    style={{
                                                                        width: '100%',
                                                                        minWidth: '200px',
                                                                        marginRight: '12px',
                                                                    }}
                                                                    ref={(el) => (inputDivRef.current[outerIndex] = el)}
                                                                >
                                                                    <Autocomplete
                                                                        freeSolo
                                                                        id={`service-search-autocomplete-${outerIndex}`}
                                                                        disabled={servicesLoading}
                                                                        clearIcon={null}
                                                                        options={serviceFilteredData}
                                                                        filterOptions={(x) => x}
                                                                        open={anchorEls[outerIndex]}
                                                                        onFocus={(event) => {
                                                                            if (cachedServices?.length > 0) {
                                                                                handleOnFocus(event, outerIndex);
                                                                            }
                                                                        }}
                                                                        onBlur={(event) => {
                                                                            setTimeout(() => {
                                                                                if (preventCloseRef.current) {
                                                                                    return; // Do not close if "Save" was clicked
                                                                                }

                                                                                if (serviceListPayload[outerIndex]?.service?._id) {
                                                                                    const filtered = cachedServices.filter(
                                                                                        (item) =>
                                                                                            item.serviceSubCategory._id ===
                                                                                            serviceListPayload[outerIndex]?.service?._id
                                                                                    );

                                                                                    if (filtered.length === 1) {
                                                                                        setServiceListPayload((prevList) =>
                                                                                            prevList.map((service, i) =>
                                                                                                i === outerIndex
                                                                                                    ? {
                                                                                                          ...service,
                                                                                                          service: {
                                                                                                              ...service.service, // Preserve existing properties
                                                                                                              name: filtered[0]?.serviceSubCategory?.name, // Update only name
                                                                                                          },
                                                                                                      }
                                                                                                    : service
                                                                                            )
                                                                                        );
                                                                                    }
                                                                                } else {
                                                                                    let updatedServiceList = [...serviceListPayload];
                                                                                    updatedServiceList[outerIndex] = {
                                                                                        ...updatedServiceList[outerIndex],
                                                                                        type: 'select',
                                                                                        serviceCategory: {
                                                                                            _id: '',
                                                                                            name: '',
                                                                                        },
                                                                                        service: { _id: '', name: '' },
                                                                                    };

                                                                                    setServiceListPayload(updatedServiceList);
                                                                                }
                                                                                if (!inputDivRef.current[outerIndex]?.contains(document.activeElement)) {
                                                                                    setAnchorEls((prev) => {
                                                                                        const newAnchors = prev.map(() => false);
                                                                                        return newAnchors;
                                                                                    });
                                                                                }
                                                                            }, 200);
                                                                        }}
                                                                        value={
                                                                            outerItem?.service?._id
                                                                                ? serviceFilteredData?.length > 0 &&
                                                                                  serviceFilteredData?.find(
                                                                                      (opt) => opt?.serviceSubCategory?._id === outerItem?.service?._id
                                                                                  )
                                                                                : null
                                                                        }
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                event.preventDefault();
                                                                                event.stopPropagation();

                                                                                const highlightedOption =
                                                                                    document.querySelector('li.MuiAutocomplete-option.Mui-focused');
                                                                                const optionText = highlightedOption?.textContent?.trim()?.toLowerCase();

                                                                                const filteredOptions = serviceFilteredData.filter((option) =>
                                                                                    option?.serviceSubCategory?.name
                                                                                        .toLowerCase()
                                                                                        .includes(optionText || outerItem?.service?.name?.toLowerCase() || '')
                                                                                );

                                                                                // Exact match option
                                                                                const exactMatch = serviceFilteredData.find(
                                                                                    (option) =>
                                                                                        option?._id !== 'new' &&
                                                                                        option?.serviceSubCategory?.name?.toLowerCase() ===
                                                                                            (optionText || outerItem?.service?.name?.toLowerCase() || '')
                                                                                );

                                                                                if (exactMatch) {
                                                                                    handleServiceSelection(exactMatch, outerIndex);
                                                                                } else if (outerItem?.service?.name) {
                                                                                    handleSaveService(outerItem?.service?.name, outerIndex);
                                                                                } else if (filteredOptions.length > 0) {
                                                                                    // If input is empty, select the first filtered option
                                                                                    const firstOption = filteredOptions[0];

                                                                                    if (firstOption?._id === 'new') {
                                                                                        handleSaveService(firstOption.serviceSubCategory.name, outerIndex);
                                                                                    } else {
                                                                                        handleServiceSelection(firstOption, outerIndex);
                                                                                    }
                                                                                    // Close dropdown after selection
                                                                                    setTimeout(() => document.activeElement.blur(), 0);
                                                                                }
                                                                            }
                                                                        }}
                                                                        inputValue={outerItem?.service?.name || ''}
                                                                        getOptionLabel={(option) =>
                                                                            typeof option === 'string' ? option : option?.serviceSubCategory?.name || ''
                                                                        }
                                                                        onInputChange={(event, newInputValue, reason) => {
                                                                            // Only process input changes if the Autocomplete is focused/open for this index
                                                                            // This prevents other Autocomplete components from clearing their values
                                                                            // when one Autocomplete's onChange is triggered
                                                                            const isFocused = anchorEls[outerIndex];
                                                                            const isUserInput = reason === 'input';

                                                                            // Only process if:
                                                                            // 1. Autocomplete is focused/open, OR
                                                                            // 2. It's a user input action (typing) - this ensures user typing is always processed
                                                                            if (cachedServices?.length > 0 && (isFocused || isUserInput)) {
                                                                                handleServiceChange(newInputValue, outerIndex);
                                                                            }
                                                                        }}
                                                                        onChange={(event, newValue) => {
                                                                            if (!newValue) {
                                                                                handleServiceChange('', outerIndex);
                                                                            } else if (typeof newValue === 'string') {
                                                                                // Handle freeSolo string input
                                                                            } else {
                                                                                handleServiceSelection(newValue, outerIndex);
                                                                            }
                                                                        }}
                                                                        renderOption={(props, option) => {
                                                                            if (option._id === 'new')
                                                                                return (
                                                                                    <li
                                                                                        {...props}
                                                                                        key={
                                                                                            option?.serviceSubCategory?._id ||
                                                                                            option._id ||
                                                                                            `temp-${Math.random()}`
                                                                                        }
                                                                                        style={{
                                                                                            height: '44px',
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'space-between',
                                                                                            cursor: 'default',
                                                                                            pointerEvents: 'none',
                                                                                            paddingRight: showMenuLoader ? '12px' : '0',
                                                                                        }}
                                                                                        onClick={(event) => {
                                                                                            event.preventDefault();
                                                                                            event.stopPropagation();
                                                                                        }}
                                                                                    >
                                                                                        <span> {option.serviceSubCategory.name}</span>
                                                                                        {showMenuLoader ? (
                                                                                            <CircularProgress />
                                                                                        ) : (
                                                                                            <div
                                                                                                style={{
                                                                                                    display: 'flex',
                                                                                                    justifyContent: 'center',
                                                                                                    padding: '6px 16px',
                                                                                                    background: 'rgba(33, 150, 243, 0.15)',
                                                                                                    cursor: 'pointer',
                                                                                                    pointerEvents: 'all',
                                                                                                }}
                                                                                                onClick={(event) => {
                                                                                                    event.preventDefault();
                                                                                                    event.stopPropagation();
                                                                                                    handleSaveService(
                                                                                                        option.serviceSubCategory.name,
                                                                                                        outerIndex
                                                                                                    );
                                                                                                }}
                                                                                            >
                                                                                                <Save
                                                                                                    sx={{
                                                                                                        color: '#006CDD',
                                                                                                        width: '26px',
                                                                                                        height: '26px',
                                                                                                    }}
                                                                                                />
                                                                                                <span
                                                                                                    style={{
                                                                                                        textDecoration: 'underline',
                                                                                                        color: '#006CDD',
                                                                                                        fontSize: '13px',
                                                                                                        textTransform: 'uppercase',
                                                                                                        fontWeight: 500,
                                                                                                        lineHeight: '26px',
                                                                                                        letterSpacing: '0.46px',
                                                                                                        marginLeft: '8px',
                                                                                                    }}
                                                                                                >
                                                                                                    Save
                                                                                                </span>
                                                                                            </div>
                                                                                        )}
                                                                                    </li>
                                                                                );
                                                                            if (option?.serviceSubCategory?.name) {
                                                                                return (
                                                                                    <li
                                                                                        {...props}
                                                                                        key={
                                                                                            option?.serviceSubCategory?._id ||
                                                                                            option._id ||
                                                                                            `temp-${Math.random()}`
                                                                                        }
                                                                                        style={{
                                                                                            height: '44px',
                                                                                            paddingRight: 0,
                                                                                            background:
                                                                                                option?.serviceSubCategory?._id === outerItem?.service?._id
                                                                                                    ? '#2196F30A'
                                                                                                    : '',
                                                                                        }}
                                                                                    >
                                                                                        {option?.serviceSubCategory?.name}
                                                                                    </li>
                                                                                );
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                placeholder={servicesLoading ? '' : 'Add Service Name'}
                                                                                inputRef={(el) => (inputFielRef.current[outerIndex] = el)}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    disableUnderline: true,
                                                                                }}
                                                                            />
                                                                        )}
                                                                        ListboxProps={{
                                                                            style: { maxHeight: '190px' },
                                                                        }}
                                                                        PopperComponent={(props) => (
                                                                            <Popper
                                                                                {...props}
                                                                                sx={{
                                                                                    '& .MuiAutocomplete-paper': {
                                                                                        borderRadius: '4px!important',
                                                                                        boxShadow:
                                                                                            '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                    },
                                                                                    width: '100%',
                                                                                    maxWidth: '672px',
                                                                                    zIndex: 1300,
                                                                                    borderRadius: '4px!important',
                                                                                    boxShadow:
                                                                                        '0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)!important',
                                                                                }}
                                                                                modifiers={[
                                                                                    {
                                                                                        name: 'offset',
                                                                                        options: {
                                                                                            offset: [0, 14],
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                        name: 'preventOverflow',
                                                                                        options: {
                                                                                            padding: 8,
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                        name: 'flip',
                                                                                        enabled: false,
                                                                                    },
                                                                                ]}
                                                                                placement="bottom-start"
                                                                            />
                                                                        )}
                                                                        sx={{
                                                                            '& .MuiInputBase-root': {
                                                                                width: '100%',
                                                                                backgroundColor: 'transparent',
                                                                                padding: '0',
                                                                                borderRadius: '0!important',
                                                                                height: '34px',
                                                                                fontSize: '16px',
                                                                                fontWeight: '700',
                                                                                lineHeight: '24px',
                                                                                letterSpacing: '0.15px',
                                                                                width: '100%',
                                                                                border: 'none',
                                                                                color: '#fff', // Text color
                                                                                borderBottom: '1px solid rgba(255, 255, 255, 0.42)', // White bottom border
                                                                                '&:hover': {
                                                                                    borderBottom: '1px solid rgba(255, 255, 255, 0.8)', // Slightly darker on hover
                                                                                },
                                                                            },
                                                                            '& .MuiInputBase-input': {
                                                                                height: '34px',
                                                                                fontSize: '16px',
                                                                                fontWeight: '700',
                                                                                lineHeight: '24px',
                                                                                letterSpacing: '0.15px',
                                                                                color: '#FFFFFFDE', // Input text color
                                                                            },
                                                                            '& .MuiInputBase-input::placeholder': {
                                                                                color: '#FFFFFFDE', // Placeholder color same as input text
                                                                                opacity: 1, // Ensure placeholder is fully visible
                                                                            },
                                                                            '& fieldset': {
                                                                                border: 'none',
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Stack>
                                                        </AccordionSummary>
                                                        <AccordionDetails
                                                            style={{
                                                                padding: '0 0 16px 0',
                                                                borderRadius: '0 0 4px 4px',
                                                                background: '#fff',
                                                            }}
                                                        >
                                                            {/* SERVICETABLE */}
                                                            <Grid container item xs={12} boxShadow={0}>
                                                                <TableContainer sx={{ maxHeight: 600, overflowX: 'auto' }}>
                                                                    <Table
                                                                        aria-label="caption table"
                                                                        padding="16px"
                                                                        sx={{
                                                                            width: '100%',
                                                                            minWidth: isNewTaxVersionActive ? 877 : 800,
                                                                            tableLayout: 'fixed',
                                                                        }}
                                                                    >
                                                                        <colgroup>
                                                                            <col style={{ width: 56 }} />
                                                                            <col style={{ minWidth: 320 }} />
                                                                            <col style={{ width: 120 }} />
                                                                            <col style={{ width: 120 }} />
                                                                            <col style={{ width: 120 }} />
                                                                            {isNewTaxVersionActive && <col style={{ width: 80 }} />}
                                                                            <col style={{ width: 50 }} />
                                                                        </colgroup>

                                                                        <TableHead
                                                                            sx={{
                                                                                backgroundColor: '#F8F8F8',
                                                                                height: '40px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                        >
                                                                            <TableRow
                                                                                sx={{
                                                                                    height: '40px',
                                                                                    borderBottom: 'none',
                                                                                    '& > th, & > td': {
                                                                                        px: '12px',
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <TableCell
                                                                                    sx={{
                                                                                        width: '56px',
                                                                                        fontSize: '14px',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                    style={{
                                                                                        paddingTop: '0',
                                                                                        paddingBottom: '0',
                                                                                        paddingLeft: '16px',
                                                                                        paddingRight: '0',
                                                                                    }}
                                                                                >
                                                                                    No.
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        fontSize: '14px',
                                                                                        paddingTop: '0',
                                                                                        paddingBottom: '0',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                    style={{
                                                                                        height: '40px',
                                                                                        paddingLeft: '0',
                                                                                        paddingRight: '10px',
                                                                                    }}
                                                                                >
                                                                                    Description
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        width: '120px',
                                                                                        fontSize: '14px',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                    style={{ padding: '0 10px' }}
                                                                                >
                                                                                    Quantity
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        width: '120px',
                                                                                        fontSize: '14px',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                    style={{ padding: '0 10px' }}
                                                                                >
                                                                                    Price
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        width: '120px',
                                                                                        fontSize: '14px',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                    style={{ padding: '0 10px' }}
                                                                                >
                                                                                    Amount
                                                                                </TableCell>
                                                                                {isNewTaxVersionActive && (
                                                                                    <TableCell
                                                                                        sx={{
                                                                                            width: '80px',
                                                                                            fontSize: '14px',
                                                                                            paddingTop: '0',
                                                                                            paddingBottom: '0',
                                                                                            borderBottom: 'none',
                                                                                        }}
                                                                                    >
                                                                                        Tax
                                                                                    </TableCell>
                                                                                )}
                                                                                <TableCell
                                                                                    sx={{
                                                                                        width: '50px',
                                                                                        fontSize: '12px',
                                                                                        paddingTop: '0',
                                                                                        paddingBottom: '0',
                                                                                        borderBottom: 'none',
                                                                                    }}
                                                                                ></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>

                                                                        <TableBody>
                                                                            {/* WORKINGGGGGG */}
                                                                            {outerItem.showDesc && (
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        colSpan={1}
                                                                                        style={{
                                                                                            paddingLeft: '16px',
                                                                                            paddingRight: '0',
                                                                                        }}
                                                                                    ></TableCell>
                                                                                    <TableCell
                                                                                        colSpan={
                                                                                            outerItem?.pricingType !== 'fixed'
                                                                                                ? 4 + (isNewTaxVersionActive ? 1 : 0)
                                                                                                : 3
                                                                                        }
                                                                                        style={{
                                                                                            paddingLeft: '0',
                                                                                            paddingRight: '10px',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                display: 'flex',
                                                                                                gap: '4px',
                                                                                                alignItems: 'center',
                                                                                                justifyContent: !outerItem?.optionalDescription
                                                                                                    ? 'flex-start'
                                                                                                    : 'space-between',
                                                                                            }}
                                                                                        >
                                                                                            <TextField
                                                                                                inputRef={(el) => (textFieldRef.current[outerIndex] = el)}
                                                                                                multiline
                                                                                                maxRows={5}
                                                                                                variant="standard"
                                                                                                value={outerItem?.optionalDescription ?? ''}
                                                                                                onChange={(event) => {
                                                                                                    setServiceListPayload((prevList) =>
                                                                                                        prevList.map((service, i) =>
                                                                                                            i === outerIndex
                                                                                                                ? {
                                                                                                                      ...service,
                                                                                                                      optionalDescription: event.target.value,
                                                                                                                  }
                                                                                                                : service
                                                                                                        )
                                                                                                    );
                                                                                                    if (!isDirty) {
                                                                                                        markSaved();
                                                                                                    }
                                                                                                }}
                                                                                                fullWidth={
                                                                                                    outerItem?.description && outerItem?.description !== ''
                                                                                                        ? true
                                                                                                        : false
                                                                                                }
                                                                                                placeholder="Add optional description"
                                                                                                InputProps={{
                                                                                                    disableUnderline: true,
                                                                                                    style: {
                                                                                                        width: !outerItem?.optionalDescription
                                                                                                            ? '178px'
                                                                                                            : '100%',
                                                                                                        fontSize: '16px',
                                                                                                        color: 'rgba(0,0,0,0.87)',
                                                                                                        cursor: 'text',
                                                                                                        lineHeight: '143%',
                                                                                                        letterSpacing: '0.17px,',
                                                                                                    },
                                                                                                }}
                                                                                                sx={{
                                                                                                    width: !outerItem?.optionalDescription ? '178px' : '100%',
                                                                                                    padding: 0,
                                                                                                    border: 'none',
                                                                                                    fontSize: '16px',
                                                                                                    '& .MuiInputBase-input': {
                                                                                                        padding: 0,
                                                                                                    },
                                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                                        border: 'none',
                                                                                                    },
                                                                                                }}
                                                                                            />
                                                                                            {!outerItem.optionalDescription && (
                                                                                                <Edit
                                                                                                    size={16}
                                                                                                    style={{
                                                                                                        color: '#646466',
                                                                                                        width: '20px',
                                                                                                        height: '20px',
                                                                                                        cursor: 'pointer',
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        if (textFieldRef.current[outerIndex]) {
                                                                                                            textFieldRef.current[outerIndex].focus();
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            )}
                                                                                        </div>
                                                                                    </TableCell>

                                                                                    {!outerItem?.parts?.length > 0 &&
                                                                                        (outerItem?.qty === null || outerItem?.qty === undefined) &&
                                                                                        (outerItem?.ratePerHour === null ||
                                                                                            outerItem?.ratePerHour === undefined) &&
                                                                                        outerItem?.pricingType === PRICING_TYPES.FXIED && (
                                                                                            <TableCell colSpan={1} align="left" style={{ padding: '6px 10px' }}>
                                                                                                <TextField
                                                                                                    fullWidth
                                                                                                    variant="outlined"
                                                                                                    onKeyDown={handlePreventKeyDownDecimal}
                                                                                                    InputProps={{
                                                                                                        startAdornment: (
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    paddingLeft: '8px',
                                                                                                                    fontSize: '16px',
                                                                                                                }}
                                                                                                            >
                                                                                                                $
                                                                                                            </p>
                                                                                                        ),
                                                                                                    }}
                                                                                                    value={outerItem?.fixedPrice || ''}
                                                                                                    onFocus={(event) => {
                                                                                                        const input = event.target;
                                                                                                        setTimeout(() => {
                                                                                                            input.setSelectionRange(
                                                                                                                input.value.length,
                                                                                                                input.value.length
                                                                                                            );
                                                                                                        }, 0);
                                                                                                    }}
                                                                                                    onChange={(event) => {
                                                                                                        let inputValue = event.target.value;

                                                                                                        if (
                                                                                                            inputValue.length > 1 &&
                                                                                                            inputValue.startsWith('0') &&
                                                                                                            /[1-9a-zA-Z]/.test(inputValue[1])
                                                                                                        ) {
                                                                                                            inputValue = inputValue.slice(1);
                                                                                                        }

                                                                                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                                                                                            let fixedPrice = inputValue;

                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            cloneService[outerIndex].fixedPrice = fixedPrice;
                                                                                                            cloneService[outerIndex].pricingType =
                                                                                                                PRICING_TYPES.FXIED;
                                                                                                            if (!isDirty) {
                                                                                                                markSaved();
                                                                                                            }
                                                                                                            setServiceListPayload(cloneService);
                                                                                                        }
                                                                                                    }}
                                                                                                    sx={{
                                                                                                        height: '40px',
                                                                                                        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                                                        borderRadius: '8px',
                                                                                                        '& .MuiInputBase-root': {
                                                                                                            border: 'none',
                                                                                                            padding: '12px 0 12px 0',
                                                                                                            height: '40px',
                                                                                                            fontSize: '16px',
                                                                                                            letterSpacing: '0.17px',
                                                                                                            lineHeight: '143%',
                                                                                                        },
                                                                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
                                                                                                            {
                                                                                                                borderRadius: '8px',
                                                                                                            },
                                                                                                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                                                                                            {
                                                                                                                WebkitAppearance: 'none',
                                                                                                                margin: 0,
                                                                                                            },
                                                                                                        '& input[type=number]': {
                                                                                                            MozAppearance: 'textfield',
                                                                                                        },
                                                                                                    }}
                                                                                                />
                                                                                            </TableCell>
                                                                                        )}

                                                                                    {!outerItem?.parts?.length > 0 &&
                                                                                        (outerItem?.qty === null || outerItem?.qty === undefined) &&
                                                                                        (outerItem?.ratePerHour === null ||
                                                                                            outerItem?.ratePerHour === undefined) &&
                                                                                        outerItem?.pricingType === PRICING_TYPES.FXIED &&
                                                                                        isNewTaxVersionActive && (
                                                                                            <TableCell
                                                                                                align="left"
                                                                                                style={{
                                                                                                    padding: '6px 10px',
                                                                                                }}
                                                                                            >
                                                                                                <LineTaxCell
                                                                                                    taxesBreakdown={outerItem?.taxesBreakdown}
                                                                                                    lineAmount={outerItem?.fixedPrice}
                                                                                                    documentType={DOCUMENT_TAX_TYPE.WORK_ORDER}
                                                                                                    shopTaxesData={shopTaxesData}
                                                                                                    globalTaxesBreakdown={taxesBreakdown}
                                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                                    kind={LINE_TAX_KIND.PACKAGE}
                                                                                                    editable={isNewTaxVersionActive}
                                                                                                    onChange={(next) => {
                                                                                                        const clone = JSON.parse(
                                                                                                            JSON.stringify(serviceListPayload)
                                                                                                        );
                                                                                                        clone[outerIndex].taxesBreakdown = next;
                                                                                                        setServiceListPayload(clone);
                                                                                                    }}
                                                                                                    discount={paymentDetails?.discount}
                                                                                                    subTotal={paymentDetails?.subTotal}
                                                                                                />
                                                                                            </TableCell>
                                                                                        )}

                                                                                    <TableCell style={{ padding: '0' }}>
                                                                                        <Stack
                                                                                            direction="row"
                                                                                            gap={1.5}
                                                                                            justifyContent={'flex-start'}
                                                                                            sx={{ height: '100%', alignItems: 'center' }}
                                                                                        >
                                                                                            <IconButton
                                                                                                color="error"
                                                                                                style={{ padding: '0' }}
                                                                                                onClick={() => {
                                                                                                    let cloneService = [...serviceListPayload];
                                                                                                    cloneService[outerIndex].showDesc = false;
                                                                                                    cloneService[outerIndex].optionalDescription = '';
                                                                                                    if (!isDirty) {
                                                                                                        markSaved();
                                                                                                    }
                                                                                                    setServiceListPayload(cloneService);
                                                                                                }}
                                                                                            >
                                                                                                <Delete />
                                                                                            </IconButton>
                                                                                        </Stack>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )}

                                                                            {!(outerItem?.qty === undefined || outerItem?.qty === null) &&
                                                                                !(outerItem?.ratePerHour === undefined || outerItem?.ratePerHour === null) && (
                                                                                    <TableRow>
                                                                                        <TableCell
                                                                                            key={0}
                                                                                            component="th"
                                                                                            align="left"
                                                                                            scope="row"
                                                                                            style={{
                                                                                                fontSize: '16px',
                                                                                                paddingLeft: '16px',
                                                                                                paddingRight: '0',
                                                                                            }}
                                                                                        >
                                                                                            {1}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            align="left"
                                                                                            style={{ padding: '16px 12px 16px 0', fontSize: '16px' }}
                                                                                        >
                                                                                            {outerItem.pricingType === PRICING_TYPES.FXIED
                                                                                                ? 'Fixed Price'
                                                                                                : outerItem.pricingType !== PRICING_TYPES.LABOUR
                                                                                                  ? outerItem?.service?.name
                                                                                                  : 'Labour'}
                                                                                        </TableCell>
                                                                                        <TableCell align="left" style={{ padding: '6px 12px' }}>
                                                                                            {outerItem.pricingType === PRICING_TYPES.LABOUR ? (
                                                                                                <InputWithIcon
                                                                                                    inputRef={labourTextRef}
                                                                                                    outerIndex={outerIndex}
                                                                                                    fontSize="16px"
                                                                                                    value={outerItem?.qty}
                                                                                                    skipOnChange
                                                                                                    onChange={(numericValue) => {
                                                                                                        if (
                                                                                                            numericValue === '' ||
                                                                                                            /^\d*(\.\d{0,2})?$/.test(numericValue)
                                                                                                        ) {
                                                                                                            const qty = Number(numericValue) || 0; // "1." → 1
                                                                                                            const rate =
                                                                                                                Number(
                                                                                                                    serviceListPayload[outerIndex]?.ratePerHour
                                                                                                                ) || 0;
                                                                                                            const amount =
                                                                                                                qty && rate
                                                                                                                    ? NumericEngine.multiply(qty, rate)
                                                                                                                    : '0';

                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            cloneService[outerIndex].qty = numericValue; // Keep "1." for display
                                                                                                            cloneService[outerIndex].amount = Number(amount); // Store as number
                                                                                                            setServiceListPayload(cloneService);
                                                                                                            if (!isDirty) {
                                                                                                                markSaved();
                                                                                                            }
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                outerItem?.qty
                                                                                            )}
                                                                                        </TableCell>

                                                                                        <TableCell align="left" style={{ padding: '6px 12px' }}>
                                                                                            {outerItem?.pricingType === PRICING_TYPES.FXIED ? (
                                                                                                <></>
                                                                                            ) : outerItem?.pricingType === PRICING_TYPES.LABOUR ? (
                                                                                                <TextField
                                                                                                    fullWidth
                                                                                                    variant="outlined"
                                                                                                    onKeyDown={handlePreventKeyDownDecimal}
                                                                                                    InputProps={{
                                                                                                        startAdornment: (
                                                                                                            <p
                                                                                                                style={{
                                                                                                                    paddingLeft: '8px',
                                                                                                                    fontSize: '16px',
                                                                                                                }}
                                                                                                            >
                                                                                                                $
                                                                                                            </p>
                                                                                                        ),
                                                                                                    }}
                                                                                                    value={outerItem?.ratePerHour}
                                                                                                    onFocus={(event) => {
                                                                                                        const input = event.target;
                                                                                                        setTimeout(() => {
                                                                                                            input.setSelectionRange(
                                                                                                                input.value.length,
                                                                                                                input.value.length
                                                                                                            );
                                                                                                        }, 0);
                                                                                                    }}
                                                                                                    onChange={(event) => {
                                                                                                        let inputValue = event.target.value;

                                                                                                        if (
                                                                                                            inputValue.length > 1 &&
                                                                                                            inputValue.startsWith('0') &&
                                                                                                            /[1-9a-zA-Z]/.test(inputValue[1])
                                                                                                        ) {
                                                                                                            inputValue = inputValue.slice(1);
                                                                                                        }

                                                                                                        if (/^\d*\.?\d*$/.test(inputValue)) {
                                                                                                            if (Number(inputValue) > 1000) {
                                                                                                                toast.error('Labour cost cannot exceed 1000.');
                                                                                                                return;
                                                                                                            }

                                                                                                            const ratePerHour = Number(inputValue) || 0; // "1." → 1
                                                                                                            const qty =
                                                                                                                Number(serviceListPayload[outerIndex]?.qty) ||
                                                                                                                0;
                                                                                                            const amount =
                                                                                                                qty && ratePerHour
                                                                                                                    ? NumericEngine.multiply(qty, ratePerHour)
                                                                                                                    : '0';

                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            cloneService[outerIndex].ratePerHour = inputValue; // Keep "1." for display
                                                                                                            cloneService[outerIndex].amount = Number(amount);
                                                                                                            if (!isDirty) {
                                                                                                                markSaved();
                                                                                                            }
                                                                                                            setServiceListPayload(cloneService);
                                                                                                        }
                                                                                                    }}
                                                                                                    sx={{
                                                                                                        height: '40px',
                                                                                                        boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                                                        borderRadius: '8px',
                                                                                                        '& .MuiInputBase-root': {
                                                                                                            border: 'none',
                                                                                                            padding: '12px 0 12px 0',
                                                                                                            height: '40px',
                                                                                                            fontSize: '16px',
                                                                                                            letterSpacing: '0.17px',
                                                                                                            lineHeight: '143%',
                                                                                                        },
                                                                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
                                                                                                            {
                                                                                                                borderRadius: '8px',
                                                                                                            },
                                                                                                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                                                                                            {
                                                                                                                WebkitAppearance: 'none',
                                                                                                                margin: 0,
                                                                                                            },
                                                                                                        '& input[type=number]': {
                                                                                                            MozAppearance: 'textfield',
                                                                                                        },
                                                                                                    }}
                                                                                                />
                                                                                            ) : (
                                                                                                <>
                                                                                                    {outerItem.pricingType !== PRICING_TYPES.NOPRICE
                                                                                                        ? '$' + outerItem?.ratePerHour
                                                                                                        : outerItem?.ratePerHour}
                                                                                                </>
                                                                                            )}
                                                                                        </TableCell>

                                                                                        <TableCell align="left" style={{ padding: '6px 12px' }}>
                                                                                            <Typography>
                                                                                                {outerItem.pricingType === PRICING_TYPES.FXIED ? (
                                                                                                    <TextField
                                                                                                        fullWidth
                                                                                                        variant="outlined"
                                                                                                        onKeyDown={handlePreventKeyDownDecimal}
                                                                                                        InputProps={{
                                                                                                            startAdornment: (
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        paddingLeft: '8px',
                                                                                                                        fontSize: '16px!important',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    $
                                                                                                                </p>
                                                                                                            ),
                                                                                                        }}
                                                                                                        value={outerItem?.fixedPrice}
                                                                                                        onChange={(event) => {
                                                                                                            let inputValue = event.target.value;
                                                                                                            if (/^\d*\.?\d*$/.test(inputValue)) {
                                                                                                                let fixedPrice = inputValue;

                                                                                                                let cloneService = JSON.parse(
                                                                                                                    JSON.stringify(serviceListPayload)
                                                                                                                );
                                                                                                                cloneService[outerIndex].fixedPrice =
                                                                                                                    fixedPrice;
                                                                                                                if (!isDirty) {
                                                                                                                    markSaved();
                                                                                                                }
                                                                                                                setServiceListPayload(cloneService);
                                                                                                            }
                                                                                                        }}
                                                                                                        sx={{
                                                                                                            height: '40px',
                                                                                                            boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',
                                                                                                            borderRadius: '8px',
                                                                                                            '& .MuiInputBase-root': {
                                                                                                                border: 'none',
                                                                                                                padding: '12px 0 12px 0',
                                                                                                                height: '40px',
                                                                                                                fontSize: '16px!important',
                                                                                                                letterSpacing: '0.17px',
                                                                                                                lineHeight: '143%',
                                                                                                            },
                                                                                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
                                                                                                                {
                                                                                                                    borderRadius: '8px',
                                                                                                                },
                                                                                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                                                                                                {
                                                                                                                    WebkitAppearance: 'none',
                                                                                                                    margin: 0,
                                                                                                                },
                                                                                                            '& input[type=number]': {
                                                                                                                MozAppearance: 'textfield',
                                                                                                            },
                                                                                                        }}
                                                                                                    />
                                                                                                ) : outerItem.pricingType !== PRICING_TYPES.NOPRICE ? (
                                                                                                    <Typography fontWeight={600} fontSize={16}>
                                                                                                        {NumericEngine.format(outerItem?.amount || 0, {
                                                                                                            formatCurrency: true,
                                                                                                            trailingZeros: true,
                                                                                                        })}
                                                                                                    </Typography>
                                                                                                ) : (
                                                                                                    ''
                                                                                                )}
                                                                                            </Typography>
                                                                                        </TableCell>
                                                                                        {isNewTaxVersionActive && (
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    padding: '0 8px',
                                                                                                }}
                                                                                            >
                                                                                                <LineTaxCell
                                                                                                    taxesBreakdown={outerItem?.taxesBreakdown}
                                                                                                    lineAmount={
                                                                                                        outerItem?.pricingType === PRICING_TYPES.FXIED
                                                                                                            ? outerItem?.fixedPrice
                                                                                                            : outerItem?.amount
                                                                                                    }
                                                                                                    documentType={DOCUMENT_TAX_TYPE.WORK_ORDER}
                                                                                                    shopTaxesData={shopTaxesData}
                                                                                                    globalTaxesBreakdown={taxesBreakdown}
                                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                                    kind={
                                                                                                        outerItem?.pricingType === PRICING_TYPES.FXIED
                                                                                                            ? LINE_TAX_KIND.PACKAGE
                                                                                                            : LINE_TAX_KIND.LABOUR
                                                                                                    }
                                                                                                    editable={isNewTaxVersionActive}
                                                                                                    onChange={(next) => {
                                                                                                        const clone = JSON.parse(
                                                                                                            JSON.stringify(serviceListPayload)
                                                                                                        );
                                                                                                        clone[outerIndex].taxesBreakdown = next;
                                                                                                        setServiceListPayload(clone);
                                                                                                    }}
                                                                                                    discount={paymentDetails?.discount}
                                                                                                    subTotal={paymentDetails?.subTotal}
                                                                                                />
                                                                                            </TableCell>
                                                                                        )}
                                                                                        <TableCell
                                                                                            style={{
                                                                                                padding: '0',
                                                                                            }}
                                                                                        >
                                                                                            {outerItem.pricingType === PRICING_TYPES.LABOUR && (
                                                                                                <Stack direction="row" gap={1.5} justifyContent={'flex-start'}>
                                                                                                    <IconButton
                                                                                                        color="error"
                                                                                                        style={{ padding: '0' }}
                                                                                                        onClick={() => {
                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            delete cloneService[outerIndex].ratePerHour;
                                                                                                            delete cloneService[outerIndex].qty;
                                                                                                            delete cloneService[outerIndex].amount;

                                                                                                            if (
                                                                                                                !cloneService[outerIndex]?.parts?.length > 0 &&
                                                                                                                (cloneService[outerIndex]?.qty === null ||
                                                                                                                    cloneService[outerIndex]?.qty ===
                                                                                                                        undefined) &&
                                                                                                                (cloneService[outerIndex]?.ratePerHour ===
                                                                                                                    null ||
                                                                                                                    cloneService[outerIndex]?.ratePerHour ===
                                                                                                                        undefined)
                                                                                                            ) {
                                                                                                                cloneService[outerIndex].pricingType =
                                                                                                                    PRICING_TYPES.FXIED;
                                                                                                            }
                                                                                                            if (!isDirty) {
                                                                                                                markSaved();
                                                                                                            }
                                                                                                            setServiceListPayload(cloneService);
                                                                                                        }}
                                                                                                    >
                                                                                                        <Delete />
                                                                                                    </IconButton>
                                                                                                </Stack>
                                                                                            )}
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                )}

                                                                            {Array.isArray(outerItem?.parts) &&
                                                                                outerItem.parts.map((part, innerIndex) => {
                                                                                    const hasDescription = Boolean(part?.description);
                                                                                    const hasFee = Boolean(part?.feeAmount > 0 && part?.fee?.name);

                                                                                    const isLastRowMain = !hasDescription && !hasFee;
                                                                                    const isLastRowDescription = hasDescription && !hasFee;
                                                                                    const isLastRowFee = hasFee;

                                                                                    return (
                                                                                        <React.Fragment key={part.partRowId ?? part._id}>
                                                                                            <TableRow>
                                                                                                <TableCell
                                                                                                    style={{
                                                                                                        fontSize: '16px',
                                                                                                        padding: '16px  0 16px 16px',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                >
                                                                                                    {outerItem.qty &&
                                                                                                    (outerItem?.ratePerHour !== null ||
                                                                                                        outerItem?.ratePerHour !== undefined)
                                                                                                        ? innerIndex + 2
                                                                                                        : innerIndex + 1}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    align="left"
                                                                                                    style={{
                                                                                                        padding: '16px 12px 16px 0',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                >
                                                                                                    {part?.type === 'search' ||
                                                                                                    (part?.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED &&
                                                                                                        !part?._id) ? (
                                                                                                        <GenralInventoryAutocomplete
                                                                                                            // Unmanaged parts only — no inventory list or batches here (spec §9, client 2026-09-24).
                                                                                                            // It renders a plain text field with browser autofill on, so Chrome suggests part names typed before.
                                                                                                            unmanagedOnly
                                                                                                            loader={inventoryLoader}
                                                                                                            setIsUsedInvoiceQty={setIsUsedInvoiceQty}
                                                                                                            setOpenTrackedIncreaseModal={
                                                                                                                setOpenTrackedIncreaseModal
                                                                                                            }
                                                                                                            setDisabledFields={setDisabledFields}
                                                                                                            setOutOfStockStatus={setOutOfStockStatus}
                                                                                                            usedQuantityOfInventory={usedQuantityOfInventory}
                                                                                                            finalizedInventoryCount={finalizedInventoryCount}
                                                                                                            usedBatchQty={usedBatchQty}
                                                                                                            inventoryPageData={inventoryPageData}
                                                                                                            inventoryList={inventoryList}
                                                                                                            handleOpenPartModal={() => setOpenpartModel(true)}
                                                                                                            serviceList={serviceListPayload}
                                                                                                            outerIndex={outerIndex}
                                                                                                            innerIndex={innerIndex}
                                                                                                            setServiceList={setServiceListPayload}
                                                                                                            setSaveIndexes={setSaveIndexes}
                                                                                                            setSelectedInventory={setSelectedInventory}
                                                                                                            setShowAllInventoryTabs={setShowAllInventoryTabs}
                                                                                                            setInventoryTabIndex={setInventoryTabIndex}
                                                                                                            setInventoryModalType={setInventoryModalType}
                                                                                                            setSelectedInventoryId={setSelectedInventoryId}
                                                                                                            searchInventory={searchInventory}
                                                                                                            setSearchInventory={setSearchInventory}
                                                                                                            setBatchNumber={setBatchNumber}
                                                                                                            setAddQty={setAddQty}
                                                                                                            setOpenpartModel={setOpenpartModel}
                                                                                                            partQtyRef={partQtyRef}
                                                                                                            onTabNavigation={() => {
                                                                                                                const qtyRef =
                                                                                                                    partQtyRef.current[
                                                                                                                        `${outerIndex}-${innerIndex}`
                                                                                                                    ];
                                                                                                                if (qtyRef) {
                                                                                                                    setTimeout(() => {
                                                                                                                        qtyRef.focus();
                                                                                                                    }, 0);
                                                                                                                }
                                                                                                            }}
                                                                                                            // TanStack Query infinite scroll props
                                                                                                            fetchNextPage={fetchNextPage}
                                                                                                            hasNextPage={hasNextPage}
                                                                                                            isFetchingNextPage={isFetchingNextPage}
                                                                                                        />
                                                                                                    ) : part?.inventoryType ===
                                                                                                      INVENTORY_MANAGE_TYPE.UNMANAGED ? (
                                                                                                        <TextField
                                                                                                            inputRef={(el) =>
                                                                                                                (partNameFieldRef.current[outerIndex] = el)
                                                                                                            }
                                                                                                            multiline
                                                                                                            maxRows={5}
                                                                                                            variant="standard"
                                                                                                            value={outerItem?.parts[innerIndex]?.partName || ''}
                                                                                                            onChange={(event) => {
                                                                                                                setServiceListPayload((prevList) =>
                                                                                                                    prevList.map((service, i) =>
                                                                                                                        i === outerIndex
                                                                                                                            ? {
                                                                                                                                  ...service,
                                                                                                                                  parts: service.parts.map(
                                                                                                                                      (part, partIndex) =>
                                                                                                                                          partIndex ===
                                                                                                                                          innerIndex
                                                                                                                                              ? {
                                                                                                                                                    ...part,
                                                                                                                                                    partName:
                                                                                                                                                        event
                                                                                                                                                            .target
                                                                                                                                                            .value,
                                                                                                                                                }
                                                                                                                                              : part
                                                                                                                                  ),
                                                                                                                              }
                                                                                                                            : service
                                                                                                                    )
                                                                                                                );
                                                                                                                if (!isDirty) {
                                                                                                                    markSaved();
                                                                                                                }
                                                                                                            }}
                                                                                                            fullWidth
                                                                                                            InputProps={{
                                                                                                                style: {
                                                                                                                    fontSize: '16px',
                                                                                                                    color: 'rgba(0,0,0,0.87)',
                                                                                                                    cursor: 'text',
                                                                                                                    lineHeight: '143%',
                                                                                                                    letterSpacing: ' 0.17px,',
                                                                                                                },
                                                                                                            }}
                                                                                                            sx={{
                                                                                                                padding: 0,
                                                                                                                border: 'none',
                                                                                                                fontSize: '16px',
                                                                                                                '& .MuiInputBase-input': {
                                                                                                                    padding: 0,
                                                                                                                    fontSize: 16,
                                                                                                                    fontWeight: 400,
                                                                                                                    lineHeight: '143%',
                                                                                                                    color: '#212121',
                                                                                                                },
                                                                                                                '& .MuiInput-underline:before': {
                                                                                                                    borderBottomColor: 'rgba(0, 0, 0, 0.42)',
                                                                                                                },
                                                                                                                '& .MuiInput-underline:hover:not(.Mui-disabled):before':
                                                                                                                    {
                                                                                                                        borderBottomColor:
                                                                                                                            'rgba(0, 0, 0, 0.42)',
                                                                                                                    },
                                                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                                                    border: 'none',
                                                                                                                },
                                                                                                            }}
                                                                                                        />
                                                                                                    ) : (
                                                                                                        <div>
                                                                                                            <Typography
                                                                                                                sx={{
                                                                                                                    fontSize: '16px',
                                                                                                                    fontWeight: 400,
                                                                                                                    letterSpacing: '0.17px',
                                                                                                                    lineHeight: '23px',
                                                                                                                    textDecoration: 'underline',
                                                                                                                    cursor: 'pointer',
                                                                                                                    marginBottom: '4px',
                                                                                                                }}
                                                                                                                onClick={() => {
                                                                                                                    setShowAllInventoryTabs(false);
                                                                                                                    setInventoryTabIndex(0);
                                                                                                                    setInventoryModalType('edit');
                                                                                                                    setSelectedInventoryId(part?._id);
                                                                                                                    setDisabledFields([
                                                                                                                        'partName',
                                                                                                                        'partNumber',
                                                                                                                        'supplierId',
                                                                                                                        'supplierInvoiceNumber',
                                                                                                                    ]);
                                                                                                                    setSaveIndexes({
                                                                                                                        outerIndex: outerIndex,
                                                                                                                        innerIndex: innerIndex,
                                                                                                                    });
                                                                                                                    if (part?.batchNumber?.length > 1) {
                                                                                                                        setOpenPartDetailModal(true);
                                                                                                                    } else {
                                                                                                                        setBatchNumber(
                                                                                                                            part?.batchNumber?.length > 0
                                                                                                                                ? part?.batchNumber[0]
                                                                                                                                : part?._id
                                                                                                                        );
                                                                                                                        setIsUsedInvoiceQty(part?.partQty);
                                                                                                                        setOpenpartModel(true);
                                                                                                                    }
                                                                                                                }}
                                                                                                            >
                                                                                                                {part?.part?.partName}
                                                                                                            </Typography>

                                                                                                            <Stack
                                                                                                                direction="row"
                                                                                                                alignItems="center"
                                                                                                                spacing={1.25}
                                                                                                                sx={{ py: '2px' }}
                                                                                                                divider={
                                                                                                                    <Box
                                                                                                                        sx={{
                                                                                                                            mx: '14px',
                                                                                                                            width: '1px',
                                                                                                                            height: '16px',
                                                                                                                            bgcolor: 'rgba(0, 0, 0, 0.12)',
                                                                                                                        }}
                                                                                                                    />
                                                                                                                }
                                                                                                            >
                                                                                                                <Stack
                                                                                                                    direction="row"
                                                                                                                    alignItems="center"
                                                                                                                    sx={{
                                                                                                                        alignSelf: 'stretch',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {(part?.partNumber ||
                                                                                                                        part?.tyreDimension) && (
                                                                                                                        <>
                                                                                                                            <Stack
                                                                                                                                direction="row"
                                                                                                                                alignItems="center"
                                                                                                                                spacing={0.5}
                                                                                                                            >
                                                                                                                                <Typography
                                                                                                                                    component="span"
                                                                                                                                    sx={{
                                                                                                                                        fontSize: '16px',
                                                                                                                                        fontWeight: 400,
                                                                                                                                        letterSpacing: '0.17px',
                                                                                                                                        color: '#006CDD',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    #
                                                                                                                                </Typography>

                                                                                                                                <Typography
                                                                                                                                    component="span"
                                                                                                                                    sx={{
                                                                                                                                        fontSize: '16px',
                                                                                                                                        fontWeight: 400,
                                                                                                                                        letterSpacing: '0.17px',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {(part?.partsType ??
                                                                                                                                        part?.part
                                                                                                                                            ?.partsType) ===
                                                                                                                                    PART_TYPES.TYRE
                                                                                                                                        ? part?.tyreDimension ||
                                                                                                                                          part?.partNumber
                                                                                                                                        : part?.partNumber ||
                                                                                                                                          part?.tyreDimension}
                                                                                                                                </Typography>
                                                                                                                            </Stack>
                                                                                                                        </>
                                                                                                                    )}

                                                                                                                    {part?.supplier?.name && (
                                                                                                                        <>
                                                                                                                            <Box
                                                                                                                                sx={{
                                                                                                                                    mx: '14px',
                                                                                                                                    width: '1px',
                                                                                                                                    height: '16px',
                                                                                                                                    bgcolor: 'rgba(0,0,0,0.12)',
                                                                                                                                    flexShrink: 0,
                                                                                                                                }}
                                                                                                                            />

                                                                                                                            <Stack
                                                                                                                                direction="row"
                                                                                                                                alignItems="center"
                                                                                                                                spacing={0.75}
                                                                                                                            >
                                                                                                                                <PartBrandSvg />

                                                                                                                                <Typography
                                                                                                                                    sx={{
                                                                                                                                        fontSize: '16px',
                                                                                                                                        fontWeight: 400,
                                                                                                                                        letterSpacing: '0.17px',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {part.supplier.name}
                                                                                                                                </Typography>
                                                                                                                            </Stack>
                                                                                                                        </>
                                                                                                                    )}

                                                                                                                    {part?.partsBrand?.name && (
                                                                                                                        <>
                                                                                                                            <Box
                                                                                                                                sx={{
                                                                                                                                    mx: '14px',
                                                                                                                                    width: '1px',
                                                                                                                                    height: '16px',
                                                                                                                                    bgcolor: 'rgba(0,0,0,0.12)',
                                                                                                                                    flexShrink: 0,
                                                                                                                                }}
                                                                                                                            />

                                                                                                                            <Stack
                                                                                                                                direction="row"
                                                                                                                                alignItems="center"
                                                                                                                                spacing={0.75}
                                                                                                                            >
                                                                                                                                <PartCategorySvg />

                                                                                                                                <Typography
                                                                                                                                    sx={{
                                                                                                                                        fontSize: '16px',
                                                                                                                                        fontWeight: 400,
                                                                                                                                        letterSpacing: '0.17px',
                                                                                                                                    }}
                                                                                                                                >
                                                                                                                                    {part.partsBrand.name}
                                                                                                                                </Typography>
                                                                                                                            </Stack>
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </Stack>
                                                                                                            </Stack>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    align="left"
                                                                                                    style={{
                                                                                                        padding: '6px 12px',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                >
                                                                                                    <InputWithIcon
                                                                                                        fontSize={'16px'}
                                                                                                        disabled={issBatchNumberLoading}
                                                                                                        inputRef={partQtyRef}
                                                                                                        outerIndex={outerIndex}
                                                                                                        innerIndex={innerIndex}
                                                                                                        value={part?.partQty}
                                                                                                        skipOnChange={true}
                                                                                                        onChange={async (newValue) => {
                                                                                                            if (
                                                                                                                newValue === '' ||
                                                                                                                (part?.inventoryType ===
                                                                                                                INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                                    ? /^\d*(\.\d{0,2})?$/.test(newValue)
                                                                                                                    : /^\d*(\.\d{0,1})?$/.test(newValue))
                                                                                                            ) {
                                                                                                                let cloneService = JSON.parse(
                                                                                                                    JSON.stringify(serviceListPayload)
                                                                                                                );
                                                                                                                const currentPart =
                                                                                                                    cloneService[outerIndex]?.parts?.[
                                                                                                                        innerIndex
                                                                                                                    ];
                                                                                                                const inventoryId = currentPart?._id;

                                                                                                                let inventoryQty = currentPart?.inStock;
                                                                                                                if (
                                                                                                                    isSaveDraftRef.current &&
                                                                                                                    (inventoryQty === null ||
                                                                                                                        inventoryQty === undefined ||
                                                                                                                        inventoryQty === '')
                                                                                                                ) {
                                                                                                                    const matchedInventory = inventoryList.find(
                                                                                                                        (item) => item._id === inventoryId
                                                                                                                    );

                                                                                                                    if (
                                                                                                                        matchedInventory &&
                                                                                                                        typeof matchedInventory.inStock ===
                                                                                                                            'number'
                                                                                                                    ) {
                                                                                                                        inventoryQty = matchedInventory.inStock;
                                                                                                                        cloneService[outerIndex].parts[
                                                                                                                            innerIndex
                                                                                                                        ].inStock = inventoryQty;
                                                                                                                    }
                                                                                                                }
                                                                                                                const partQty = newValue;

                                                                                                                const currentQty = currentPart?.partQty || 0;

                                                                                                                // 🔹 If multiple batches, open selection modal
                                                                                                                if (currentPart?.batchNumber?.length > 1) {
                                                                                                                    setInventoryOption(currentPart);
                                                                                                                    setSaveIndexes({
                                                                                                                        innerIndex,
                                                                                                                        outerIndex,
                                                                                                                    });
                                                                                                                    setBatchSelectionModal(true);
                                                                                                                    return;
                                                                                                                }

                                                                                                                // 🔹 Calculate total used quantity excluding the current index
                                                                                                                const totalUsedQtyExcludingCurrent =
                                                                                                                    cloneService.reduce(
                                                                                                                        (total, service, serviceIndex) => {
                                                                                                                            const parts = service?.parts || [];
                                                                                                                            return (
                                                                                                                                total +
                                                                                                                                parts.reduce(
                                                                                                                                    (sum, part, partIndex) => {
                                                                                                                                        if (
                                                                                                                                            part?._id ===
                                                                                                                                                inventoryId &&
                                                                                                                                            !(
                                                                                                                                                serviceIndex ===
                                                                                                                                                    outerIndex &&
                                                                                                                                                partIndex ===
                                                                                                                                                    innerIndex
                                                                                                                                            )
                                                                                                                                        ) {
                                                                                                                                            return (
                                                                                                                                                sum +
                                                                                                                                                (part
                                                                                                                                                    ?.batchArray?.[0]
                                                                                                                                                    ?.batchQty ||
                                                                                                                                                    0)
                                                                                                                                            );
                                                                                                                                        }
                                                                                                                                        return sum;
                                                                                                                                    },
                                                                                                                                    0
                                                                                                                                )
                                                                                                                            );
                                                                                                                        },
                                                                                                                        0
                                                                                                                    );

                                                                                                                const proposedTotalQty =
                                                                                                                    totalUsedQtyExcludingCurrent +
                                                                                                                    Number(partQty || 0);
                                                                                                                // 🔹Inventory exceeded (non-finalized) or finalized but new part adding.
                                                                                                                if (
                                                                                                                    (!isFinalizedEmail ||
                                                                                                                        !usedBatchQty[
                                                                                                                            currentPart.batchArray?.length >
                                                                                                                                0 &&
                                                                                                                                currentPart.batchArray[0]
                                                                                                                                    .batchNumber
                                                                                                                        ]) &&
                                                                                                                    proposedTotalQty > inventoryQty
                                                                                                                ) {
                                                                                                                    //### Case 4 - Untracked Inventory - 0 in stock or multiple in stock but user trying to add more
                                                                                                                    if (!currentPart?.isTracked) {
                                                                                                                        setBatchNumber(
                                                                                                                            currentPart?.batchArray?.[0]
                                                                                                                                ?.batchNumber
                                                                                                                        );

                                                                                                                        setSaveIndexes({
                                                                                                                            outerIndex,
                                                                                                                            innerIndex,
                                                                                                                        });
                                                                                                                        setSelectedInventoryId(inventoryId);
                                                                                                                        setAddQty(true);
                                                                                                                        setIsUsedInvoiceQty(
                                                                                                                            currentPart?.qty || 0
                                                                                                                        );
                                                                                                                        setOpenpartModel(true);
                                                                                                                        toast.error(
                                                                                                                            'You do not have sufficient quantity in your inventory. Please add additional quantity to continue',
                                                                                                                            {
                                                                                                                                icon: (
                                                                                                                                    <InfoOutlined
                                                                                                                                        sx={{
                                                                                                                                            fontSize: '22px',
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                ),
                                                                                                                            }
                                                                                                                        );
                                                                                                                        return;
                                                                                                                    }
                                                                                                                    //###  Case 1 - >0 inventory from one supplier (tracked)
                                                                                                                    if (currentPart?.isTracked) {
                                                                                                                        setSaveIndexes({
                                                                                                                            outerIndex,
                                                                                                                            innerIndex,
                                                                                                                        });
                                                                                                                        setOpenTrackedIncreaseModal(true);
                                                                                                                        return;
                                                                                                                    }
                                                                                                                }

                                                                                                                // 🔹 Finalized condition - only make API call if increasing
                                                                                                                if (
                                                                                                                    isFinalizedEmail &&
                                                                                                                    currentPart?.batchArray?.length > 0 &&
                                                                                                                    currentPart?.batchArray?.[0]?.batchNumber &&
                                                                                                                    proposedTotalQty > currentQty
                                                                                                                ) {
                                                                                                                    const batchNumber =
                                                                                                                        currentPart.batchArray[0].batchNumber;
                                                                                                                    const usedQtyForBatch =
                                                                                                                        usedBatchQty[batchNumber];

                                                                                                                    // 🔸 Skip API if proposed total is less than used (already validated)
                                                                                                                    if (proposedTotalQty >= usedQtyForBatch) {
                                                                                                                        setIsBatchNumberLoading(true);
                                                                                                                        const resp =
                                                                                                                            await getInventoryBatchDetailApi(
                                                                                                                                batchNumber
                                                                                                                            );
                                                                                                                        setIsBatchNumberLoading(false);

                                                                                                                        if (
                                                                                                                            proposedTotalQty >
                                                                                                                            resp.inStock + usedQtyForBatch
                                                                                                                        ) {
                                                                                                                            setBatchNumber(batchNumber);
                                                                                                                            setSaveIndexes({
                                                                                                                                outerIndex,
                                                                                                                                innerIndex,
                                                                                                                            });
                                                                                                                            setSelectedInventoryId(inventoryId);
                                                                                                                            setAddQty(true);
                                                                                                                            setIsUsedInvoiceQty(
                                                                                                                                currentPart?.partQty || 0
                                                                                                                            );
                                                                                                                            setOpenpartModel(true);
                                                                                                                            toast.error(
                                                                                                                                'You do not have sufficient quantity in your inventory. Please add additional quantity to continue',
                                                                                                                                {
                                                                                                                                    icon: (
                                                                                                                                        <InfoOutlined
                                                                                                                                            sx={{
                                                                                                                                                fontSize:
                                                                                                                                                    '22px',
                                                                                                                                            }}
                                                                                                                                        />
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                            );
                                                                                                                            return;
                                                                                                                        }
                                                                                                                    }
                                                                                                                }

                                                                                                                // 🔹 Final update of state
                                                                                                                const partCost = part?.partCost || 0;
                                                                                                                const qty = Number(partQty || 0) || 0;
                                                                                                                const cost = Number(partCost) || 0;
                                                                                                                const totalAmount =
                                                                                                                    qty && cost
                                                                                                                        ? Number(
                                                                                                                              NumericEngine.multiply(qty, cost)
                                                                                                                          )
                                                                                                                        : 0;

                                                                                                                cloneService[outerIndex].parts[
                                                                                                                    innerIndex
                                                                                                                ].partQty = partQty;
                                                                                                                cloneService[outerIndex].parts[
                                                                                                                    innerIndex
                                                                                                                ].totalAmount = totalAmount;

                                                                                                                if (
                                                                                                                    cloneService[outerIndex].parts?.[innerIndex]
                                                                                                                        ?.batchArray?.[0]
                                                                                                                ) {
                                                                                                                    cloneService[outerIndex].parts[
                                                                                                                        innerIndex
                                                                                                                    ].batchArray[0].batchQty = partQty;
                                                                                                                }
                                                                                                                if (!isDirty) {
                                                                                                                    markSaved();
                                                                                                                }
                                                                                                                setServiceListPayload(cloneService);
                                                                                                            }
                                                                                                        }}
                                                                                                    />

                                                                                                    <CommonDialog
                                                                                                        dialogClaassName="commonDialog commonDialog__560"
                                                                                                        open={openTrackedIncreaseModal}
                                                                                                        onClose={() => {
                                                                                                            //cancl button fuyncituon
                                                                                                            setOutOfStockStatus(null);
                                                                                                            setDisabledFields([]);
                                                                                                            setShowAllInventoryTabs(false);
                                                                                                            setOpenTrackedIncreaseModal(false);
                                                                                                        }}
                                                                                                        onSave={() => {
                                                                                                            //update button funtion
                                                                                                            setOutOfStockStatus('update');
                                                                                                            setShowAllInventoryTabs(false);
                                                                                                            setDisabledFields([
                                                                                                                'partName',
                                                                                                                'partNumber',
                                                                                                                'supplierId',
                                                                                                                'supplierInvoiceNumber',
                                                                                                            ]);
                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            const currentPart =
                                                                                                                cloneService[saveIndexes.outerIndex]?.parts?.[
                                                                                                                    saveIndexes.innerIndex
                                                                                                                ];

                                                                                                            if (!batchNumber) {
                                                                                                                setBatchNumber(
                                                                                                                    currentPart?.batchArray?.[0]?.batchNumber
                                                                                                                );
                                                                                                                setSelectedInventoryId(currentPart?._id);
                                                                                                            }

                                                                                                            setShowAllInventoryTabs(false);

                                                                                                            setSaveIndexes({
                                                                                                                outerIndex: saveIndexes.outerIndex,
                                                                                                                innerIndex: saveIndexes.innerIndex,
                                                                                                            });
                                                                                                            setAddQty(true);
                                                                                                            setIsUsedInvoiceQty(currentPart?.partQty || 0);
                                                                                                            setOpenpartModel(true);
                                                                                                            // setOpenTrackedIncreaseModal(false);
                                                                                                        }}
                                                                                                        onConfirm={() => {
                                                                                                            // Create new variant: In Stock and Added to Invoice should default to 1
                                                                                                            setOutOfStockStatus('create');
                                                                                                            setDisabledFields([
                                                                                                                'partName',
                                                                                                                'partNumber',
                                                                                                                'supplierId',
                                                                                                            ]);
                                                                                                            let cloneService = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            const currentPart =
                                                                                                                cloneService[saveIndexes.outerIndex]?.parts?.[
                                                                                                                    saveIndexes.innerIndex
                                                                                                                ];

                                                                                                            if (!batchNumber) {
                                                                                                                setBatchNumber(
                                                                                                                    currentPart?.batchArray?.[0]?.batchNumber
                                                                                                                );
                                                                                                            }

                                                                                                            setShowAllInventoryTabs(false);
                                                                                                            setSaveIndexes({
                                                                                                                outerIndex: saveIndexes.outerIndex,
                                                                                                                innerIndex: saveIndexes.innerIndex,
                                                                                                            });
                                                                                                            setIsUsedInvoiceQty(1);
                                                                                                            setOpenpartModel(true);
                                                                                                        }}
                                                                                                        dialogTitle={
                                                                                                            'Not Enough Inventory – Update or Add New?'
                                                                                                        }
                                                                                                        dialogSubtitle={
                                                                                                            'You’re trying to add additional quantity to this invoice, but there’s not enough inventory available.'
                                                                                                        }
                                                                                                        dialogSubtitle2={
                                                                                                            'Would you like to add more quantity to the existing inventory at the same cost, or create a new entry with a different cost from a new supplier invoice?'
                                                                                                        }
                                                                                                        saveButtonText="UPDATE Existing"
                                                                                                        saveButtonWidth="176px"
                                                                                                        saveButtonType="primary"
                                                                                                        confirmButtonText="Create New"
                                                                                                        confirmButtonWidth="140px"
                                                                                                    />
                                                                                                </TableCell>
                                                                                                <TableCell
                                                                                                    align="left"
                                                                                                    style={{
                                                                                                        padding: '6px 12px',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                >
                                                                                                    <TextField
                                                                                                        fullWidth
                                                                                                        variant="outlined"
                                                                                                        onFocus={(event) => {
                                                                                                            const input = event.target;
                                                                                                            setTimeout(() => {
                                                                                                                input.setSelectionRange(
                                                                                                                    input.value.length,
                                                                                                                    input.value.length
                                                                                                                );
                                                                                                            }, 0);
                                                                                                        }}
                                                                                                        onChange={(event) => {
                                                                                                            let inputValue = event.target.value;

                                                                                                            if (
                                                                                                                inputValue.length > 1 &&
                                                                                                                inputValue.startsWith('0') &&
                                                                                                                /[1-9a-zA-Z]/.test(inputValue[1])
                                                                                                            ) {
                                                                                                                inputValue = inputValue.slice(1);
                                                                                                            }

                                                                                                            if (/^\d*\.?\d*$/.test(inputValue)) {
                                                                                                                const cloneService = JSON.parse(
                                                                                                                    JSON.stringify(serviceListPayload)
                                                                                                                );
                                                                                                                const partCost = Number(inputValue) || 0; // "1." → 1
                                                                                                                const partQty = Number(part?.partQty) || 0;
                                                                                                                const totalAmount =
                                                                                                                    partQty && partCost
                                                                                                                        ? NumericEngine.multiply(
                                                                                                                              partQty,
                                                                                                                              partCost
                                                                                                                          )
                                                                                                                        : '0';

                                                                                                                cloneService[outerIndex].parts[
                                                                                                                    innerIndex
                                                                                                                ].partCost = inputValue; // Keep "1." for display
                                                                                                                cloneService[outerIndex].parts[
                                                                                                                    innerIndex
                                                                                                                ].totalAmount = Number(totalAmount);
                                                                                                                if (
                                                                                                                    cloneService[outerIndex].parts[innerIndex]
                                                                                                                        .batchArray?.length > 0
                                                                                                                ) {
                                                                                                                    cloneService[outerIndex].parts[
                                                                                                                        innerIndex
                                                                                                                    ].batchArray = cloneService[
                                                                                                                        outerIndex
                                                                                                                    ].parts[innerIndex].batchArray.map(
                                                                                                                        (batch) => ({
                                                                                                                            ...batch,
                                                                                                                            batchCost: partCost,
                                                                                                                        })
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    cloneService[outerIndex].parts[
                                                                                                                        innerIndex
                                                                                                                    ].batchArray = [{ batchCost: partCost }];
                                                                                                                }

                                                                                                                setServiceListPayload(cloneService);
                                                                                                                // Editing a part's price is an unsaved change, so leaving asks to discard.
                                                                                                                if (!isDirty) {
                                                                                                                    markSaved();
                                                                                                                }

                                                                                                                if (
                                                                                                                    part?.inventoryType ===
                                                                                                                    INVENTORY_MANAGE_TYPE.MANAGED
                                                                                                                    // && part?.isTracked
                                                                                                                ) {
                                                                                                                    // Clear previous timer
                                                                                                                    if (debouncePriceTimerRef.current)
                                                                                                                        clearTimeout(
                                                                                                                            debouncePriceTimerRef.current
                                                                                                                        );

                                                                                                                    // Save original price if first change
                                                                                                                    if (previousPriceRef.current === null) {
                                                                                                                        previousPriceRef.current =
                                                                                                                            part.partCost;
                                                                                                                    }

                                                                                                                    // Set debounce to open modal
                                                                                                                    debouncePriceTimerRef.current = setTimeout(
                                                                                                                        () => {
                                                                                                                            setOpenPriceChangeModal({
                                                                                                                                open: true,
                                                                                                                                outerIndex,
                                                                                                                                innerIndex,
                                                                                                                            });
                                                                                                                        },
                                                                                                                        2000
                                                                                                                    ); // 2 seconds
                                                                                                                }
                                                                                                            }
                                                                                                        }}
                                                                                                        value={part?.partCost}
                                                                                                        InputProps={{
                                                                                                            startAdornment: (
                                                                                                                <p
                                                                                                                    style={{
                                                                                                                        paddingLeft: '8px',
                                                                                                                        fontSize: '16px',
                                                                                                                    }}
                                                                                                                >
                                                                                                                    $
                                                                                                                </p>
                                                                                                            ),
                                                                                                        }}
                                                                                                        onKeyDown={handlePreventKeyDownDecimal}
                                                                                                        sx={{
                                                                                                            height: '40px',
                                                                                                            boxShadow: '0px 2px 3px 0px rgba(0, 0, 0, 0.06)',

                                                                                                            borderRadius: '8px',
                                                                                                            '& .MuiInputBase-root': {
                                                                                                                border: 'none',
                                                                                                                padding: '12px 0 12px 0',
                                                                                                                height: '40px',
                                                                                                                fontSize: '16px',
                                                                                                                letterSpacing: '0.17px',
                                                                                                                lineHeight: '143%',
                                                                                                            },
                                                                                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline':
                                                                                                                {
                                                                                                                    borderRadius: '8px',
                                                                                                                },
                                                                                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                                                                                                                {
                                                                                                                    WebkitAppearance: 'none',
                                                                                                                    margin: 0,
                                                                                                                },
                                                                                                            '& input[type=number]': {
                                                                                                                MozAppearance: 'textfield',
                                                                                                            },
                                                                                                        }}
                                                                                                    />
                                                                                                </TableCell>
                                                                                                {/* price update modal  */}
                                                                                                <CommonDialog
                                                                                                    dialogClaassName="commonDialog commonDialog__600"
                                                                                                    open={
                                                                                                        openPriceChangeModal.open &&
                                                                                                        openPriceChangeModal.outerIndex === outerIndex &&
                                                                                                        openPriceChangeModal.innerIndex === innerIndex
                                                                                                    }
                                                                                                    iconClose={true}
                                                                                                    onIconClose={() => {
                                                                                                        const clone = JSON.parse(
                                                                                                            JSON.stringify(serviceListPayload)
                                                                                                        );
                                                                                                        clone[openPriceChangeModal.outerIndex].parts[
                                                                                                            openPriceChangeModal.innerIndex
                                                                                                        ].partCost = previousPriceRef.current;
                                                                                                        const partQty =
                                                                                                            clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                openPriceChangeModal.innerIndex
                                                                                                            ].partQty || 0;

                                                                                                        const qty = Number(partQty) || 0;
                                                                                                        const cost = Number(previousPriceRef.current) || 0;
                                                                                                        clone[openPriceChangeModal.outerIndex].parts[
                                                                                                            openPriceChangeModal.innerIndex
                                                                                                        ].totalAmount =
                                                                                                            qty && cost
                                                                                                                ? Number(NumericEngine.multiply(qty, cost))
                                                                                                                : 0;

                                                                                                        setServiceListPayload(clone);
                                                                                                        setOpenPriceChangeModal({
                                                                                                            open: false,
                                                                                                            outerIndex: 0,
                                                                                                            innerIndex: 0,
                                                                                                        });
                                                                                                        previousPriceRef.current = null;
                                                                                                    }}
                                                                                                    onClose={() => {
                                                                                                        handleClosePriceChangeModal(
                                                                                                            openPriceChangeModal.outerIndex,
                                                                                                            openPriceChangeModal.innerIndex
                                                                                                        );
                                                                                                    }}
                                                                                                    onSave={async () => {
                                                                                                        try {
                                                                                                            setPriceUpdateLoader(true);
                                                                                                            const clone = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );

                                                                                                            let batchNumber =
                                                                                                                clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                    openPriceChangeModal.innerIndex
                                                                                                                ]?.batchNumber[0];

                                                                                                            const values =
                                                                                                                await getInventoryBatchDetailApi(batchNumber);

                                                                                                            const inventoryId =
                                                                                                                values?.inventory?._id ||
                                                                                                                values?.inventoryId ||
                                                                                                                values?._id;

                                                                                                            const batchN = batchNumber || undefined;

                                                                                                            const pricingMethod =
                                                                                                                values?.pricingMethod ||
                                                                                                                values?.inventory?.lastPricingMethod;

                                                                                                            const partCost =
                                                                                                                clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                    openPriceChangeModal.innerIndex
                                                                                                                ].partCost || 0;

                                                                                                            const cost = Number(values.cost);

                                                                                                            let inventoryPayload = {
                                                                                                                pricingMethod: PRICING_METHOD.RETAIL_PRICE,
                                                                                                                retailPrice: partCost,
                                                                                                                partsType: values?.inventory?.partsType,
                                                                                                                partName:
                                                                                                                    values?.inventory?.part?.partName ||
                                                                                                                    values?.part?.partName ||
                                                                                                                    values?.part?.name ||
                                                                                                                    undefined,
                                                                                                                partsBrandName:
                                                                                                                    values?.inventory?.partsBrand?.name ||
                                                                                                                    undefined,
                                                                                                                partsCategoryName:
                                                                                                                    values?.inventory?.partsCategory?.name ||
                                                                                                                    undefined,
                                                                                                                partsProvider:
                                                                                                                    values?.inventory?.lastPartsProvider ||
                                                                                                                    undefined,
                                                                                                                supplierId: values?.supplier || undefined,
                                                                                                                supplierInvoiceNumber: values?.supplier
                                                                                                                    ? values?.supplierInvoice?.invoiceNumber ||
                                                                                                                      undefined
                                                                                                                    : undefined,
                                                                                                                partNumber:
                                                                                                                    values?.inventory?.partNumber ||
                                                                                                                    values?.partNumber ||
                                                                                                                    undefined,
                                                                                                                description:
                                                                                                                    values?.inventory?.lastDescription ||
                                                                                                                    undefined,
                                                                                                                qty: Number(values.inStock) || 0,
                                                                                                                cost: cost,
                                                                                                            };

                                                                                                            if (values?.inventory?.feeAmount > 0) {
                                                                                                                inventoryPayload.feeName =
                                                                                                                    values?.inventory?.fee?.name || undefined;
                                                                                                                inventoryPayload.feeAmount =
                                                                                                                    Number(values?.inventory?.feeAmount) || 0;
                                                                                                            }
                                                                                                            if (values?.partsType === PART_TYPES.TYRE) {
                                                                                                                inventoryPayload.partNumber = undefined;
                                                                                                                inventoryPayload.partsCategoryName = undefined;
                                                                                                                inventoryPayload.tyreModelName =
                                                                                                                    values?.inventory?.tyreModel?.name ||
                                                                                                                    undefined;
                                                                                                                inventoryPayload.tyreDimension =
                                                                                                                    values.tyreDimension || undefined;
                                                                                                            }
                                                                                                            const resp = await updateInventoryApi(
                                                                                                                inventoryId,
                                                                                                                batchN,
                                                                                                                filterUndefined(inventoryPayload)
                                                                                                            );

                                                                                                            if (resp?.data?._id) {
                                                                                                                clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                    openPriceChangeModal.innerIndex
                                                                                                                ].partCost = partCost;
                                                                                                                const partQty =
                                                                                                                    clone[openPriceChangeModal.outerIndex]
                                                                                                                        .parts[openPriceChangeModal.innerIndex]
                                                                                                                        .partQty || 0;
                                                                                                                const qty = Number(partQty) || 0;
                                                                                                                const cost = Number(partCost) || 0;
                                                                                                                clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                    openPriceChangeModal.innerIndex
                                                                                                                ].totalAmount =
                                                                                                                    qty && cost
                                                                                                                        ? Number(
                                                                                                                              NumericEngine.multiply(qty, cost)
                                                                                                                          )
                                                                                                                        : 0;

                                                                                                                if (
                                                                                                                    clone[openPriceChangeModal.outerIndex]
                                                                                                                        .parts[openPriceChangeModal.innerIndex]
                                                                                                                        .batchArray?.length > 0
                                                                                                                ) {
                                                                                                                    clone[
                                                                                                                        openPriceChangeModal.outerIndex
                                                                                                                    ].parts[innerIndex].batchArray = clone[
                                                                                                                        openPriceChangeModal.outerIndex
                                                                                                                    ].parts[innerIndex].batchArray.map(
                                                                                                                        (batch) => ({
                                                                                                                            ...batch,
                                                                                                                            batchCost: partCost,
                                                                                                                        })
                                                                                                                    );
                                                                                                                } else {
                                                                                                                    clone[
                                                                                                                        openPriceChangeModal.outerIndex
                                                                                                                    ].parts[innerIndex].batchArray = [
                                                                                                                        { batchCost: partCost },
                                                                                                                    ];
                                                                                                                }

                                                                                                                setServiceListPayload(clone);
                                                                                                            }
                                                                                                            setPriceUpdateLoader(false);
                                                                                                            setOpenPriceChangeModal({
                                                                                                                open: false,
                                                                                                                outerIndex: 0,
                                                                                                                innerIndex: 0,
                                                                                                            });
                                                                                                            previousPriceRef.current = null;
                                                                                                        } catch (error) {
                                                                                                            const clone = JSON.parse(
                                                                                                                JSON.stringify(serviceListPayload)
                                                                                                            );
                                                                                                            clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                openPriceChangeModal.innerIndex
                                                                                                            ].partCost = previousPriceRef.current;
                                                                                                            const partQty =
                                                                                                                clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                    openPriceChangeModal.innerIndex
                                                                                                                ].partQty || 0;

                                                                                                            const qty = Number(partQty) || 0;
                                                                                                            const cost = Number(previousPriceRef.current) || 0;
                                                                                                            clone[openPriceChangeModal.outerIndex].parts[
                                                                                                                openPriceChangeModal.innerIndex
                                                                                                            ].totalAmount =
                                                                                                                qty && cost
                                                                                                                    ? Number(NumericEngine.multiply(qty, cost))
                                                                                                                    : 0;

                                                                                                            setServiceListPayload(clone);
                                                                                                            setOpenPriceChangeModal({
                                                                                                                open: false,
                                                                                                                outerIndex: 0,
                                                                                                                innerIndex: 0,
                                                                                                            });
                                                                                                            previousPriceRef.current = null;
                                                                                                        } finally {
                                                                                                            setPriceUpdateLoader(false);
                                                                                                            setOpenPriceChangeModal({
                                                                                                                open: false,
                                                                                                                outerIndex: 0,
                                                                                                                innerIndex: 0,
                                                                                                            });
                                                                                                        }
                                                                                                    }}
                                                                                                    loader={priceUpdateLoader}
                                                                                                    dialogTitle="Price Change Detected"
                                                                                                    dialogSubtitle="The price you entered doesn’t match the current inventory price."
                                                                                                    dialogSubtitle2={
                                                                                                        ' Would you like to apply this change only for this invoice, or update the inventory price for this part going forward?'
                                                                                                    }
                                                                                                    cancelButtonText="ONLY FOR THIS INVOICE"
                                                                                                    cancelButtonWidth="223px"
                                                                                                    saveButtonText="UPDATE ALL INVENTORY"
                                                                                                    saveButtonType="primary"
                                                                                                    saveButtonWidth="220px"
                                                                                                />

                                                                                                <TableCell
                                                                                                    align="left"
                                                                                                    style={{
                                                                                                        padding: '6px 12px',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                >
                                                                                                    <Typography fontWeight={600} fontSize={16}>
                                                                                                        {NumericEngine.format(part?.totalAmount || 0, {
                                                                                                            formatCurrency: true,
                                                                                                            trailingZeros: true,
                                                                                                        })}
                                                                                                    </Typography>
                                                                                                </TableCell>
                                                                                                {isNewTaxVersionActive && (
                                                                                                    <TableCell
                                                                                                        align="left"
                                                                                                        style={{
                                                                                                            padding: '6px 8px',
                                                                                                        }}
                                                                                                        sx={partItemRowStyle(isLastRowMain)}
                                                                                                    >
                                                                                                        <LineTaxCell
                                                                                                            taxesBreakdown={part?.taxesBreakdown}
                                                                                                            // Tax base for a part = qty × (cost + per-unit fee). part.totalAmount is
                                                                                                            // qty × cost only — the fee ("Parts disposal") is a separate field, shown on
                                                                                                            // its own row. partGrossAmount() is what the totals engine
                                                                                                            // (buildTaxableLines) already charges tax on, so passing it here makes the
                                                                                                            // chip agree with the tax actually billed.
                                                                                                            lineAmount={partGrossAmount(part)}
                                                                                                            documentType={DOCUMENT_TAX_TYPE.WORK_ORDER}
                                                                                                            shopTaxesData={shopTaxesData}
                                                                                                            globalTaxesBreakdown={taxesBreakdown}
                                                                                                            provinceTaxGroup={provinceTaxGroup}
                                                                                                            documentHasPartsOrPackages={
                                                                                                                documentHasPartsOrPackages
                                                                                                            }
                                                                                                            kind={LINE_TAX_KIND.PARTS}
                                                                                                            editable={isNewTaxVersionActive}
                                                                                                            onChange={(next) => {
                                                                                                                const clone = JSON.parse(
                                                                                                                    JSON.stringify(serviceListPayload)
                                                                                                                );
                                                                                                                clone[outerIndex].parts[
                                                                                                                    innerIndex
                                                                                                                ].taxesBreakdown = next;
                                                                                                                setServiceListPayload(clone);
                                                                                                            }}
                                                                                                            discount={paymentDetails?.discount}
                                                                                                            subTotal={paymentDetails?.subTotal}
                                                                                                        />
                                                                                                    </TableCell>
                                                                                                )}
                                                                                                <TableCell
                                                                                                    style={{
                                                                                                        padding: '0',
                                                                                                    }}
                                                                                                    sx={partItemRowStyle(isLastRowMain)}
                                                                                                    align="left"
                                                                                                >
                                                                                                    <Stack
                                                                                                        direction="row"
                                                                                                        gap={1.5}
                                                                                                        justifyContent={'flex-start'}
                                                                                                    >
                                                                                                        <IconButton
                                                                                                            color="error"
                                                                                                            style={{ padding: '0' }}
                                                                                                            onClick={() => {
                                                                                                                if (part?.partName || part?._id) {
                                                                                                                    setIsOpenPartDeleteModal({
                                                                                                                        open: true,
                                                                                                                        outerIndex,
                                                                                                                        innerIndex,
                                                                                                                    });
                                                                                                                } else {
                                                                                                                    if (!isDirty) {
                                                                                                                        markSaved();
                                                                                                                    }
                                                                                                                    handleDeletePartFunction(
                                                                                                                        outerIndex,
                                                                                                                        innerIndex
                                                                                                                    );
                                                                                                                }
                                                                                                            }}
                                                                                                        >
                                                                                                            <Delete />
                                                                                                        </IconButton>

                                                                                                        {/* CommonDialog placed inside map */}
                                                                                                        <CommonDialog
                                                                                                            dialogClaassName="commonDialog commonDialog__470"
                                                                                                            open={
                                                                                                                isOpenPartDeleteModal.open &&
                                                                                                                isOpenPartDeleteModal.outerIndex ===
                                                                                                                    outerIndex &&
                                                                                                                isOpenPartDeleteModal.innerIndex === innerIndex
                                                                                                            }
                                                                                                            onClose={() =>
                                                                                                                setIsOpenPartDeleteModal({
                                                                                                                    open: false,
                                                                                                                    outerIndex: 0,
                                                                                                                    innerIndex: 0,
                                                                                                                })
                                                                                                            }
                                                                                                            onSave={() => {
                                                                                                                if (!isDirty) {
                                                                                                                    markSaved();
                                                                                                                }
                                                                                                                handleDeletePartFunction(
                                                                                                                    isOpenPartDeleteModal.outerIndex,
                                                                                                                    isOpenPartDeleteModal.innerIndex
                                                                                                                );
                                                                                                            }}
                                                                                                            loader={false}
                                                                                                            dialogTitle="Delete Part?"
                                                                                                            dialogSubtitle={
                                                                                                                ' Are you sure you want to remove this part from your invoice? This action can’t be undone.'
                                                                                                            }
                                                                                                            saveButtonText="DELETE"
                                                                                                            cancelButtonText="CANCEL"
                                                                                                        />
                                                                                                    </Stack>
                                                                                                </TableCell>
                                                                                            </TableRow>

                                                                                            {part?.description && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        sx={{
                                                                                                            paddingInline: '12px',
                                                                                                            ...partItemRowStyle(isLastRowDescription),
                                                                                                        }}
                                                                                                    />
                                                                                                    <TableCell
                                                                                                        colSpan={isNewTaxVersionActive ? 6 : 5}
                                                                                                        sx={{
                                                                                                            paddingLeft: '0',
                                                                                                            paddingTop: '12px',
                                                                                                            ...partItemRowStyle(isLastRowDescription),
                                                                                                        }}
                                                                                                    >
                                                                                                        <Typography
                                                                                                            color={'#848484'}
                                                                                                            sx={{
                                                                                                                fontSize: '14px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.4px',
                                                                                                                lineHeight: '20px',
                                                                                                                color: '#848484',
                                                                                                            }}
                                                                                                        >
                                                                                                            {part?.description}
                                                                                                        </Typography>
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )}

                                                                                            {part?.feeAmount > 0 && part?.fee?.name && (
                                                                                                <TableRow>
                                                                                                    <TableCell
                                                                                                        sx={{
                                                                                                            paddingTop: '12px',
                                                                                                            ...partItemRowStyle(isLastRowFee),
                                                                                                        }}
                                                                                                    />
                                                                                                    <TableCell
                                                                                                        align="left"
                                                                                                        colSpan={2}
                                                                                                        sx={{
                                                                                                            paddingTop: '12px',
                                                                                                            paddingLeft: '0',
                                                                                                            ...partItemRowStyle(isLastRowFee),
                                                                                                        }}
                                                                                                    >
                                                                                                        <Typography
                                                                                                            color={'#000000DE'}
                                                                                                            sx={{
                                                                                                                marginTop: '0',
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.4px',
                                                                                                                lineHeight: '20px',
                                                                                                                color: '#000000DE',
                                                                                                            }}
                                                                                                        >
                                                                                                            {part?.fee?.name}
                                                                                                        </Typography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        align="left"
                                                                                                        colSpan={1}
                                                                                                        sx={{
                                                                                                            paddingTop: '12px',
                                                                                                            paddingLeft: '24px',
                                                                                                            fontSize: '16px',
                                                                                                            ...partItemRowStyle(isLastRowFee),
                                                                                                        }}
                                                                                                    >
                                                                                                        {NumericEngine.format(part?.feeAmount || 0, {
                                                                                                            formatCurrency: true,
                                                                                                            trailingZeros: true,
                                                                                                        })}
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        colSpan={1}
                                                                                                        sx={{
                                                                                                            paddingTop: '12px',
                                                                                                            paddingLeft: '12px',
                                                                                                            fontWeight: 600,
                                                                                                            fontSize: '16px',
                                                                                                            ...partItemRowStyle(isLastRowFee),
                                                                                                        }}
                                                                                                    >
                                                                                                        <Typography fontWeight={600} fontSize={16}>
                                                                                                            {NumericEngine.format(
                                                                                                                (() => {
                                                                                                                    const qty = Number(part?.partQty) || 0;
                                                                                                                    const fee = Number(part?.feeAmount) || 0;
                                                                                                                    return qty && fee
                                                                                                                        ? Number(
                                                                                                                              NumericEngine.multiply(qty, fee)
                                                                                                                          )
                                                                                                                        : 0;
                                                                                                                })(),
                                                                                                                {
                                                                                                                    formatCurrency: true,
                                                                                                                    trailingZeros: true,
                                                                                                                }
                                                                                                            )}
                                                                                                        </Typography>
                                                                                                    </TableCell>
                                                                                                    <TableCell
                                                                                                        colSpan={isNewTaxVersionActive ? 2 : 1}
                                                                                                        sx={{
                                                                                                            paddingTop: '12px',
                                                                                                            ...partItemRowStyle(isLastRowFee),
                                                                                                        }}
                                                                                                    />
                                                                                                </TableRow>
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })}

                                                                            {shouldShowPerServiceSubtotalRow(outerItem, { variant: 'form' }) && (
                                                                                <TableRow>
                                                                                    <TableCell
                                                                                        colSpan={4}
                                                                                        style={{
                                                                                            borderBottom: 0,
                                                                                            background: '#F8F8F8',
                                                                                            padding: '12px',
                                                                                        }}
                                                                                    ></TableCell>
                                                                                    <TableCell
                                                                                        style={{
                                                                                            borderBottom: 0,
                                                                                            background: '#F8F8F8',
                                                                                            padding: '12px',
                                                                                        }}
                                                                                    >
                                                                                        <Typography fontWeight={600} fontSize={16}>
                                                                                            {serviceSubtotal > 0
                                                                                                ? NumericEngine.format(serviceSubtotal, {
                                                                                                      formatCurrency: true,
                                                                                                      trailingZeros: true,
                                                                                                  })
                                                                                                : '$0.00'}
                                                                                        </Typography>
                                                                                    </TableCell>
                                                                                    {isNewTaxVersionActive && (
                                                                                        <TableCell
                                                                                            style={{
                                                                                                borderBottom: 0,
                                                                                                background: '#F8F8F8',
                                                                                                padding: '12px',
                                                                                            }}
                                                                                        />
                                                                                    )}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            borderBottom: 0,
                                                                                            background: '#F8F8F8',
                                                                                            padding: '12px',
                                                                                        }}
                                                                                    ></TableCell>
                                                                                </TableRow>
                                                                            )}
                                                                        </TableBody>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                            {/* Bottombutton  */}
                                                            <Grid
                                                                container
                                                                item
                                                                justifyContent={'space-between'}
                                                                style={{ padding: '24px 24px 0 24px' }}
                                                                gap={2}
                                                            >
                                                                <Grid item xs="auto">
                                                                    <Stack direction="row" spacing={2}>
                                                                        {!outerItem?.showDesc && (
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="black"
                                                                                size="large"
                                                                                onClick={() => {
                                                                                    let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
                                                                                    cloneService[outerIndex].showDesc = true;
                                                                                    setServiceListPayload(cloneService);
                                                                                }}
                                                                                startIcon={<Add />}
                                                                            >
                                                                                DESC
                                                                            </Button>
                                                                        )}
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            size="large"
                                                                            startIcon={<Add />}
                                                                            onClick={() => {
                                                                                let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
                                                                                if (cloneService[outerIndex].pricingType === PRICING_TYPES.FXIED) {
                                                                                    cloneService[outerIndex] = {
                                                                                        ...cloneService[outerIndex],
                                                                                        pricingType: PRICING_TYPES.LABOUR,
                                                                                        fixedPrice: '0',

                                                                                        parts: [
                                                                                            {
                                                                                                type: 'search',
                                                                                                partQty: 1,
                                                                                                partCost: 0,
                                                                                                partRowId: createPartRowId(),
                                                                                            },
                                                                                        ],
                                                                                    };
                                                                                    setServiceListPayload(cloneService);
                                                                                } else {
                                                                                    let newPart = {
                                                                                        type: 'search',
                                                                                        partQty: 1,
                                                                                        partCost: 0,
                                                                                        partRowId: createPartRowId(),
                                                                                    };
                                                                                    if (cloneService[outerIndex]?.parts) {
                                                                                        cloneService[outerIndex].parts.push(newPart);
                                                                                    } else {
                                                                                        cloneService[outerIndex].parts = [newPart];
                                                                                    }
                                                                                    setServiceListPayload(cloneService);
                                                                                }

                                                                                setTimeout(() => {
                                                                                    const innerIndex =
                                                                                        typeof cloneService[outerIndex]?.parts?.length === 'number'
                                                                                            ? cloneService[outerIndex].parts.length
                                                                                            : 0 + 1;
                                                                                    const input = document.getElementById(
                                                                                        `inventory-search-${outerIndex}-${innerIndex - 1}`
                                                                                    );
                                                                                    if (input) {
                                                                                        input.focus();
                                                                                    }
                                                                                }, 300);
                                                                            }}
                                                                        >
                                                                            PART
                                                                        </Button>
                                                                        {!outerItem?.qty && !outerItem?.ratePerHour && (
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                startIcon={<Add />}
                                                                                size="large"
                                                                                // disabled={
                                                                                //   outerItem?.pricingType ===
                                                                                //   PRICING_TYPES.FXIED
                                                                                // }
                                                                                onClick={async () => {
                                                                                    setIsLoading(true);

                                                                                    let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
                                                                                    const ratePerHour = shopPriceDetails?.priceBase?.labor?.defaultHourlyRate;

                                                                                    let payload = {
                                                                                        qty: 1,
                                                                                        ratePerHour: ratePerHour,
                                                                                        amount: 1 * ratePerHour,
                                                                                        pricingType: PRICING_TYPES.LABOUR,
                                                                                    };
                                                                                    if (cloneService[outerIndex]) {
                                                                                        cloneService[outerIndex] = {
                                                                                            ...cloneService[outerIndex], // Spread the existing properties
                                                                                            ...payload, // Add/replace the category and service data
                                                                                        };
                                                                                    } else {
                                                                                        payload.type = 'select';
                                                                                        payload.pricingType = PRICING_TYPES.LABOUR;
                                                                                        cloneService = [payload];
                                                                                    }

                                                                                    setIsLoading(false);
                                                                                    setServiceListPayload(cloneService);
                                                                                    setTimeout(() => {
                                                                                        if (labourTextRef.current[outerIndex]) {
                                                                                            labourTextRef.current[outerIndex].focus(); // Ensure focus works
                                                                                        }
                                                                                    }, 300);
                                                                                }}
                                                                            >
                                                                                LABOUR
                                                                            </Button>
                                                                        )}
                                                                    </Stack>
                                                                </Grid>

                                                                <Grid item xs="auto">
                                                                    <Stack direction="row" spacing={2} justifyContent={'flex-end'} width={'100%'}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="error"
                                                                            startIcon={<Delete />}
                                                                            size="large"
                                                                            onClick={() => {
                                                                                if (!isDirty) {
                                                                                    markSaved();
                                                                                }
                                                                                setIsOpenServiceDeleteModal({ open: true, outerIndex: outerIndex });
                                                                            }}
                                                                        >
                                                                            REMOVE
                                                                        </Button>
                                                                        {/* CommonDialog placed inside map */}
                                                                        <CommonDialog
                                                                            dialogClaassName="commonDialog commonDialog__470"
                                                                            open={
                                                                                isOpenServiceDeleteModal.open &&
                                                                                isOpenServiceDeleteModal.outerIndex === outerIndex
                                                                            }
                                                                            onClose={() =>
                                                                                setIsOpenServiceDeleteModal({ open: false, outerIndex: 0, innerIndex: 0 })
                                                                            }
                                                                            onSave={() => {
                                                                                let cloneService = JSON.parse(JSON.stringify(serviceListPayload));
                                                                                cloneService.splice(isOpenServiceDeleteModal.outerIndex, 1);
                                                                                setServiceListPayload(cloneService);
                                                                                setIsOpenServiceDeleteModal({ open: false, outerIndex: 0, innerIndex: 0 });
                                                                            }}
                                                                            loader={false}
                                                                            dialogTitle="Remove Service?"
                                                                            subtitle2MarginTop="0"
                                                                            dialogSubtitle={
                                                                                outerItem?.service?.name
                                                                                    ? `Are you sure you want to delete the “${outerItem?.service?.name}” service? `
                                                                                    : 'Are you sure you want to delete this service? '
                                                                            }
                                                                            dialogSubtitle2={'All parts and fees under this service will be removed.'}
                                                                            saveButtonText="REMOVE"
                                                                            cancelButtonText="CANCEL"
                                                                        />
                                                                        {!hasManagedPart && (
                                                                            <Button
                                                                                variant="contained"
                                                                                style={{
                                                                                    background: ' rgba(0, 0, 0, 0.10)',
                                                                                    color: '#000',
                                                                                }}
                                                                                startIcon={
                                                                                    <svg
                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                        width="20"
                                                                                        height="20"
                                                                                        viewBox="0 0 20 20"
                                                                                        fill="none"
                                                                                    >
                                                                                        <path
                                                                                            d="M17.3187 5.80626L14.1937 2.68126C14.1353 2.62333 14.0661 2.57751 13.9899 2.5464C13.9138 2.5153 13.8323 2.49953 13.75 2.50001H3.75C3.41848 2.50001 3.10054 2.63171 2.86612 2.86613C2.6317 3.10055 2.5 3.41849 2.5 3.75001V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V6.25001C17.5005 6.16776 17.4847 6.08622 17.4536 6.01007C17.4225 5.93392 17.3767 5.86466 17.3187 5.80626ZM7.5 3.75001H12.5V6.25001H7.5V3.75001ZM12.5 16.25H7.5V11.25H12.5V16.25ZM13.75 16.25V11.25C13.75 10.9185 13.6183 10.6005 13.3839 10.3661C13.1495 10.1317 12.8315 10 12.5 10H7.5C7.16848 10 6.85054 10.1317 6.61612 10.3661C6.3817 10.6005 6.25 10.9185 6.25 11.25V16.25H3.75V3.75001H6.25V6.25001C6.25 6.58153 6.3817 6.89947 6.61612 7.13389C6.85054 7.36831 7.16848 7.50001 7.5 7.50001H12.5C12.8315 7.50001 13.1495 7.36831 13.3839 7.13389C13.6183 6.89947 13.75 6.58153 13.75 6.25001V4.00626L16.25 6.50626V16.25H13.75Z"
                                                                                            fill="black"
                                                                                        />
                                                                                    </svg>
                                                                                }
                                                                                size="large"
                                                                                onClick={() => {
                                                                                    const currentService = serviceListPayload[outerIndex];

                                                                                    // Common validations first
                                                                                    if (!currentService?.service?._id) {
                                                                                        toast.error('Please select a service before saving.');
                                                                                        return;
                                                                                    }

                                                                                    // if (!selectedVehicleMake?._id) {
                                                                                    //     toast.error('Please select a vehicle to continue.');
                                                                                    //     return;
                                                                                    // }

                                                                                    // Pricing type specific validations
                                                                                    if (currentService.pricingType === PRICING_TYPES.FXIED) {
                                                                                        const fixedAmount = Number(currentService.fixedPrice);
                                                                                        if (!fixedAmount || fixedAmount <= 0) {
                                                                                            toast.error('Fixed price amount must be greater than zero.');
                                                                                            return;
                                                                                        }
                                                                                    } else if (currentService.pricingType === PRICING_TYPES.LABOUR) {
                                                                                        // Check if all parts are unmanaged
                                                                                        if (currentService.parts && currentService.parts.length > 0) {
                                                                                            const hsEmptyString = currentService.parts.some(
                                                                                                (part) => !part.partName
                                                                                            );

                                                                                            if (hsEmptyString) {
                                                                                                toast.error('Part name cannot be empty', {
                                                                                                    icon: (
                                                                                                        <InfoOutlined
                                                                                                            sx={{
                                                                                                                fontSize: '22px',
                                                                                                            }}
                                                                                                        />
                                                                                                    ),
                                                                                                });
                                                                                                return;
                                                                                            }
                                                                                        }
                                                                                    }

                                                                                    // All validations passed, open the modal
                                                                                    setSavedServiceOuterIndex(outerIndex);
                                                                                    setOpenCreateSavedServiceFromInvoiceModal(true);
                                                                                }}
                                                                            >
                                                                                SAVE
                                                                            </Button>
                                                                        )}
                                                                    </Stack>
                                                                </Grid>
                                                            </Grid>
                                                        </AccordionDetails>
                                                    </Accordion>
                                                );
                                            })}
                                    </div>
                                </Grid>

                                {isTableVisible && (
                                    <Grid item container justifyContent={'center'} marginTop={'24px'}>
                                        <Button
                                            startIcon={<Add />}
                                            color="secondary"
                                            variant={'contained'}
                                            className="btn-text-size-manage"
                                            style={{ height: '42px' }}
                                            onClick={handleAddService}
                                            sx={{ mr: 2 }}
                                        >
                                            ADD SERVICE
                                        </Button>
                                        <Button
                                            startIcon={<Add />}
                                            color="primary"
                                            variant={'outlined'}
                                            className="btn-text-size-manage"
                                            style={{ height: '42px' }}
                                            onClick={() => handleOpenSavedServicesModal(null)}
                                        >
                                            Saved Service
                                        </Button>
                                    </Grid>
                                )}

                                {/* FeesSection  */}
                                <FeesSection
                                    feesList={FeesList}
                                    selectedFees={selectedFees}
                                    setSelectedFees={setSelectedFees}
                                    paymentDetails={paymentDetails}
                                    fetchFeesList={fetchFeesList}
                                    isNewTaxVersion={isNewTaxVersionActive}
                                    shopTaxesData={shopTaxesData}
                                    documentType={DOCUMENT_TAX_TYPE.WORK_ORDER}
                                    globalTaxesBreakdown={taxesBreakdown}
                                />

                                <AddNotesSection control={control} country={shopConfigData?.config?.mileageUnit} />

                                {/* AdditionalDetailsAccordian  */}
                                {screenWidth < 1200 && (
                                    <Grid item container justifyContent={'center'} marginTop={'24px'}>
                                        <AdditionalDetailsAccrodian
                                            type="workOrder"
                                            setInvoiceDataInStore={setInvoiceDataInStore}
                                            invoiceDataInStore={invoiceDataInStore}
                                            index={2}
                                            accordianExpanded={accordianExpanded}
                                            handleAccordianToggle={handleAccordianToggle}
                                            setValue={setValue}
                                            errors={errors}
                                            control={control}
                                            hideTerms
                                        />
                                    </Grid>
                                )}

                                {/*
                                 * Authorization — the one section the invoice does not have.
                                 * Plain open text field, no modal (spec §4.5).
                                 */}
                                <Grid item container xs={12} className="customBoxWrapper" marginTop={'24px'} padding={'24px'}>
                                    {/*
                                     * The header row keeps the button's height whether or not the button is
                                     * showing, so typing in the box reveals it without shifting the page.
                                     */}
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        sx={{ width: '100%', minHeight: '36px', mb: '16px' }}
                                    >
                                        {/* Title row: section icon + heading, 4px apart (design). */}
                                        <Stack direction="row" alignItems="center" gap={'4px'}>
                                            <AuthorizationSectionSvg />
                                            <Typography
                                                sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '32px', letterSpacing: '0.15px', color: '#212121' }}
                                            >
                                                Authorization
                                            </Typography>
                                        </Stack>

                                        <Button
                                            variant="contained"
                                            disabled={updateShopConfigMutation.isPending}
                                            onClick={handleSetAuthorizationAsDefault}
                                            startIcon={updateShopConfigMutation.isPending ? <CircularProgress size={16} sx={{ color: '#000' }} /> : null}
                                            // Design's own style for this button only.
                                            sx={{
                                                visibility: authorizationDiffersFromDefault ? 'visible' : 'hidden',
                                                pointerEvents: authorizationDiffersFromDefault ? 'auto' : 'none',
                                                borderRadius: '4px',
                                                background: 'rgba(0, 0, 0, 0.10)',
                                                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                                height: '42px',
                                                padding: '6px 12px',
                                                alignItems: 'center',
                                                color: '#000',
                                                fontSize: '15px',
                                                fontWeight: 500,
                                                lineHeight: '26px',
                                                letterSpacing: '0.46px',
                                                textTransform: 'uppercase',
                                                '&:hover': { background: 'rgba(0, 0, 0, 0.10)', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)' },
                                            }}
                                        >
                                            SET AS DEFAULT
                                        </Button>
                                    </Stack>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={5}
                                        value={authorizationText}
                                        onChange={(e) => setAuthorizationText(e.target.value)}
                                        sx={MuiMultiFieldWithFocus}
                                    />
                                </Grid>

                                {/* PaymentDetailsAccordian  */}
                                <Grid item container justifyContent={'center'} marginTop={'24px'}>
                                    <PaymentDetailsAccrodian
                                        type={'invoice'}
                                        index={1}
                                        accordianExpanded={accordianExpanded}
                                        handleAccordianToggle={handleAccordianToggle}
                                        errors={errors}
                                        control={control}
                                        customerInvoiceTaxes={customerInvoiceTaxes}
                                        paymentDetails={paymentDetails}
                                        setPaymentDetails={setPaymentDetails}
                                        discountId={discountId}
                                        setDiscountId={setDiscountId}
                                        setSelectedDiscount={setSelectedDiscount}
                                        discountList={discountList.length > 0 ? discountList : []}
                                        structuredPaymentSummary
                                        taxPercentageInputRef={taxPercentageInputRef}
                                        isNewTaxVersion={isNewTaxVersionActive}
                                        taxesBreakdown={taxesBreakdown}
                                        setTaxesBreakdown={setTaxesBreakdown}
                                        documentType={DOCUMENT_TAX_TYPE.WORK_ORDER}
                                        lineTaxSummary={lineTaxSummary}
                                        onBulkTaxToggle={handleBulkTaxToggle}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                {/* Footer  */}
                <Box
                    sx={{
                        padding: '24px',
                        background: '#fff',
                        // position: "absolute",
                        width: '100%',
                        // zIndex: 10,
                        // bottom: 0,
                    }}
                >
                    <Grid container justifyContent={'space-between'} spacing={2}>
                        <Grid item xs={4} sm={'auto'}>
                            <Button fullWidth color="error" variant="contained" className="btn-text-size-manage" onClick={cancelInvoice}>
                                CANCEL
                            </Button>
                        </Grid>
                        <Grid container item display={'flex'} justifyContent={'flexx-start'} xs={12} sm="auto">
                            <Grid container gap={2}>
                                {/*
                                 * Creating, or editing a draft: Save as Draft + Create Work Order —
                                 *   the second promotes the draft to open.
                                 * Editing anything else: a single Update Work Order.
                                 * A work order is never emailed, so there is no Save and Send.
                                 */}
                                {usesCreateEndpoint && (
                                    <Grid xs={5} sm="auto">
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            type="button"
                                            className="btn-text-size-manage"
                                            startIcon={<SaveAsDraftSvg />}
                                            disabled={isSubmitting || submitCompleted}
                                            onClick={async () => {
                                                if (isSubmittingRef.current || submitCompletedRef.current) return;

                                                isSaveDraftRef.current = true;
                                                isSendEmailRef.current = false;
                                                const isValid = validateInvoice(getValues());
                                                if (!isValid) {
                                                    isSubmittingRef.current = false;
                                                    setIsSubmitting(false);
                                                }
                                            }}
                                            style={{
                                                background: 'rgba(0, 0, 0, 0.10)',
                                                boxShadow: ' 0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                                                color: '#000',
                                            }}
                                        >
                                            SAVE AS DRAFT
                                        </Button>
                                    </Grid>
                                )}

                                <Grid item xs={5} sm={'auto'}>
                                    <Button
                                        variant="contained"
                                        className="btn-text-size-manage"
                                        startIcon={<SaveAndSendSvg />}
                                        disabled={isSubmitting || submitCompleted}
                                        onClick={async () => {
                                            if (isSubmittingRef.current || submitCompletedRef.current) return;
                                            if (customerData?.email) {
                                                isSaveDraftRef.current = false;
                                                isSendEmailRef.current = true;
                                                const isValid = validateInvoice(getValues());
                                                if (!isValid) {
                                                    isSubmittingRef.current = false;
                                                    setIsSubmitting(false);
                                                }
                                            } else {
                                                isSaveDraftRef.current = false;
                                                isSendEmailRef.current = true;
                                                setOpenEditCustomer(true);
                                                isSubmittingRef.current = false;
                                                setIsSubmitting(false);
                                            }
                                        }}
                                    >
                                        SAVE AND Email
                                    </Button>
                                </Grid>

                                <Grid item xs={5} sm={'auto'}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="secondary"
                                        className="btn-text-size-manage"
                                        disabled={isSubmitting || submitCompleted}
                                        onClick={async () => {
                                            if (isSubmittingRef.current || submitCompletedRef.current) return;

                                            isSaveDraftRef.current = false;
                                            isSendEmailRef.current = false;
                                            const isValid = validateInvoice(getValues());
                                            if (!isValid) {
                                                isSubmittingRef.current = false;
                                                setIsSubmitting(false);
                                            }
                                        }}
                                    >
                                        {id && !isDraftRecord ? 'UPDATE WORK ORDER' : 'CREATE WORK ORDER'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                {/* A work order takes no payment — the record-payment dialog belongs to the invoice only (spec §5). */}

                {openEditCustomer && (
                    <Suspense fallback={<CircularProgress />}>
                        <AddCustomerModalV4
                            from="invoice_email"
                            openModal={openEditCustomer}
                            customerId={customerData?.refIdUsers || customerData?._id}
                            customerType={customerData?.createdFrom || USER_TYPES.SHOP_CREATED}
                            onClose={() => {
                                setOpenEditCustomer(false);
                            }}
                            onSubmitModal={(updatedCustomer) => {
                                setOpenEditCustomer(false);

                                // update local customer state
                                setCustomerData(updatedCustomer);

                                // update RHF value
                                setValue('customerId', updatedCustomer);

                                // continue estimate validation/save flow
                                validateInvoice(getValues(), false);
                            }}
                        />
                    </Suspense>
                )}
            </form>

            <AddCustomerProgramModal
                loader={showLoader}
                open={openProgramModal}
                setOpenProgramModal={setOpenProgramModal}
                isRemoveDiscount={isRemoveDiscount}
                setIsRemoveDiscount={setIsRemoveDiscount}
                onSave={async (type) => {
                    if (type) {
                        try {
                            setShowLoader(true);
                            const resp = await dispatch(
                                updateUserMembershipDetail(customerData.refIdUsers, {
                                    membershipProgram: discountId === 'none' || discountId === 'custom' ? '' : discountId,
                                })
                            );
                            if (resp) {
                                setOpenProgramModal(false);
                                setShowLoader(false);
                                onSubmitInvoice(storeValues);
                            }
                            setShowLoader(false);
                        } catch (error) {
                            setOpenProgramModal(false);
                            setShowLoader(false);
                        }
                    } else {
                        onSubmitInvoice(storeValues);
                    }
                }}
                customerName={customerData?.fullName}
                programName={selectedDiscount?.programName}
            />
            {/* Update linked invoice? — this work order already has an invoice (spec §6.5) */}
            <CommonDialog
                loader={false}
                open={Boolean(invoiceSyncPrompt)}
                onClose={() => setInvoiceSyncPrompt(null)}
                dialogClaassName="commonDialog commonDialog__600"
                dialogTitle="🔗 Update linked invoice?"
                dialogSubtitle={`This work order is linked to invoice ${linkedInvoiceToSync?.invoiceNumber || ''}.`}
                dialogSubtitle2="Apply these changes to the invoice?"
                dialogSubtitle3="If you update the invoice, all of the existing line items and totals will be replaced with the latest work order."
                cancelButtonText="SKIP"
                cancelButtonVariant="outlined"
                onCancel={() => {
                    const { values, isDelete, outerIndex, innerIndex, overrides } = invoiceSyncPrompt;
                    setInvoiceSyncPrompt(null);
                    void submitInvoice(values, isDelete, outerIndex, innerIndex, { ...overrides, syncLinkedInvoice: false });
                }}
                saveButtonText="UPDATE"
                saveButtonType="primary"
                saveButtonVariant="contained"
                onSave={() => {
                    const { values, isDelete, outerIndex, innerIndex, overrides } = invoiceSyncPrompt;
                    setInvoiceSyncPrompt(null);
                    void submitInvoice(values, isDelete, outerIndex, innerIndex, { ...overrides, syncLinkedInvoice: true });
                }}
            />

            {/* Reauthorization Required — editing an Authorized work order changed a reapproval field (spec §4.4) */}
            <CommonDialog
                loader={false}
                open={Boolean(reapprovalPrompt)}
                onClose={() => {
                    // X: nothing is saved, the user stays in the editor.
                    if (reapprovalPrompt?.isDelete === true) {
                        setDeletePartConfirmation(false);
                        setDeletePartLoader(false);
                    }
                    setReapprovalPrompt(null);
                }}
                dialogClaassName="commonDialog commonDialog__560"
                dialogTitle="⚠️ Reauthorization Required"
                dialogSubtitle="Saving these changes will change work order status to reapprove and you will require re-authorization from the customer."
                dialogSubtitle2="Continue updating?"
                cancelButtonText="CANCEL"
                cancelButtonVariant="outlined"
                // CANCEL just closes the prompt — nothing is saved and the status is left alone.
                onCancel={() => {
                    if (reapprovalPrompt?.isDelete === true) {
                        setDeletePartConfirmation(false);
                        setDeletePartLoader(false);
                    }
                    setReapprovalPrompt(null);
                }}
                saveButtonText="UPDATE WORK ORDER"
                saveButtonType="primary"
                saveButtonVariant="contained"
                saveButtonWidth="194px"
                onSave={() => {
                    const { values, isDelete, outerIndex, innerIndex, overrides } = reapprovalPrompt;
                    setReapprovalPrompt(null);
                    void submitInvoice(values, isDelete, outerIndex, innerIndex, { ...overrides, requireReapproval: true });
                }}
            />
            {/* AddPartModel  */}
            <AddInventoryModal
                isAddPartBtn
                isAddPartAgain={isAddPartAgain}
                setIsAddPartAgain={setIsAddPartAgain}
                disabledFields={disabledFields}
                showUsedInInvoiceFeild={true}
                FeildLabelName={'Added to Invoice'}
                stockPlusMinus={!isSaveDraftRef.current ? usedBatchQty[batchNumber] || 0 : 0}
                addQty={addQty}
                isUsedInvoiceQty={isUsedInvoiceQty}
                setIsUsedInvoiceQty={setIsUsedInvoiceQty}
                type={INVENTORY_TYPES.INVOICE}
                conflictResolutionProp={disabledFields.length === 3 ? 'create_new_part' : null}
                inventoryId={selectedInventoryId}
                batchNumber={batchNumber}
                openModal={openPartModel}
                closeModal={handleClosePartModel}
                onSubmitModal={handleSavePartModel}
                showLoader={inventoryModalLoader}
                setShowLoader={setInventoryModalLoader}
                selectedInventory={selectedInventory}
                setSelectedInventory={setSelectedInventory}
                fetchApi={(data) => {
                    handleSavePartModel(data);
                }}
                ShowAllTabs={showAllInventoryTabs}
                ShowTabIndex={inventoryTabIndex}
                modalType={inventoryModalType}
            />

            {/* AddFeeModal replaced by inline FeesSection */}

            {openVehicleModal && (
                <Suspense fallback={<CircularProgress />}>
                    <VehicleModalV4
                        open={openVehicleModal}
                        enableLicenseDecoding={false}
                        mode={
                            editVehicleData?.source === USER_TYPES.SHOP_IMPORTED
                                ? editVehicleData?.source
                                : editVehicleData
                                  ? 'update_shop_created_vehicle'
                                  : 'create'
                        }
                        customerId={customerData?.refIdUsers || customerData?._id}
                        vehicleId={editVehicleData?._id}
                        vehicleData={
                            editVehicleData
                                ? {
                                      _id: editVehicleData?._id,
                                      vin: editVehicleData?.vin || '',
                                      year: editVehicleData?.year || editVehicleData?.vehicleYear || '',
                                      vehicleMakeId: editVehicleData?.vehicleMake?._id,
                                      vehicleModelId: editVehicleData?.vehicleModel?._id,
                                      vehicleModelTrimId: editVehicleData?.vehicleModelTrim?._id,
                                      licenseNumber: editVehicleData?.licenseNumber || editVehicleData?.license || '',
                                      provinceId: editVehicleData?.provinceId || editVehicleData?.province?._id,
                                      fleetUnitNumber: editVehicleData?.fleetUnitNumber || '',
                                  }
                                : null
                        }
                        isFleetCustomer={customerData?.shopCustomer?.isFleetCustomer || customerData?.isFleetCustomer || false}
                        onClose={() => {
                            setOpenVehicleModal(false);
                            setEditVehicleData(null);
                            handleClose();
                        }}
                        onSuccess={(updatedVehicle) => {
                            const customerIdForVehicle = customerData?.refIdUsers || customerData?._id;
                            const vehicleIdToSelect = updatedVehicle?._id ?? editVehicleData?._id;
                            if (customerData) {
                                fetchVehicles(customerIdForVehicle, vehicleIdToSelect);
                            }
                            setOpenVehicleModal(false);
                            setEditVehicleData(null);
                        }}
                    />
                </Suspense>
            )}

            <PartDetailsModal
                fromCustomerInv={true}
                saveIndexes={saveIndexes}
                serviceListPayload={serviceListPayload}
                open={openPartDetailModal}
                onClose={() => {
                    setOpenPartDetailModal(false);
                    setSelectedInventoryId(null);
                    setSaveIndexes({ outerIndex: 0, innerIndex: 0 });
                    setDisabledFields([]);
                }}
                inventoryId={selectedInventoryId}
                fetchAPi={(data, noCLose, detailBatch, detailQty) => {
                    handleSavePartModel(data, noCLose, detailBatch, detailQty);
                }}
            />
            <BatchSelectionModal
                usedBatchQty={usedBatchQty}
                serviceListPayload={serviceListPayload}
                outerIndex={saveIndexes.outerIndex}
                innerIndex={saveIndexes.innerIndex}
                open={openBatchSelectionModal}
                inventoryId={inventoryOption}
                onClose={() => {
                    setInventoryOption(null);
                    setSaveIndexes({
                        outerIndex: 0,
                        innerIndex: 0,
                    });
                    setBatchSelectionModal(false);
                }}
                onSave={(data) => {
                    const filteredData = data.filter((item) => item.isSelected);
                    if (filteredData.length > 0) {
                        let cloneService = JSON.parse(JSON.stringify(serviceListPayload));

                        delete cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].type;
                        // const partQty = cloneService[outerIndex].parts[saveIndexes.innerIndex].partQty;
                        const partCost = filteredData[0]?.batchCost || inventoryOption.lastRetailPrice;
                        const previousPartCost = cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].partCost;

                        cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex] = inventoryOption;
                        let totalPart = '0';

                        cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].batchArray = filteredData.map((item, index) => {
                            totalPart = NumericEngine.add(totalPart, Number(formatNumberAsWhole(item.batchQty)) || 0);
                            return {
                                outerIndex: saveIndexes.outerIndex,
                                innerIndex: saveIndexes.innerIndex,
                                batchIndex: index,
                                batchNumber: item.batchNumber,
                                batchQty: item.batchQty,
                                batchCost: item.batchCost,
                                inStock: item.inStock,
                            };
                        });

                        cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].partQty = Number(totalPart) || 1;
                        cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].partCost = partCost || 0;

                        const qty = Number(totalPart) || 0;
                        const cost = Number(partCost) || 0;
                        const totalAmount = qty && cost ? Number(NumericEngine.multiply(qty, cost)) : 0;

                        cloneService[saveIndexes.outerIndex].parts[saveIndexes.innerIndex].totalAmount = totalAmount;
                        setServiceListPayload(cloneService);
                    }
                    setInventoryOption(null);
                    setSaveIndexes({
                        outerIndex: 0,
                        innerIndex: 0,
                    });
                    setBatchSelectionModal(false);
                }}
            />
            {/* Discard Model  */}
            <CommonDialog
                loader={false}
                open={isDiscardModel}
                onClose={() => setIsDiscardModel(false)}
                onSave={() => {
                    cancelInvoice();
                }}
                dialogTitle={'⚠️ Discard Work Order?'}
                dialogSubtitle={'You have unsaved changes. Do you want to discard this work order or continue editing?'}
                saveButtonText="Discard"
            />

            <CommonDialog
                loader={false}
                open={openZeroTaxModal}
                onClose={() => setOpenZeroTaxModal(false)}
                dialogClaassName="commonDialog commonDialog__560"
                dialogTitle={'⚠️ Sales Tax Amount is $0'}
                dialogSubtitle={'No sales tax has been added to this invoice.'}
                dialogSubtitle2={'Would you like to review the tax on this invoice before continuing?'}
                cancelButtonText="CONTINUE ANYWAY"
                cancelButtonVariant="outlined"
                cancelButtonWidth="188px"
                onCancel={() => {
                    setOpenZeroTaxModal(false);
                    zeroTaxBypassRef.current = true;
                    const action = pendingZeroTaxActionRef.current;
                    pendingZeroTaxActionRef.current = null;
                    action?.();
                }}
                saveButtonText="ADJUST TAX"
                saveButtonType="primary"
                saveButtonVariant="contained"
                saveButtonWidth="143px"
                onSave={() => {
                    setOpenZeroTaxModal(false);
                    focusTaxPercentageInput();
                }}
            />

            <TermsAndWarrantyModal
                open={openTermsModal}
                onClose={() => setOpenTermsModal(false)}
                mode={termsModalMode}
                initialValues={termsModalInitial}
                onSuccess={handleTermsModalSuccess}
                onDeleted={handleTermsDeleted}
                showInvoiceDefaultCheckbox={true}
            />

            {openAddCustomerModal && (
                <Suspense fallback={<CircularProgress />}>
                    <AddCustomerModalV4
                        openModal={openAddCustomerModal}
                        customerId={
                            isEditCustomer
                                ? customerData?.refIdImport || customerData?.refIdUsers || getValues()?.customerId?._id || getValues()?.customerId
                                : null
                        }
                        customerType={customerData?.createdFrom || USER_TYPES.shop_imported}
                        onClose={() => {
                            setIsEditCustomer(false);
                            setOpenAddCustomerModal(false);
                        }}
                        onSubmitModal={async (resp, isUserDelete) => {
                            //Actins to handle for the shop imported delete customer
                            if (isUserDelete) {
                                setValue('customerId', '');
                                setCustomerData('');
                                customersLists(1, customerLimit);

                                if (customerId && type === USER_TYPES.SHOP_IMPORTED) {
                                    navigate(`/work-orders/new`, { replace: true });
                                    return;
                                }
                            }
                            // redirect when coming from profile to estimate creation for shop_imported customer
                            if (customerId && type === USER_TYPES.SHOP_IMPORTED) {
                                setIsEditCustomer(false);
                                setOpenAddCustomerModal(false);
                                navigate(`/work-orders/new/${resp._id}/${USER_TYPES.SHOP_CREATED}`, { replace: true });

                                return;
                            }

                            // update the react hook field accordingly
                            const selectedVehicle = resp?.selectedVehicle || null;
                            const selectedVehcileId = resp?.selectedVehicleId || null;
                            if (resp?._id) {
                                setShowLoader(true);
                                if (selectedVehcileId) {
                                    skipVehicleDetailRef.current = true;
                                }
                                let customerResp;
                                if (type != SHOP_IMPORTED) {
                                    customerResp = await dispatch(customerDetailApi(resp?._id));
                                }
                                if (type == SHOP_IMPORTED && customerResp?.refIdImport) {
                                    customerResp = await dispatch(importedCustomerDetail(customerResp.refIdImport));
                                }

                                const customerObject = {
                                    ...customerResp,
                                    fullName: `${customerResp?.firstName} ${customerResp?.lastName || ''}`,
                                    refIdUsers: customerResp?._id,
                                    refIdImport: customerResp?._id,
                                    _id: customerResp._id || customerResp?._id, // Ensure _id exists for proper comparison
                                };

                                setCustomerDetail([customerObject]);
                                setCustomerData(customerObject);
                                setValue('customerId', customerObject);

                                const vehicleIdentifier = selectedVehicle || selectedVehcileId;
                                if (vehicleIdentifier) {
                                    fetchVehicles(customerObject?.refIdUsers || customerObject?._id, vehicleIdentifier);
                                }

                                setShowLoader(false);
                            }
                            // } else {
                            //     setOpenAddCustomerModal(false);
                            // }
                            // setIsEditCustomer(false);
                            setOpenAddCustomerModal(false);
                        }}
                    />
                </Suspense>
            )}

            {openSavedServicesModal && (
                <Suspense fallback={<CircularProgress />}>
                    <AddSavedServicesModal
                        openModal={openSavedServicesModal}
                        onClose={handleCloseSavedServicesModal}
                        outerIndex={savedServicesModalOuterIndex}
                        onAddToInvoice={handleAddSavedServicesToInvoice}
                        documentLabel="Work Order"
                        selectedVehicleMake={selectedVehicleMake}
                        refreshSavedServices={refreshSavedServices}
                        serviceListPayload={serviceListPayload}
                    />
                </Suspense>
            )}

            {openCreateSavedServiceFromInvoiceModal && savedServiceOuterIndex !== null && (
                <Suspense fallback={<CircularProgress />}>
                    <CreateSavedServiceFromInvoice
                        open={openCreateSavedServiceFromInvoiceModal}
                        vehicleMake={vehicleMakeList}
                        initialVehicleMake={selectedVehicleMake}
                        serviceData={serviceListPayload[savedServiceOuterIndex]}
                        onClose={() => {
                            setOpenCreateSavedServiceFromInvoiceModal(false);
                            setSavedServiceOuterIndex(null);
                        }}
                        onSave={(payload) => {
                            createSavedServiceMutation.mutate(payload);
                        }}
                        loader={createSavedServiceMutation.isPending}
                    />
                </Suspense>
            )}

            {/* Loading dialog shown during API calls */}
            <Dialog fullScreen={false} open={showLoader || isLoading || showMenuLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            {/* successmodal */}
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} alertType={messageType} />
            <OpenDraftExistsDialog
                open={openDraftModal}
                documentType="workOrder"
                draft={openDraftData}
                onClose={handleCloseOpenDraftModal}
                onViewDraft={handleViewOpenDraft}
            />
        </>
    );
};

export default NewWorkOrderV4;
